angular.module('app').controller('mainController', function ($scope, $rootScope, $routeParams, $location, $window, $interval, safeApply, systemService, $sce, $http, allowedFileTypesConfig) {

	// The portal's modern theme (sass/_theme_modern.scss + _portal_modern.scss) is scoped to body.ep-cp
	$window.document.body.classList.add('ep-cp')
	$scope.$on('$destroy', function () {
		$window.document.body.classList.remove('ep-cp')
	})

	$scope.uploadedFiles = []

	// Uploaded Files filter (by content type)
	$scope.uploadedFileTypeOptions = []
	$scope.uploadedFileTypeFilter = {}
	$scope.visibleUploadedFiles = []
	$scope.groupedUploadedFiles = { photos: [], documents: [] }
	$scope.uploadedGroupsCollapsed = { photos: false, documents: false }
	$scope.uploadedFilesTab = 'photos'

	const UPLOADED_HIGHLIGHT_MS = 1 * 60 * 1000
	const REVIEW_PORTAL_CHANGE_STORAGE_KEY = 'ep.review.portal.change'
	const REVIEW_PORTAL_CHANGE_BROADCAST = 'ep-review-portal-change'
	const PORTAL_OPEN_EDIT_INTENT_STORAGE_KEY = 'ep.portal.open.edit.intent'
	let reviewPortalBroadcast = null

	// Mobile splitter between Upload Evidence and Uploaded Files
	$scope.isMobile = false
	function initMobilePanelsSplitter() {
		try {
			if ($window && $window.matchMedia) {
				let was = $scope.isMobile
				$scope.isMobile = $window.matchMedia('(max-width: 900px)').matches
				if (was !== $scope.isMobile) safeApply($scope)
			}

			if (!$window || typeof document === 'undefined') return
			if (!$window.matchMedia || !$window.matchMedia('(max-width: 900px)').matches) return

			let panels = document.querySelector('.ep-panels')
			let handle = document.getElementById('epMobilePanelsSplitterHandle')
			if (!panels || !handle) return
			if (handle && handle.getAttribute('data-ep-split-init') === '1') return
			try { handle.setAttribute('data-ep-split-init', '1') } catch (e) { }

			let dragging = false
			let splitterH = 26
			let MIN_TOP = 100
			let MIN_BOTTOM = 65

			function clampSplit(topPx) {
				let rect = panels.getBoundingClientRect()
				let maxTop = Math.max(MIN_TOP, rect.height - splitterH - MIN_BOTTOM)
				if (topPx < MIN_TOP) topPx = MIN_TOP
				if (topPx > maxTop) topPx = maxTop
				return topPx
			}

			function applyAtClientY(clientY) {
				let rect = panels.getBoundingClientRect()
				let y = clientY - rect.top
				let topPx = clampSplit(Math.round(y - splitterH / 2))
				panels.style.setProperty('--ep-upload-h', topPx + 'px')
			}

			function onDown(e) {
				try {
					dragging = true
					if (e && typeof e.preventDefault === 'function') e.preventDefault()
					if (e && typeof e.stopPropagation === 'function') e.stopPropagation()
					let y = (e && e.touches && e.touches[0]) ? e.touches[0].clientY : (e && e.clientY)
					if (typeof y === 'number') applyAtClientY(y)
				} catch (err) { }
			}

			function onMove(e) {
				try {
					if (!dragging) return
					if (e && typeof e.preventDefault === 'function') e.preventDefault()
					let y = (e && e.touches && e.touches[0]) ? e.touches[0].clientY : (e && e.clientY)
					if (typeof y === 'number') applyAtClientY(y)
				} catch (err) { }
			}

			function onUp() {
				dragging = false
			}

			handle.addEventListener('pointerdown', onDown)
			$window.addEventListener('pointermove', onMove, { passive: false })
			$window.addEventListener('pointerup', onUp)
			$window.addEventListener('pointercancel', onUp)
			// Touch fallback (older iOS)
			handle.addEventListener('touchstart', onDown, { passive: false })
			$window.addEventListener('touchmove', onMove, { passive: false })
			$window.addEventListener('touchend', onUp)
			$window.addEventListener('touchcancel', onUp)

			$scope.$on('$destroy', function () {
				try {
					handle.removeEventListener('pointerdown', onDown)
					$window.removeEventListener('pointermove', onMove)
					$window.removeEventListener('pointerup', onUp)
					$window.removeEventListener('pointercancel', onUp)
					handle.removeEventListener('touchstart', onDown)
					$window.removeEventListener('touchmove', onMove)
					$window.removeEventListener('touchend', onUp)
					$window.removeEventListener('touchcancel', onUp)
				} catch (e) { }
			})
		} catch (e) { }
	}

	try {
		if ($window) {
			$window.setTimeout(initMobilePanelsSplitter, 0)
			let _epOnResizeInitSplitter = function () {
				try { $window.setTimeout(initMobilePanelsSplitter, 0) } catch (e) { }
			}
			$window.addEventListener('resize', _epOnResizeInitSplitter)
			$scope.$on('$destroy', function () {
				try { $window.removeEventListener('resize', _epOnResizeInitSplitter) } catch (e) { }
			})
		}
	} catch (e) { }

	// Force even small images up to 360px wide, set UPSCALE to true.
	const UPLOAD_IMAGE_TARGET_WIDTH_PX = 360
	const UPLOAD_IMAGE_RESIZE_UPSCALE = true

	function getUploadedTabForFile(file) {
		return (file && file.selectedType === 'PHOTO') ? 'photos' : 'documents'
	}

	function markUploadedFileJustAdded(file) {
		try {
			if (!file) return
			file._epAddedAtMs = Date.now()
			file.addedAt = new Date()
			$scope.setUploadedFilesTab(getUploadedTabForFile(file))
		} catch (e) { }
	}

	function clearUploadedFileJustAdded(file) {
		try {
			if (!file) return
			delete file._epAddedAtMs
		} catch (e) { }
	}

	function resizeCanvasToWidth(canvas, targetWidthPx, upscale) {
		try {
			if (!canvas) return canvas
			let w = canvas.width
			let h = canvas.height
			if (!w || !h) return canvas
			let targetW = Number(targetWidthPx)
			if (!targetW || targetW <= 0) return canvas
			if (!upscale && w <= targetW) return canvas

			let scale = targetW / w
			let targetH = Math.max(1, Math.round(h * scale))

			let out = document.createElement('canvas')
			out.width = targetW
			out.height = targetH
			let ctx = out.getContext('2d')
			if (!ctx) return canvas

			ctx.imageSmoothingEnabled = true
			try { ctx.imageSmoothingQuality = 'high' } catch (e) { }
			ctx.fillStyle = '#ffffff'
			ctx.fillRect(0, 0, targetW, targetH)
			ctx.drawImage(canvas, 0, 0, targetW, targetH)
			return out
		} catch (e) {
			return canvas
		}
	}

	$scope.setUploadedFilesTab = function (key) {
		if (key !== 'photos' && key !== 'documents') return
		$scope.uploadedFilesTab = key
	}

	$scope.getUploadedJustAddedStyle = function (file) {
		try {
			let t = file && typeof file._epAddedAtMs === 'number' ? file._epAddedAtMs : 0
			if (!t) return null
			let elapsed = Date.now() - t
			if (elapsed < 0) elapsed = 0
			if (elapsed >= UPLOADED_HIGHLIGHT_MS) return null

			let remainingRatio = 1 - (elapsed / UPLOADED_HIGHLIGHT_MS)
			if (remainingRatio < 0) remainingRatio = 0
			if (remainingRatio > 1) remainingRatio = 1

			let bgA = 0.18 * remainingRatio
			let borderA = 0.30 * remainingRatio

			return {
				background: `rgba(34, 197, 94, ${bgA.toFixed(4)})`,
				borderColor: `rgba(34, 197, 94, ${borderA.toFixed(4)})`
			}
		} catch (e) {
			return null
		}
	}

	$scope.isUploadedJustAdded = function (file) {
		try {
			let t = file && typeof file._epAddedAtMs === 'number' ? file._epAddedAtMs : 0
			if (!t) return false
			let elapsed = Date.now() - t
			return elapsed >= 0 && elapsed < UPLOADED_HIGHLIGHT_MS
		} catch (e) {
			return false
		}
	}

	$scope.getUploadedJustAddedBarStyle = function (file) {
		try {
			let t = file && typeof file._epAddedAtMs === 'number' ? file._epAddedAtMs : 0
			if (!t) return { width: '0%' }
			let elapsed = Date.now() - t
			if (elapsed < 0) elapsed = 0
			if (elapsed >= UPLOADED_HIGHLIGHT_MS) return { width: '0%' }
			let remainingRatio = 1 - (elapsed / UPLOADED_HIGHLIGHT_MS)
			if (remainingRatio < 0) remainingRatio = 0
			if (remainingRatio > 1) remainingRatio = 1
			return { width: (remainingRatio * 100).toFixed(2) + '%' }
		} catch (e) {
			return { width: '0%' }
		}
	}

	// Tick to fade out the highlight without user interaction.
	try {
		if ($interval) {
			let highlightTimer = $interval(function () {
				try {
					let files = Array.isArray($scope.uploadedFiles) ? $scope.uploadedFiles : []
					let now = Date.now()
					for (let i = 0; i < files.length; i++) {
						let f = files[i]
						if (!f || typeof f._epAddedAtMs !== 'number') continue
						if ((now - f._epAddedAtMs) >= UPLOADED_HIGHLIGHT_MS) {
							delete f._epAddedAtMs
						}
					}
					safeApply($scope)
				} catch (e) { }
			}, 5000)
			$scope.$on('$destroy', function () {
				try { $interval.cancel(highlightTimer) } catch (e) { }
			})
		}
	} catch (e) { }

	$scope.toggleUploadedGroup = function (key) {
		if (!key) return
		if (!$scope.uploadedGroupsCollapsed) $scope.uploadedGroupsCollapsed = { photos: false, documents: false }
		$scope.uploadedGroupsCollapsed[key] = !$scope.uploadedGroupsCollapsed[key]
	}

	$scope.isUploadedGroupCollapsed = function (key) {
		try {
			return !!($scope.uploadedGroupsCollapsed && $scope.uploadedGroupsCollapsed[key])
		} catch (e) {
			return false
		}
	}

	$scope.initializing = true
	$scope.creatingPdf = false
	$scope.previewingReport = false
	$scope.portalMessages = []
	$scope.portalMessageUnread = 0
	$scope.portalMessageUnreadMessages = 0
	$scope.portalMessageUnreadReplies = 0
	$scope.currentYear = (new Date()).getFullYear()
	const params = $routeParams
	let pendingPortalEditIntent = null
	let pendingPortalEditAttempted = false

	try {
		if (!pendingPortalEditIntent && $window && $window.localStorage) {
			let rawIntent = $window.localStorage.getItem(PORTAL_OPEN_EDIT_INTENT_STORAGE_KEY)
			if (rawIntent) {
				let parsedIntent = JSON.parse(rawIntent)
				let currentOrigin = ($window.location && $window.location.origin)
					? String($window.location.origin)
					: `${$window.location.protocol}//${$window.location.host}`
				let sameUser = parsedIntent && parsedIntent.user_id != null && String(parsedIntent.user_id) === String(params.user_id || '')
				let sameProp = parsedIntent && parsedIntent.prop_id != null && String(parsedIntent.prop_id) === String(params.prop_id || '')
				let sameOrigin = !parsedIntent || !parsedIntent.target_origin || String(parsedIntent.target_origin) === currentOrigin
				let freshEnough = parsedIntent && parsedIntent.emitted_at != null && (Date.now() - Number(parsedIntent.emitted_at)) < (5 * 60 * 1000)
				if (sameUser && sameProp && sameOrigin && freshEnough) {
					pendingPortalEditIntent = {
						file_id: parsedIntent.file_id != null && String(parsedIntent.file_id).trim() ? String(parsedIntent.file_id).trim() : '',
						gcs_path: parsedIntent.gcs_path != null && String(parsedIntent.gcs_path).trim() ? String(parsedIntent.gcs_path).trim() : '',
						original_name: parsedIntent.original_name != null && String(parsedIntent.original_name).trim() ? String(parsedIntent.original_name).trim() : '',
						size_bytes: parsedIntent.size_bytes != null && String(parsedIntent.size_bytes).trim() ? String(parsedIntent.size_bytes).trim() : ''
					}
				} else if (!sameOrigin) {
					try { $window.localStorage.removeItem(PORTAL_OPEN_EDIT_INTENT_STORAGE_KEY) } catch (e) { }
				}
			}
		}
	} catch (e) { }

	function clearPendingPortalEditIntent() {
		pendingPortalEditIntent = null
		pendingPortalEditAttempted = true
		try {
			if ($window && $window.localStorage) {
				$window.localStorage.removeItem(PORTAL_OPEN_EDIT_INTENT_STORAGE_KEY)
			}
		} catch (e) { }
	}

	function maybeOpenPendingPortalEditFile() {
		try {
			if (!pendingPortalEditIntent || pendingPortalEditAttempted) return
			if (isEditingActive()) return
			if (!Array.isArray($scope.uploadedFiles) || !$scope.uploadedFiles.length) {
				clearPendingPortalEditIntent()
				return
			}

			let targetId = pendingPortalEditIntent.file_id ? String(pendingPortalEditIntent.file_id) : ''
			let targetPath = pendingPortalEditIntent.gcs_path ? String(pendingPortalEditIntent.gcs_path) : ''
			let targetName = pendingPortalEditIntent.original_name ? String(pendingPortalEditIntent.original_name) : ''
			let targetSize = pendingPortalEditIntent.size_bytes ? String(pendingPortalEditIntent.size_bytes) : ''

			let target = $scope.uploadedFiles.find(function (file) {
				if (!file) return false
				if (targetId) {
					if (file.id != null && String(file.id) === targetId) return true
					if (file.server_id != null && String(file.server_id) === targetId) return true
				}
				if (targetPath && file.gcs_path != null && String(file.gcs_path) === targetPath) return true
				if (targetName && file.name != null && String(file.name) === targetName) {
					if (!targetSize) return true
					return file.size != null && String(file.size) === targetSize
				}
				return false
			})

			if (!target) {
				clearPendingPortalEditIntent()
				return
			}

			clearPendingPortalEditIntent()
			$window.setTimeout(function () {
				try { startEditFile(target) } catch (e) { }
			}, 0)
		} catch (e) {
			clearPendingPortalEditIntent()
		}
	}

	function computePortalMessageUnreadBreakdown(messages) {
		try {
			if (!Array.isArray(messages) || messages.length === 0) {
				return { unreadMessages: 0, unreadReplies: 0 }
			}

			function isUnread(obj) {
				if (!obj) return false
				if (typeof obj.is_read !== 'undefined') return Number(obj.is_read) === 0
				if (typeof obj.read !== 'undefined') return Number(obj.read) === 0
				if (typeof obj.read_at !== 'undefined') return !obj.read_at
				return false
			}

			let unreadMessages = 0
			let unreadReplies = 0
			for (let i = 0; i < messages.length; i++) {
				const m = messages[i]
				if (!m) continue
				if (String(m.sender_type || '').toLowerCase() === 'employee' && isUnread(m)) unreadMessages++

				let replies = Array.isArray(m.replies) ? m.replies : []
				for (let j = 0; j < replies.length; j++) {
					let r = replies[j]
					if (!r) continue
					if (String(r.sender_type || '').toLowerCase() !== 'employee') continue
					if (isUnread(r)) unreadReplies++
				}
			}

			return { unreadMessages, unreadReplies }
		} catch (e) {
			return { unreadMessages: 0, unreadReplies: 0 }
		}
	}

	function canMarkPortalItemRead(obj) {
		try {
			if (!obj) return false
			if (String(obj.sender_type || '').toLowerCase() !== 'employee') return false
			return isPortalMessageUnread(obj)
		} catch (e) {
			return false
		}
	}
	$scope.canMarkPortalItemRead = canMarkPortalItemRead

	function computePortalMessageUnread(messages) {
		try {
			let breakdown = computePortalMessageUnreadBreakdown(messages)
			return (breakdown.unreadMessages || 0) + (breakdown.unreadReplies || 0)
		} catch (e) {
			return 0
		}
	}

	function getActiveParams() {
		return {
			user_id: params.user_id,
			user_token: params.user_token,
			prop_id: ($scope.activeProp && $scope.activeProp.prop_id) ? $scope.activeProp.prop_id : params.prop_id,
			tax_year: ($scope.activeProp && $scope.activeProp.tax_year != null)
				? $scope.activeProp.tax_year
				: params.tax_year
		}
	}

	function notifyReviewToolPortalChanged(action, extra) {
		try {
			let p = getActiveParams()
			if (!p || p.user_id == null || p.prop_id == null) return

			let payload = Object.assign({}, extra || {}, {
				action: action ? String(action) : 'portal-change',
				user_id: String(p.user_id),
				prop_id: String(p.prop_id),
				tax_year: (extra && extra.tax_year != null)
					? String(extra.tax_year)
					: (($scope.activeProp && $scope.activeProp.tax_year != null)
						? String($scope.activeProp.tax_year)
						: (params && params.tax_year != null ? String(params.tax_year) : '')),
				emitted_at: Date.now()
			})

			if ($window && $window.localStorage) {
				$window.localStorage.setItem(REVIEW_PORTAL_CHANGE_STORAGE_KEY, JSON.stringify(payload))
			}

			if (!reviewPortalBroadcast && $window && typeof $window.BroadcastChannel === 'function') {
				reviewPortalBroadcast = new $window.BroadcastChannel(REVIEW_PORTAL_CHANGE_BROADCAST)
			}

			if (reviewPortalBroadcast && typeof reviewPortalBroadcast.postMessage === 'function') {
				reviewPortalBroadcast.postMessage(payload)
			}
		} catch (e) { }
	}

	function setTypeLabel(file) {
		try {
			if (!file) return
			let cfg = (file.selectedType && $scope.allowedFileTypes)
				? $scope.allowedFileTypes[file.selectedType]
				: null
			file.typeLabel = (cfg && (cfg.cardLabel || cfg.label)) ? String(cfg.cardLabel || cfg.label) : ''
			// The full name, as in the upload picker ("Invoice of Repair Costs") - the heading of a document's card
			file.typeTitle = (cfg && (cfg.pickerLabel || cfg.label)) ? String(cfg.pickerLabel || cfg.label) : file.typeLabel
		} catch (e) {
			try { if (file) file.typeLabel = file.typeTitle = '' } catch (e2) { }
		}
	}

	function getUploadedTypeKey(file) {
		let key = file && file.selectedType ? String(file.selectedType) : ''
		key = key.trim()
		return key ? key : '__other__'
	}

	function getUploadedTypeLabelForKey(key) {
		if (!key || key === '__other__') return 'Other'
		try {
			let cfg = ($scope.allowedFileTypes && $scope.allowedFileTypes[key]) ? $scope.allowedFileTypes[key] : null
			if (cfg && (cfg.cardLabel || cfg.label)) return String(cfg.cardLabel || cfg.label)
		} catch (e) { }
		return key
	}

	function rebuildUploadedTypeOptions() {
		try {
			let files = Array.isArray($scope.uploadedFiles) ? $scope.uploadedFiles : []
			let counts = {}
			for (let i = 0; i < files.length; i++) {
				let k = getUploadedTypeKey(files[i])
				counts[k] = (counts[k] || 0) + 1
			}

			// Drop filter keys that no longer exist.
			try {
				Object.keys($scope.uploadedFileTypeFilter || {}).forEach(function (k) {
					if (!counts[k]) delete $scope.uploadedFileTypeFilter[k]
				})
			} catch (e) { }

			let opts = Object.keys(counts).map(function (k) {
				// Default new types to checked.
				if ($scope.uploadedFileTypeFilter[k] === undefined) $scope.uploadedFileTypeFilter[k] = true
				return {
					key: k,
					label: getUploadedTypeLabelForKey(k),
					count: counts[k]
				}
			})

			opts.sort(function (a, b) {
				let la = String(a.label || '').toLowerCase()
				let lb = String(b.label || '').toLowerCase()
				if (la < lb) return -1
				if (la > lb) return 1
				return 0
			})
			$scope.uploadedFileTypeOptions = opts
			applyUploadedTypeFilter()
		} catch (e) {
			$scope.uploadedFileTypeOptions = []
			$scope.visibleUploadedFiles = Array.isArray($scope.uploadedFiles) ? $scope.uploadedFiles : []
			rebuildGroupedUploadedFiles()
		}
	}

	function rebuildGroupedUploadedFiles() {
		try {
			let files = Array.isArray($scope.visibleUploadedFiles) ? $scope.visibleUploadedFiles : []
			let photos = []
			let documents = []
			for (let i = 0; i < files.length; i++) {
				let f = files[i]
				if (f && f.selectedType === 'PHOTO') photos.push(f)
				else documents.push(f)
			}
			$scope.groupedUploadedFiles = { photos: photos, documents: documents }
			normalizeUploadedFilesTab()
		} catch (e) {
			$scope.groupedUploadedFiles = { photos: [], documents: [] }
			normalizeUploadedFilesTab()
		}
		pruneUploadedSelection()
	}

	function normalizeUploadedFilesTab() {
		try {
			let g = ($scope.groupedUploadedFiles && typeof $scope.groupedUploadedFiles === 'object')
				? $scope.groupedUploadedFiles
				: { photos: [], documents: [] }
			let hasPhotos = Array.isArray(g.photos) && g.photos.length > 0
			let hasDocs = Array.isArray(g.documents) && g.documents.length > 0
			let tab = $scope.uploadedFilesTab

			if (tab !== 'photos' && tab !== 'documents') {
				tab = hasPhotos ? 'photos' : (hasDocs ? 'documents' : 'photos')
			}

			if (tab === 'photos' && !hasPhotos && hasDocs) tab = 'documents'
			if (tab === 'documents' && !hasDocs && hasPhotos) tab = 'photos'

			$scope.uploadedFilesTab = tab
		} catch (e) {
			$scope.uploadedFilesTab = 'photos'
		}
	}

	function applyUploadedTypeFilter() {
		let files = Array.isArray($scope.uploadedFiles) ? $scope.uploadedFiles : []
		let filter = $scope.uploadedFileTypeFilter || {}
		$scope.visibleUploadedFiles = files.filter(function (f) {
			let k = getUploadedTypeKey(f)
			// default to visible if key not present
			return filter[k] !== false
		})
		rebuildGroupedUploadedFiles()
	}

	$scope.applyUploadedTypeFilter = function () {
		applyUploadedTypeFilter()
	}

	$scope.setAllUploadedTypes = function (checked) {
		try {
			let opts = Array.isArray($scope.uploadedFileTypeOptions) ? $scope.uploadedFileTypeOptions : []
			for (let i = 0; i < opts.length; i++) {
				$scope.uploadedFileTypeFilter[opts[i].key] = !!checked
			}
		} catch (e) { }
		applyUploadedTypeFilter()
	}

	$scope.getUploadedFilesCountLabel = function () {
		let total = Array.isArray($scope.uploadedFiles) ? $scope.uploadedFiles.length : 0
		let visible = Array.isArray($scope.visibleUploadedFiles) ? $scope.visibleUploadedFiles.length : 0
		if (total === visible) return `${total} file(s)`
		return `${visible} of ${total} file(s)`
	}

	$scope.getUploadedHiddenCount = function () {
		try {
			let total = Array.isArray($scope.uploadedFiles) ? $scope.uploadedFiles.length : 0
			let visible = Array.isArray($scope.visibleUploadedFiles) ? $scope.visibleUploadedFiles.length : 0
			let hidden = total - visible
			return hidden > 0 ? hidden : 0
		} catch (e) {
			return 0
		}
	}

	function getPortalExitPropertyLabel() {
		try {
			if ($scope.activeProp && $scope.activeProp.address) return String($scope.activeProp.address)
			let p = getActiveParams()
			if (p && p.prop_id) return `Property ${p.prop_id}`
		} catch (e) { }
		return 'Current property'
	}

	function buildPortalExitSummary() {
		try {
			let files = Array.isArray($scope.uploadedFiles) ? $scope.uploadedFiles : []
			let totalSize = 0
			let totalPhotos = 0
			let totalDocuments = 0
			let groupsByKey = {}

			for (let i = 0; i < files.length; i++) {
				let file = files[i]
				if (!file) continue

				let fileSize = Number(file.size) || 0
				totalSize += fileSize

				if (getUploadedTabForFile(file) === 'photos') totalPhotos += 1
				else totalDocuments += 1

				let groupKey = file.selectedType ? String(file.selectedType) : '__UNSPECIFIED__'
				if (!groupsByKey[groupKey]) {
					groupsByKey[groupKey] = {
						key: groupKey,
						label: file.typeLabel || 'Other Evidence',
						count: 0,
						sizeBytes: 0,
						items: []
					}
				}

				let group = groupsByKey[groupKey]
				group.count += 1
				group.sizeBytes += fileSize
				group.items.push({
					id: file.id || `${groupKey}-${i}`,
					name: file.name || 'Unnamed file',
					sizeLabel: file.sizeLabel || formatBytes(fileSize),
					metaLabel: $scope.getPhotoLocationLabel(file) || ''
				})
			}

			let groups = Object.keys(groupsByKey).map(function (key) {
				let group = groupsByKey[key]
				group.sizeLabel = formatBytes(group.sizeBytes)
				return group
			}).sort(function (a, b) {
				return String(a.label || '').localeCompare(String(b.label || ''))
			})

			return {
				propertyLabel: getPortalExitPropertyLabel(),
				totalFiles: files.length,
				totalPhotos: totalPhotos,
				totalDocuments: totalDocuments,
				totalSizeLabel: formatBytes(totalSize),
				groups: groups
			}
		} catch (e) {
			return {
				propertyLabel: getPortalExitPropertyLabel(),
				totalFiles: 0,
				totalPhotos: 0,
				totalDocuments: 0,
				totalSizeLabel: '0 Bytes',
				groups: []
			}
		}
	}

	function getPortalExitSummaryModal() {
		try {
			let el = document.getElementById('epPortalExitSummaryModal')
			if (!el) return null
			if (!_portalExitSummaryModal && $window.bootstrap && $window.bootstrap.Modal) {
				_portalExitSummaryModal = $window.bootstrap.Modal.getOrCreateInstance(el)
			}
			if (!_portalExitSummaryModalBound) {
				_portalExitSummaryModalBound = true
				el.addEventListener('hidden.bs.modal', function () {
					$scope.portalExitSummary.intent = null
					safeApply($scope)
				})
			}
			return _portalExitSummaryModal
		} catch (e) {
			return null
		}
	}

	function showPortalExitSummary(intent) {
		try {
			let summary = buildPortalExitSummary()
			$scope.portalExitSummary = {
				intent: intent || 'dashboard',
				propertyLabel: summary.propertyLabel,
				totalFiles: summary.totalFiles,
				totalPhotos: summary.totalPhotos,
				totalDocuments: summary.totalDocuments,
				totalSizeLabel: summary.totalSizeLabel,
				groups: summary.groups,
				queuedCount: Array.isArray($scope.uploadQueue) ? $scope.uploadQueue.length : 0
			}
			safeApply($scope)
			let modal = getPortalExitSummaryModal()
			if (modal) modal.show()
		} catch (e) { }
	}

	$scope.closePortalExitSummary = function () {
		try {
			let modal = getPortalExitSummaryModal()
			if (modal) modal.hide()
		} catch (e) { }
	}

	$scope.getPortalExitContinueLabel = function () {
		return $scope.portalExitSummary && $scope.portalExitSummary.intent === 'tab-close'
			? 'Continue and Close Tab'
			: 'Continue to Dashboard'
	}

	$scope.continuePortalExit = function () {
		let intent = $scope.portalExitSummary ? $scope.portalExitSummary.intent : null
		$scope.closePortalExitSummary()

		if (intent === 'tab-close') {
			_allowPortalExitBeforeUnload = true
			$window.setTimeout(function () {
				try { $window.open('', '_self') } catch (e) { }
				try { $window.close() } catch (e) { }
				$window.setTimeout(function () {
					try {
						if (!$window.closed) {
							_allowPortalExitBeforeUnload = false
							$window.alert('Your browser blocked automatic tab closing. You can close this tab now.')
						}
					} catch (e) {
						_allowPortalExitBeforeUnload = false
					}
				}, 150)
			}, 0)
			return
		}

		_allowPortalExitBeforeUnload = true
		doRouteTo('dashboard')
	}

	function bindPortalExitBeforeUnload() {
		if (_portalExitBeforeUnloadHandler || !$window) return
		_portalExitBeforeUnloadHandler = function (event) {
			try {
				if (_allowPortalExitBeforeUnload) return undefined
				if (_portalExitTabCloseTimer) {
					try { $window.clearTimeout(_portalExitTabCloseTimer) } catch (e) { }
					_portalExitTabCloseTimer = null
				}
				_portalExitTabCloseTimer = $window.setTimeout(function () {
					_portalExitTabCloseTimer = null
					try {
						if (_allowPortalExitBeforeUnload) return
						showPortalExitSummary('tab-close')
					} catch (e) { }
				}, 0)
				if (event) {
					event.preventDefault()
					event.returnValue = ''
				}
				return ''
			} catch (e) {
				return undefined
			}
		}
		try { $window.addEventListener('beforeunload', _portalExitBeforeUnloadHandler) } catch (e) { }
	}

	$scope.getPhotoLocationLabel = function (file) {
		try {
			if (!file || file.selectedType !== 'PHOTO') return ''
			let meta = (file.meta && typeof file.meta === 'object') ? file.meta : {}
			let val = meta.photo_location
			if (!val) return ''
			val = String(val).trim()
			if (!val) return ''

			if (val === 'interior_other' || val === 'exterior_other') {
				let other = meta.photo_location_other
				other = (other === null || other === undefined) ? '' : String(other)
				other = other.trim()
				return other ? other : 'Other'
			}

			let cfg = ($scope.allowedFileTypes && $scope.allowedFileTypes.PHOTO) ? $scope.allowedFileTypes.PHOTO : null
			if (cfg && Array.isArray(cfg.fields)) {
				let field = cfg.fields.find(f => f && f.key === 'photo_location')
				if (field && Array.isArray(field.options)) {
					let opt = field.options.find(o => o && o.value === val)
					if (opt && opt.label) return String(opt.label)
				}
			}
			return val
		} catch (e) {
			return ''
		}
	}

	$scope.getPhotoLocationCount = function () {
		try {
			let photos = ($scope.groupedUploadedFiles && Array.isArray($scope.groupedUploadedFiles.photos))
				? $scope.groupedUploadedFiles.photos
				: []
			if (!photos.length) return 0

			let locations = new Set()
			for (let i = 0; i < photos.length; i++) {
				// (Fill in Later is not an area)
				if (photos[i] && photos[i].meta && photos[i].meta.photo_location === 'fill_in_later') continue
				let label = $scope.getPhotoLocationLabel(photos[i])
				if (label) {
					locations.add(label)
				}
			}
			return locations.size
		} catch (e) {
			return 0
		}
	}

	$scope.hasFileNotesOrLocation = function (file) {
		try {
			return !!($scope.getFileNotes && $scope.getFileNotes(file)) || !!$scope.getPhotoLocationLabel(file)
		} catch (e) {
			return false
		}
	}

	$scope.isUploadedTypeFilterApplied = function () {
		try {
			return $scope.getUploadedHiddenCount() > 0
		} catch (e) {
			return false
		}
	}

	// Keep filter dropdown + visible list in sync as uploadedFiles change.
	$scope.$watchCollection('uploadedFiles', function () {
		rebuildUploadedTypeOptions()
	})

	$scope.closeUploadedTypeFilterDropdown = function () {
		try {
			if (!$window || !$window.bootstrap || !$window.bootstrap.Dropdown) return
			let toggleEl = document.getElementById('epUploadedFilesFilterToggle')
			if (!toggleEl) return
			let dd = $window.bootstrap.Dropdown.getOrCreateInstance(toggleEl)
			if (dd) dd.hide()
		} catch (e) { }
	}

	// Pending upload (left panel: questions shown here before Save)
	$scope.pendingFile = null
	$scope.pendingMessage = null

	$scope.dragging = false
	$scope.uiMessage = null

	// Preview modal state
	$scope.previewingFile = null
	$scope.previewTrustedUrl = null
	let _previewModal = null
	let _previewModalBound = false

	// Remove confirmation modal state
	$scope.removeCandidate = null
	$scope.removeTrustedUrl = null
	$scope.removeMetaRows = []
	$scope.removeDeleting = false
	$scope.removeDeleteError = null
	let _removeModal = null
	let _removeModalBound = false

	// Pending (Upload evidence) remove confirmation modal state
	$scope.pendingRemoveCandidate = null
	$scope.pendingRemoveTrustedUrl = null
	$scope.pendingRemoveMetaRows = []
	let _pendingRemoveModal = null
	let _pendingRemoveModalBound = false

	// Photo wizard "Remove all photos" confirmation modal state
	$scope.removeAllWizard = { columns: [], rows: [], count: 0 }
	let _removeAllWizardModal = null

	// Edit lock modal state (block actions while editing an existing file)
	$scope.editLockReason = null
	$scope.editLockSaving = false
	$scope.editLockError = null
	let _editLockModal = null
	let _editLockModalBound = false
	let _editLockNextAction = null

	// Exit summary modal state
	$scope.portalExitSummary = {
		intent: null,
		propertyLabel: '',
		totalFiles: 0,
		totalPhotos: 0,
		totalDocuments: 0,
		totalSizeLabel: '0 Bytes',
		groups: []
	}
	let _portalExitSummaryModal = null
	let _portalExitSummaryModalBound = false
	let _portalExitBeforeUnloadHandler = null
	let _portalExitTabCloseTimer = null
	let _allowPortalExitBeforeUnload = false

	// File types modal state
	let _fileTypesModal = null
	let _fileTypesModalBound = false

	// Message center modal state
	$scope.messageCenter = {
		view: 'list',
		selected: null,
		loading: false,
		error: null,
		replying: false,
		sendingReply: false,
		replyError: null,
		expandedBodies: {},
		threadHasScrollbar: false,
		threadStickyReplyVisible: false
	}

	function messageCenterBodyKey(item, kind) {
		try {
			if (!item) return null
			let id = item.message_id || item.id
			id = id != null ? String(id) : ''
			if (!id) return null
			return String(kind || 'item') + ':' + id
		} catch (e) {
			return null
		}
	}

	function stripHtmlToText(html) {
		try {
			let s = String(html || '')
			// Remove tags
			s = s.replace(/<[^>]*>/g, ' ')
			// Decode a couple common entities
			s = s.replace(/&nbsp;/gi, ' ')
			s = s.replace(/&amp;/gi, '&')
			s = s.replace(/&lt;/gi, '<')
			s = s.replace(/&gt;/gi, '>')
			s = s.replace(/&quot;/gi, '"')
			s = s.replace(/&#39;/gi, "'")
			// Collapse whitespace
			s = s.replace(/\s+/g, ' ').trim()
			return s
		} catch (e) {
			return ''
		}
	}

	function messageCenterLooksLong(html) {
		try {
			let raw = String(html || '')
			if (!raw) return false

			// Heuristic: multiple paragraphs/line breaks often exceed 2 lines.
			let breaks = (raw.match(/<br\s*\/?\s*>|<\s*\/\s*p\s*>/gi) || []).length
			if (breaks >= 2) return true

			let text = stripHtmlToText(raw)
			return text.length > 160
		} catch (e) {
			return false
		}
	}

	$scope.messageCenterIsBodyExpanded = function (item, kind) {
		try {
			let key = messageCenterBodyKey(item, kind)
			if (!key) return false
			let map = ($scope.messageCenter && $scope.messageCenter.expandedBodies) ? $scope.messageCenter.expandedBodies : {}
			return !!map[key]
		} catch (e) {
			return false
		}
	}

	$scope.messageCenterShouldShowBodyToggle = function (item) {
		try {
			if (!item) return false
			return messageCenterLooksLong(item.message_text)
		} catch (e) {
			return false
		}
	}

	$scope.messageCenterToggleBodyExpanded = function (item, kind) {
		try {
			let key = messageCenterBodyKey(item, kind)
			if (!key) return
			if (!$scope.messageCenter.expandedBodies) $scope.messageCenter.expandedBodies = {}
			let next = !$scope.messageCenter.expandedBodies[key]
			$scope.messageCenter.expandedBodies[key] = next
			safeApply($scope)
		} catch (e) { }
	}

	$scope.messageCenterThreadSortValue = function (m) {
		try {
			if (!m) return 0
			return $scope.portalDate(m.latest_activity || m.updated_at || m.created_at) || 0
		} catch (e) {
			return 0
		}
	}

	$scope.messageCenterReplySortValue = function (r) {
		try {
			if (!r) return 0
			return $scope.portalDate(r.created_at) || 0
		} catch (e) {
			return 0
		}
	}

	// Normalize incoming timestamps so Angular's date filter formats consistently.
	// Supports Date objects, epoch millis, ISO strings, and MySQL-style datetime strings.
	$scope.portalDate = function (value) {
		try {
			if (!value) return null
			if (value instanceof Date) return value
			if (typeof value === 'number') {
				let d = new Date(value)
				return isNaN(d.getTime()) ? null : d
			}
			if (typeof value !== 'string') return null

			let s = String(value).trim()
			if (!s) return null

			// MySQL: "YYYY-MM-DD HH:mm:ss" (optionally with .microseconds)
			if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(s)) {
				let normalized = s.replace(' ', 'T')
				normalized = normalized.replace(/\.\d+$/, '')
				let d = new Date(normalized)
				return isNaN(d.getTime()) ? null : d
			}

			// ISO-like string
			let d = new Date(s)
			return isNaN(d.getTime()) ? null : d
		} catch (e) {
			return null
		}
	}

	// Human-readable relative time for Message Center timestamps.
	// Examples: "1 day ago" or "72 hours ago" depending on age.
	$scope.messageCenterRelativeAgeLabel = function (value) {
		try {
			let d = $scope.portalDate(value)
			if (!d) return ''
			let ms = Date.now() - d.getTime()
			if (!isFinite(ms)) return ''
			if (ms < 0) ms = 0

			let minutes = Math.floor(ms / (60 * 1000))
			let hours = Math.floor(ms / (60 * 60 * 1000))
			let days = Math.floor(ms / (24 * 60 * 60 * 1000))

			function plural(n, unit) {
				return n === 1 ? unit : unit + 's'
			}

			if (ms < (60 * 60 * 1000)) {
				let m = Math.max(1, minutes)
				return m + ' ' + plural(m, 'minute') + ' ago'
			}
			if (ms < (24 * 60 * 60 * 1000)) {
				let h = Math.max(1, hours)
				return h + ' ' + plural(h, 'hour') + ' ago'
			}

			// Prefer a day-based label around 1-2 days.
			if (ms < (48 * 60 * 60 * 1000)) {
				let dd = Math.max(1, days)
				return dd + ' ' + plural(dd, 'day') + ' ago'
			}

			// Prefer hours for mid-range ages (e.g., 72 hours ago).
			if (ms < (96 * 60 * 60 * 1000)) {
				let hh = Math.max(1, hours)
				return hh + ' ' + plural(hh, 'hour') + ' ago'
			}

			let dd = Math.max(1, days)
			return dd + ' ' + plural(dd, 'day') + ' ago'
		} catch (e) {
			return ''
		}
	}

	function normalizeSenderType(senderType) {
		try {
			return String(senderType || '').trim().toLowerCase()
		} catch (e) {
			return ''
		}
	}

	$scope.portalSenderTypeLabel = function (senderType) {
		let t = normalizeSenderType(senderType)
		if (t === 'employee') return 'Agent'
		if (t === 'client') return 'Property Owner'
		return senderType
	}

	$scope.portalSenderLabel = function (obj) {
		try {
			if (!obj) return 'Unknown'
			if (obj.sender_name) return obj.sender_name
			if (obj.sender_type) return $scope.portalSenderTypeLabel(obj.sender_type)
			return 'Unknown'
		} catch (e) {
			return 'Unknown'
		}
	}
	let _messageCenterModal = null
	let _messageCenterModalBound = false
	let _messageCenterEditorInitToken = 0
	let _messageCenterReplyModal = null
	let _messageCenterReplyModalBound = false
	let _messageCenterThreadResizeBound = false
	let _messageCenterThreadOnResize = null
	let _messageCenterThreadScrollBound = false
	let _messageCenterThreadOnScroll = null
	let _messageCenterThreadScrollEl = null

	// Image editor modal state (Toast UI Image Editor)
	$scope.imageEditorState = { loading: false, applying: false, error: null }
	$scope.imageEditorViewportOk = true
	let _imageEditorModal = null
	let _imageEditorModalBound = false
	let _imageEditorInstance = null
	let _imageEditorSourceObjectUrl = null
	let _imageEditorInitToken = 0
	// The file being edited: the edit form's pendingFile or a file in the upload list
	let _imageEditorTarget = null
	let _imageEditorWindowResizeBound = false
	let _imageEditorOnWindowResize = null
	let _imageEditorViewportResizeBound = false
	let _imageEditorViewportOnResize = null

	const IMAGE_EDIT_MIN_W = 600
	const IMAGE_EDIT_MIN_H = 500

	function computeImageEditorViewportOk() {
		try {
			return Number($window.innerWidth) >= IMAGE_EDIT_MIN_W && Number($window.innerHeight) >= IMAGE_EDIT_MIN_H
		} catch (e) {
			return false
		}
	}

	function updateImageEditorViewportOk() {
		const next = computeImageEditorViewportOk()
		if ($scope.imageEditorViewportOk === next) return
		$scope.imageEditorViewportOk = next
		safeApply($scope)
	}

	function bindImageEditorViewportResize() {
		if (_imageEditorViewportResizeBound) return
		_imageEditorViewportResizeBound = true
		_imageEditorViewportOnResize = function () {
			updateImageEditorViewportOk()
		}
		try { $window.addEventListener('resize', _imageEditorViewportOnResize, { passive: true }) } catch (e) { }
		try { $window.addEventListener('orientationchange', _imageEditorViewportOnResize, { passive: true }) } catch (e) { }
		updateImageEditorViewportOk()
	}

	function unbindImageEditorViewportResize() {
		if (!_imageEditorViewportResizeBound) return
		_imageEditorViewportResizeBound = false
		try {
			if (_imageEditorViewportOnResize) $window.removeEventListener('resize', _imageEditorViewportOnResize)
		} catch (e) { }
		try {
			if (_imageEditorViewportOnResize) $window.removeEventListener('orientationchange', _imageEditorViewportOnResize)
		} catch (e) { }
		_imageEditorViewportOnResize = null
	}

	function getFileTypesModal() {
		try {
			let el = document.getElementById('epFileTypesModal')
			if (!el) return null
			if (!_fileTypesModal && $window.bootstrap && $window.bootstrap.Modal) {
				_fileTypesModal = $window.bootstrap.Modal.getOrCreateInstance(el)
			}
			if (!_fileTypesModalBound) {
				_fileTypesModalBound = true
				el.addEventListener('hidden.bs.modal', function () {
					safeApply($scope)
				})
			}
			return _fileTypesModal
		} catch (e) {
			return null
		}
	}

	function revokeImageEditorSourceUrl() {
		if (!_imageEditorSourceObjectUrl) return
		try { URL.revokeObjectURL(_imageEditorSourceObjectUrl) } catch (e) { }
		_imageEditorSourceObjectUrl = null
	}

	function destroyImageEditorInstance() {
		try {
			if (_imageEditorInstance && typeof _imageEditorInstance.destroy === 'function') {
				_imageEditorInstance.destroy()
			} else if (_imageEditorInstance && typeof _imageEditorInstance.dispose === 'function') {
				_imageEditorInstance.dispose()
			}
		} catch (e) {
			// ignore
		}
		_imageEditorInstance = null
		try {
			let root = document.getElementById('epImageEditorRoot')
			if (root) root.innerHTML = ''
		} catch (e) { }
	}

	function getImageEditorRootRect() {
		try {
			let root = document.getElementById('epImageEditorRoot')
			if (!root || !root.getBoundingClientRect) return null
			return root.getBoundingClientRect()
		} catch (e) {
			return null
		}
	}

	function getToastUiZoomComponent(imageEditorInstance) {
		try {
			if (!imageEditorInstance || !imageEditorInstance._graphics) return null
			let g = imageEditorInstance._graphics
			if (typeof g.getComponent !== 'function') return null
			// Component name differs between builds; try a few safe candidates.
			return g.getComponent('ZOOM') || g.getComponent('zoom') || g.getComponent('Zoom') || null
		} catch (e) {
			return null
		}
	}

	function installToastUiZoomButtonFix(rootEl, imageEditorInstance) {
		try {
			if (!rootEl || !rootEl.querySelector || !imageEditorInstance) return
			let zoomInBtn = rootEl.querySelector('.tie-btn-zoomIn')
			let zoomOutBtn = rootEl.querySelector('.tie-btn-zoomOut')
			if (!zoomInBtn && !zoomOutBtn) return

			let zoomComp = getToastUiZoomComponent(imageEditorInstance)
			let graphics = imageEditorInstance._graphics
			let canvas = (graphics && typeof graphics.getCanvas === 'function') ? graphics.getCanvas() : null
			if (!canvas) return

			function getCanvasCenter() {
				let w = (typeof canvas.getWidth === 'function') ? canvas.getWidth() : canvas.width
				let h = (typeof canvas.getHeight === 'function') ? canvas.getHeight() : canvas.height
				w = Number(w) || 0
				h = Number(h) || 0
				return { x: w / 2, y: h / 2 }
			}

			function enterHandModeIfPossible() {
				try {
					// ToastUI uses drawingMode=ZOOM for both zoom + hand.
					if (typeof imageEditorInstance.startDrawingMode === 'function') {
						imageEditorInstance.startDrawingMode('ZOOM')
					}
				} catch (e) { }
				try {
					if (zoomComp && typeof zoomComp.startHandMode === 'function') {
						zoomComp.startHandMode()
					}
				} catch (e) { }
			}

			function exitHandModeIfPossible() {
				try {
					if (zoomComp && typeof zoomComp.endHandMode === 'function') {
						zoomComp.endHandMode()
					}
				} catch (e) { }
			}

			function stepZoomIn() {
				let c = getCanvasCenter()
				if (zoomComp && typeof zoomComp.zoom === 'function' && typeof zoomComp.zoomLevel === 'number') {
					let next = Math.min(5, zoomComp.zoomLevel + 1)
					zoomComp.zoom({ x: c.x, y: c.y }, next)
					if (next > 1) enterHandModeIfPossible()
					return
				}
				// Fallback: Fabric direct zoom (still better than a dead button)
				let current = (typeof canvas.getZoom === 'function') ? canvas.getZoom() : 1
				let next = Math.min(5, (Number(current) || 1) * 1.25)
				if (typeof canvas.zoomToPoint === 'function') canvas.zoomToPoint({ x: c.x, y: c.y }, next)
				else if (typeof canvas.setZoom === 'function') canvas.setZoom(next)
				if (next > 1) enterHandModeIfPossible()
			}

			function stepZoomOut() {
				if (zoomComp && typeof zoomComp.zoomOut === 'function') {
					zoomComp.zoomOut()
					try {
						if (typeof zoomComp.zoomLevel === 'number' && zoomComp.zoomLevel <= 1) {
							exitHandModeIfPossible()
						}
					} catch (e) { }
					return
				}
				let current = (typeof canvas.getZoom === 'function') ? canvas.getZoom() : 1
				let next = Math.max(1, (Number(current) || 1) / 1.25)
				let c = getCanvasCenter()
				if (typeof canvas.zoomToPoint === 'function') canvas.zoomToPoint({ x: c.x, y: c.y }, next)
				else if (typeof canvas.setZoom === 'function') canvas.setZoom(next)
				if (next <= 1) exitHandModeIfPossible()
			}

			function intercept(handler) {
				return function (e) {
					try {
						if (e && typeof e.preventDefault === 'function') e.preventDefault()
						if (e && typeof e.stopPropagation === 'function') e.stopPropagation()
						if (e && typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation()
					} catch (e2) { }
					try { handler() } catch (e3) { }
				}
			}

			// Use capture so we run before ToastUI's own click handler.
			if (zoomInBtn) zoomInBtn.addEventListener('click', intercept(stepZoomIn), true)
			if (zoomOutBtn) zoomOutBtn.addEventListener('click', intercept(stepZoomOut), true)
		} catch (e) {
			// ignore
		}
	}

	function resizeImageEditorToContainer() {
		try {
			if (!_imageEditorInstance || !_imageEditorInstance.ui) return
			if (typeof _imageEditorInstance.ui.resizeEditor !== 'function') return
			_imageEditorInstance.ui.resizeEditor()
		} catch (e) {
			// ignore
		}
	}

	function bindImageEditorWindowResize() {
		if (_imageEditorWindowResizeBound) return
		_imageEditorWindowResizeBound = true
		_imageEditorOnWindowResize = function () {
			// Defer slightly to allow Bootstrap to finish layout.
			$window.setTimeout(resizeImageEditorToContainer, 40)
		}
		try { $window.addEventListener('resize', _imageEditorOnWindowResize, { passive: true }) } catch (e) { }
	}

	function unbindImageEditorWindowResize() {
		if (!_imageEditorWindowResizeBound) return
		_imageEditorWindowResizeBound = false
		try {
			if (_imageEditorOnWindowResize) $window.removeEventListener('resize', _imageEditorOnWindowResize)
		} catch (e) { }
		_imageEditorOnWindowResize = null
	}

	function getImageEditorCtor() {
		try {
			if ($window && $window.tui && $window.tui.ImageEditor) return $window.tui.ImageEditor
		} catch (e) { }
		return null
	}

	function getImageEditorModal() {
		try {
			let el = document.getElementById('epImageEditorModal')
			if (!el) return null
			if (!_imageEditorModal && $window.bootstrap && $window.bootstrap.Modal) {
				// IMPORTANT: disable focus trap so Fabric.js can focus its hidden textarea
				// (required for editing/typing text objects inside the canvas).
				_imageEditorModal = $window.bootstrap.Modal.getOrCreateInstance(el, {
					backdrop: 'static',
					keyboard: false,
					focus: false
				})
			}
			if (!_imageEditorModalBound) {
				_imageEditorModalBound = true
				el.addEventListener('shown.bs.modal', function () {
					// Ensure editor is sized correctly once Bootstrap finishes showing.
					bindImageEditorWindowResize()
					$window.setTimeout(resizeImageEditorToContainer, 60)
					$window.setTimeout(resizeImageEditorToContainer, 220)
				})
				el.addEventListener('hidden.bs.modal', function () {
					// Always dispose editor resources when the modal closes.
					destroyImageEditorInstance()
					revokeImageEditorSourceUrl()
					unbindImageEditorWindowResize()
					$scope.imageEditorState = { loading: false, applying: false, error: null }
					safeApply($scope)
				})
			}
			return _imageEditorModal
		} catch (e) {
			return null
		}
	}

	async function fetchBlobFromUrl(url) {
		let resp = await fetch(url, { method: 'GET', mode: 'cors', credentials: 'omit', cache: 'no-store' })
		if (!resp || !resp.ok) throw new Error('Unable to load image.')
		return await resp.blob()
	}

	function replaceFilenameExt(filename, newExtWithDot) {
		let base = filename || 'image'
		let idx = base.lastIndexOf('.')
		if (idx > 0) base = base.slice(0, idx)
		return base + newExtWithDot
	}

	// Opens the editor on a file in the upload list, or on the file in the edit form when no file is given
	$scope.openImageEditor = async function (item) {
		let target = item || $scope.pendingFile
		try {
			if (!$scope.imageEditorViewportOk) return
			if (!target) return
			if (target.previewKind !== 'image' || !target.previewUrl) return
			if (target._processingPreview) return
			_imageEditorTarget = target
			$scope.portalMessageUnread = 0

			$scope.imageEditorState = { loading: true, applying: false, error: null }
			safeApply($scope)

			let modal = getImageEditorModal()
			if (modal) modal.show()

			$scope.portalMessageUnread = 0
			// Defer init until modal is visible so editor can measure size.
			let token = ++_imageEditorInitToken
			// Wait for Bootstrap modal transition (approx 300ms) to ensure correct sizing.
			$window.setTimeout(async function () {
				if (token !== _imageEditorInitToken) return
				try {
					destroyImageEditorInstance()
					revokeImageEditorSourceUrl()
					let root = document.getElementById('epImageEditorRoot')
					if (!root) throw new Error('Image editor root not found')
					let Ctor = getImageEditorCtor()

					// Prefer the actual pending rawFile (new uploads), otherwise fetch the existing image.
					let blob = null
					if (target && target.rawFile instanceof Blob) {
						blob = target.rawFile
					} else {
						blob = await fetchBlobFromUrl(target.previewUrl)
					}

					_imageEditorSourceObjectUrl = URL.createObjectURL(blob)

					_imageEditorInstance = new Ctor(root, {
						includeUI: {
							loadImage: {
								path: _imageEditorSourceObjectUrl,
								name: (target && target.name) ? target.name : 'image'
							},
							menu: ['crop', 'flip', 'rotate', 'draw', 'shape', 'text'],
							// Don't force Crop mode on open; it can feel like the image is "stuck".
							initMenu: 'draw',
							menuBarPosition: 'bottom'
						},
						// cssMaxWidth/Height: Do NOT set these to the container size, as it restricts
						// the canvas from growing when zooming in. Let the editor handle sizing.
						selectionStyle: {
							cornerSize: 18,
							rotatingPointOffset: 60
						},
						usageStatistics: false
					})

					// Force zoom buttons to work as simple step-zoom (ToastUI's default zoom-in
					// is a drag-to-zoom mode, which is often interpreted as "broken" in modals).
					installToastUiZoomButtonFix(root, _imageEditorInstance)

					// A couple delayed resizes makes zoom controls reliable.
					$window.setTimeout(resizeImageEditorToContainer, 0)
					$window.setTimeout(resizeImageEditorToContainer, 120)

					$scope.imageEditorState = { loading: false, applying: false, error: null }
					safeApply($scope)
				} catch (err) {
					try { console.error('Image editor init failed:', err) } catch (e) { }
					$scope.imageEditorState = {
						loading: false,
						applying: false,
						error: 'Unable to load the image editor for this file.'
					}
					safeApply($scope)
				}
			}, 350)
		} catch (e) {
			$scope.imageEditorState = { loading: false, applying: false, error: 'Unable to open image editor.' }
			safeApply($scope)
		}
	}

	// Keep the edit button enabled/disabled based on viewport size.
	bindImageEditorViewportResize()
	$scope.$on('$destroy', function () {
		unbindImageEditorViewportResize()
	})

	$scope.imageEditorCancel = function () {
		let modal = getImageEditorModal()
		if (modal) modal.hide()
	}

	$scope.imageEditorApply = async function () {
		let target = _imageEditorTarget
		if (!target) return
		if (!_imageEditorInstance) return
		if ($scope.imageEditorState && ($scope.imageEditorState.loading || $scope.imageEditorState.applying)) return

		$scope.imageEditorState = { loading: false, applying: true, error: null }
		safeApply($scope)
		try {
			let dataUrl = null
			try {
				// Prefer JPEG output (smaller + matches backend normalization).
				dataUrl = _imageEditorInstance.toDataURL({ format: 'jpeg', quality: 0.9 })
			} catch (e) {
				dataUrl = _imageEditorInstance.toDataURL()
			}
			if (!dataUrl) throw new Error('Unable to export edited image.')

			let resp = await fetch(dataUrl)
			let blob = await resp.blob()
			let mime = (blob && blob.type) ? String(blob.type) : 'image/jpeg'
			let extDot = (mime === 'image/png') ? '.png' : '.jpg'
			let newName = replaceFilenameExt(target.name || 'image', extDot)
			let file = new File([blob], newName, { type: mime, lastModified: Date.now() })

			// Update pending file + preview to use the edited file.
			cleanupPreview(target)
			target.rawFile = file
			target.name = file.name
			target.size = file.size
			target.sizeLabel = formatBytes(file.size)
			target.detectedExt = (extDot.toUpperCase())
			target.previewKind = 'image'
			target.previewUrl = URL.createObjectURL(file)
			target.previewLabel = null
			target._processingPreview = false

			$scope.imageEditorState = { loading: false, applying: false, error: null }
			safeApply($scope)
			let modal = getImageEditorModal()
			if (modal) modal.hide()
		} catch (err) {
			try { console.error('Image editor apply failed:', err) } catch (e) { }
			$scope.imageEditorState = { loading: false, applying: false, error: 'Unable to apply image changes. Please try again.' }
			safeApply($scope)
		}
	}

	$scope.openFileTypesModal = function () {
		let modal = getFileTypesModal()
		if (modal) modal.show()
	}

	$scope.closeFileTypesModal = function () {
		let modal = getFileTypesModal()
		if (modal) modal.hide()
	}

	$scope.trustHtml = function (html) {
		return $sce.trustAsHtml(html || '')
	}

	function messageCenterIsNarrow() {
		try {
			if (!$window || typeof $window.matchMedia !== 'function') return false
			return $window.matchMedia('(max-width: 991.98px)').matches
		} catch (e) {
			return false
		}
	}
	$scope.messageCenterIsNarrow = messageCenterIsNarrow

	function isPortalMessageUnread(obj) {
		try {
			if (!obj) return false
			// Clients do not need to mark their own messages as read.
			if (String(obj.sender_type || '').toLowerCase() !== 'employee') return false
			if (typeof obj.is_read !== 'undefined') return Number(obj.is_read) === 0
			if (typeof obj.read !== 'undefined') return Number(obj.read) === 0
			if (typeof obj.read_at !== 'undefined') return !obj.read_at
			return false
		} catch (e) {
			return false
		}
	}
	$scope.isPortalMessageUnread = isPortalMessageUnread

	function hasPortalMessageUnreadFlag(obj) {
		try {
			if (!obj) return false
			if (typeof obj.is_read !== 'undefined') return Number(obj.is_read) === 0
			if (typeof obj.read !== 'undefined') return Number(obj.read) === 0
			if (typeof obj.read_at !== 'undefined') return !obj.read_at
			return false
		} catch (e) {
			return false
		}
	}
	$scope.hasPortalMessageUnreadFlag = hasPortalMessageUnreadFlag

	function hasPortalMessageReadFlag(obj) {
		try {
			if (!obj) return false
			if (typeof obj.is_read !== 'undefined') return Number(obj.is_read) === 1
			if (typeof obj.read !== 'undefined') return Number(obj.read) === 1
			if (typeof obj.read_at !== 'undefined') return !!obj.read_at
			return false
		} catch (e) {
			return false
		}
	}
	$scope.hasPortalMessageReadFlag = hasPortalMessageReadFlag

	function getMessageCenterModal() {
		try {
			let el = document.getElementById('epMessageCenterModal')
			if (!el) return null
			if (!_messageCenterModal && $window.bootstrap && $window.bootstrap.Modal) {
				_messageCenterModal = $window.bootstrap.Modal.getOrCreateInstance(el)
			}
			if (!_messageCenterModalBound) {
				_messageCenterModalBound = true
				el.addEventListener('shown.bs.modal', function () {
					try {
						if (!_messageCenterThreadResizeBound) {
							_messageCenterThreadResizeBound = true
							_messageCenterThreadOnResize = function () {
								updateMessageCenterThreadHasScrollbar()
							}
							try { $window.addEventListener('resize', _messageCenterThreadOnResize, { passive: true }) } catch (e) { }
							try { $window.addEventListener('orientationchange', _messageCenterThreadOnResize, { passive: true }) } catch (e) { }
						}
						bindMessageCenterThreadScroll()
						updateMessageCenterThreadHasScrollbar()
					} catch (e) { }
				})
				el.addEventListener('hidden.bs.modal', function () {
					try { destroyMessageCenterEditor() } catch (e) { }
					try {
						unbindMessageCenterThreadScroll()
						if (_messageCenterThreadResizeBound) {
							_messageCenterThreadResizeBound = false
							if (_messageCenterThreadOnResize) {
								try { $window.removeEventListener('resize', _messageCenterThreadOnResize) } catch (e) { }
								try { $window.removeEventListener('orientationchange', _messageCenterThreadOnResize) } catch (e) { }
							}
							_messageCenterThreadOnResize = null
						}
					} catch (e) { }
					$scope.messageCenter.view = 'list'
					$scope.messageCenter.selected = null
					$scope.messageCenter.loading = false
					$scope.messageCenter.error = null
					$scope.messageCenter.replying = false
					$scope.messageCenter.sendingReply = false
					$scope.messageCenter.replyError = null
					$scope.messageCenter.threadHasScrollbar = false
					$scope.messageCenter.threadStickyReplyVisible = false
					safeApply($scope)
				})
			}
			return _messageCenterModal
		} catch (e) {
			return null
		}
	}

	function getMessageCenterReplyModal() {
		try {
			let el = document.getElementById('epMessageCenterReplyModal')
			if (!el) return null
			if (!_messageCenterReplyModal && $window.bootstrap && $window.bootstrap.Modal) {
				_messageCenterReplyModal = $window.bootstrap.Modal.getOrCreateInstance(el)
			}
			if (!_messageCenterReplyModalBound) {
				_messageCenterReplyModalBound = true
				el.addEventListener('hidden.bs.modal', function () {
					try { destroyMessageCenterEditor() } catch (e) { }
					$scope.messageCenter.replying = false
					$scope.messageCenter.sendingReply = false
					$scope.messageCenter.replyError = null
					safeApply($scope)
				})
			}
			return _messageCenterReplyModal
		} catch (e) {
			return null
		}
	}

	function destroyMessageCenterEditor() {
		try {
			if (!$window || !$window.$) return
			let $ = $window.$
			let el = $('#epMessageCenterReplyEditor')
			if (!el || !el.length) return
			if (el.data('summernote')) el.summernote('destroy')
		} catch (e) { }
	}

	function initMessageCenterEditor() {
		let token = ++_messageCenterEditorInitToken
		$window.setTimeout(function () {
			if (token !== _messageCenterEditorInitToken) return
			try {
				if (!$window || !$window.$ || !$window.$.fn || typeof $window.$.fn.summernote !== 'function') {
					$scope.messageCenter.replyError = 'Summernote is not available.'
					safeApply($scope)
					return
				}
				destroyMessageCenterEditor()
				let $ = $window.$
				$('#epMessageCenterReplyEditor').summernote({
					height: messageCenterIsNarrow() ? 160 : 220,
					dialogsInBody: true,
					placeholder: 'Type your reply…',
					toolbar: [
						['misc', ['undo', 'redo']],
						['style', ['bold', 'italic', 'underline', 'clear']],
						['font', ['strikethrough', 'superscript', 'subscript']],
						['fontsize', ['fontsize']],
						['insert', ['hr']],
						['para', ['ul', 'ol', 'paragraph']],
						['height', ['height']]
					]
					// toolbar: [
					// 	['style', ['bold', 'italic', 'underline']],
					// 	['para', ['ul', 'ol']],
					// 	['view', ['codeview']]
					// ]
				})
				// Ensure editor starts empty
				$('#epMessageCenterReplyEditor').summernote('code', '')
			} catch (e) {
				$scope.messageCenter.replyError = 'Unable to initialize the editor.'
				safeApply($scope)
			}
		}, 0)
	}

	let _qrModal = null
	let _qrModalBound = false
	$scope.evidenceQr = null

	function getQrModal() {
		try {
			let el = document.getElementById('epQrModal')
			if (!el) return null
			if (!_qrModal && $window.bootstrap && $window.bootstrap.Modal) {
				_qrModal = $window.bootstrap.Modal.getOrCreateInstance(el)
			}
			if (!_qrModalBound) {
				_qrModalBound = true
				el.addEventListener('hidden.bs.modal', function () {
					$scope.evidenceQr = null
					safeApply($scope)
				})
			}
			return _qrModal
		} catch (e) {
			return null
		}
	}

	$scope.openQrModal = function () {
		try {
			let p = getActiveParams()
			if (!p || !p.user_id || !p.prop_id) return

			const hostname = ($window.location && $window.location.hostname) ? String($window.location.hostname).toLowerCase() : ''
			let evidenceOrigin = 'https://evidence.propertytax.io'

			if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1') {
				evidenceOrigin = 'https://evidence.propertytax.io'
			} else if (
				hostname === 'evidence.texasptc.com'
				|| hostname === 'texasptc.com'
				|| hostname === 'evidence.texastpc.com'
				|| hostname === 'texastpc.com'
			) {
				evidenceOrigin = 'https://evidence.texasptc.com'
			} else if (hostname === 'evidence.propertytax.io' || hostname === 'propertytax.io') {
				evidenceOrigin = 'https://evidence.propertytax.io'
			}
			let fullUrl = `${evidenceOrigin}/${p.user_id}/${p.user_token}/${p.prop_id}`

			$scope.evidenceQr = {
				evidenceUrl: fullUrl,
				// API to generate QR code image
				qrSrc: `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(fullUrl)}`
			}
			safeApply($scope)

			let modal = getQrModal()
			if (modal) modal.show()
		} catch (e) {
			console.error('Unable to open QR modal', e)
		}
	}

	$scope.openMessageCenter = async function () {
		try {
			$scope.messageCenter.error = null
			$scope.messageCenter.loading = false
			$scope.messageCenter.replying = false
			$scope.messageCenter.replyError = null
			$scope.messageCenter.threadHasScrollbar = false
			$scope.messageCenter.threadStickyReplyVisible = false
			$scope.messageCenter.view = 'list'
			$scope.messageCenter.selected = null
			destroyMessageCenterEditor()

			let modal = getMessageCenterModal()
			if (modal) modal.show()
		} catch (e) {
			$scope.messageCenter.error = 'Unable to open Message Center.'
			safeApply($scope)
		}
	}

	$scope.closeMessageCenter = function () {
		let modal = getMessageCenterModal()
		if (modal) modal.hide()
	}

	$scope.helpMenuOpen = false

	$scope.toggleHelpMenu = function () {
		$scope.helpMenuOpen = !$scope.helpMenuOpen
		// Hide any active tooltips when opening the menu
		if ($scope.helpMenuOpen) {
			try {
				let tooltips = document.querySelectorAll('[role="tooltip"]')
				tooltips.forEach(function (tooltip) {
					if (tooltip && tooltip.style) {
						tooltip.style.display = 'none'
					}
				})
			} catch (e) { }
		}
		safeApply($scope)
	}

	$scope.openHelpArticle = function () {
		try {
			$window.open('https://intercom.help/propertytaxio/en/articles/13909035-goodrich-realty-consulting-evidence-portal', '_blank')
			$scope.helpMenuOpen = false
			safeApply($scope)
		} catch (e) {
			console.error('Unable to open help article', e)
		}
	}

	$scope.openHelpVideo = function () {
		try {
			$window.open('https://player.vimeo.com/video/1169438399', '_blank')
			$scope.helpMenuOpen = false
			safeApply($scope)
		} catch (e) {
			console.error('Unable to open help video', e)
		}
	}

	// Close help menu when clicking outside
	try {
		if (document) {
			document.addEventListener('click', function (e) {
				try {
					let container = document.querySelector('.ep-helpBtn__container')
					if (container && !container.contains(e.target)) {
						if ($scope.helpMenuOpen) {
							$scope.helpMenuOpen = false
							safeApply($scope)
						}
					}
				} catch (err) { }
			})
		}
	} catch (e) { }

	$scope.refreshMessageCenter = async function () {
		try {
			let selectedId = null
			try {
				selectedId = ($scope.messageCenter && $scope.messageCenter.selected && $scope.messageCenter.selected.message_id)
				selectedId = selectedId ? Number(selectedId) : null
			} catch (e) { selectedId = null }

			await $scope.loadPortalFiles()

			// Restore selection after reload.
			try {
				if (selectedId && Array.isArray($scope.portalMessages)) {
					let updated = $scope.portalMessages.find(m => m && Number(m.message_id) === selectedId)
					if (updated) $scope.messageCenter.selected = updated
				}
			} catch (e) { }

			safeApply($scope)
			scheduleMessageCenterThreadScrollToBottom()
		} catch (e) {
			try {
				$scope.messageCenter.error = 'Unable to refresh messages.'
			} catch (e2) { }
			safeApply($scope)
		}
	}

	function getMessageCenterThreadScrollEl() {
		try {
			let modalEl = document.getElementById('epMessageCenterModal')
			if (!modalEl) return null
			return modalEl.querySelector('.ep-msgcenter__gridCol--right')
		} catch (e) {
			return null
		}
	}

	function bindMessageCenterThreadScroll() {
		try {
			let rightCol = getMessageCenterThreadScrollEl()
			if (!rightCol) return
			if (_messageCenterThreadScrollBound && _messageCenterThreadScrollEl && _messageCenterThreadScrollEl !== rightCol) {
				try { _messageCenterThreadScrollEl.removeEventListener('scroll', _messageCenterThreadOnScroll) } catch (e) { }
				_messageCenterThreadScrollBound = false
				_messageCenterThreadOnScroll = null
				_messageCenterThreadScrollEl = null
			}
			if (_messageCenterThreadScrollBound) return
			_messageCenterThreadScrollBound = true
			_messageCenterThreadScrollEl = rightCol
			_messageCenterThreadOnScroll = function () {
				updateMessageCenterThreadHasScrollbar()
			}
			try { rightCol.addEventListener('scroll', _messageCenterThreadOnScroll, { passive: true }) } catch (e) {
				try { rightCol.addEventListener('scroll', _messageCenterThreadOnScroll) } catch (e2) { }
			}
		} catch (e) { }
	}

	function unbindMessageCenterThreadScroll() {
		try {
			if (!_messageCenterThreadScrollBound) return
			_messageCenterThreadScrollBound = false
			if (_messageCenterThreadScrollEl && _messageCenterThreadOnScroll) {
				try { _messageCenterThreadScrollEl.removeEventListener('scroll', _messageCenterThreadOnScroll) } catch (e) { }
			}
			_messageCenterThreadOnScroll = null
			_messageCenterThreadScrollEl = null
		} catch (e) { }
	}

	function updateMessageCenterThreadHasScrollbar() {
		try {
			let rightCol = getMessageCenterThreadScrollEl()
			if (!rightCol) return
			if (!$scope.messageCenter) return

			let scrollable = (rightCol.scrollHeight - rightCol.clientHeight) > 2
			let scrolledDown = Number(rightCol.scrollTop || 0) > 40
			let stickyVisible = !!(scrollable && scrolledDown)

			let changed = false
			if ($scope.messageCenter.threadHasScrollbar !== scrollable) {
				$scope.messageCenter.threadHasScrollbar = scrollable
				changed = true
			}
			if ($scope.messageCenter.threadStickyReplyVisible !== stickyVisible) {
				$scope.messageCenter.threadStickyReplyVisible = stickyVisible
				changed = true
			}
			if (changed) safeApply($scope)
		} catch (e) { }
	}

	function scheduleMessageCenterThreadScrollToBottom() {
		// If the thread view is scrollable, jump to the bottom so the latest reply is visible.
		// Must defer until after Angular updates the DOM.
		try {
			$window.setTimeout(function () {
				try {
					let modalEl = document.getElementById('epMessageCenterModal')
					if (!modalEl) return
					let rightCol = modalEl.querySelector('.ep-msgcenter__gridCol--right')
					if (!rightCol) return
					bindMessageCenterThreadScroll()
					let scrollable = (rightCol.scrollHeight - rightCol.clientHeight) > 2
					if ($scope.messageCenter) $scope.messageCenter.threadHasScrollbar = scrollable
					safeApply($scope)

					// Only scroll when the right column is actually scrollable.
					if (!scrollable) return
					rightCol.scrollTop = rightCol.scrollHeight
					updateMessageCenterThreadHasScrollbar()
				} catch (e) { }
			}, 0)

			// A second tick helps when images/fonts load and change height.
			$window.setTimeout(function () {
				try {
					let modalEl = document.getElementById('epMessageCenterModal')
					if (!modalEl) return
					let rightCol = modalEl.querySelector('.ep-msgcenter__gridCol--right')
					if (!rightCol) return
					bindMessageCenterThreadScroll()
					let scrollable = (rightCol.scrollHeight - rightCol.clientHeight) > 2
					if ($scope.messageCenter) $scope.messageCenter.threadHasScrollbar = scrollable
					safeApply($scope)
					if (!scrollable) return
					rightCol.scrollTop = rightCol.scrollHeight
					updateMessageCenterThreadHasScrollbar()
				} catch (e) { }
			}, 120)
		} catch (e) { }
	}

	$scope.messageCenterBackToList = function () {
		$scope.messageCenter.view = 'list'
		$scope.messageCenter.threadHasScrollbar = false
		$scope.messageCenter.threadStickyReplyVisible = false
		safeApply($scope)
	}

	function getUnreadThreadItems(thread) {
		try {
			if (!thread) return []
			let items = [thread].concat(Array.isArray(thread.replies) ? thread.replies : [])
			return items.filter(function (item) {
				return canMarkPortalItemRead(item)
			})
		} catch (e) {
			return []
		}
	}

	async function markPortalMessageRead(thread) {
		try {
			if (!thread || !thread.message_id) return
			if (!canMarkPortalItemRead(thread)) return
			let p = getActiveParams()
			if (!p || !p.user_id || !p.user_token || !p.prop_id) return

			// Optimistic UI update.
			thread.is_read = 1
			thread.read_at = (new Date()).toISOString()
			try {
				let breakdown = computePortalMessageUnreadBreakdown($scope.portalMessages)
				$scope.portalMessageUnreadMessages = breakdown.unreadMessages || 0
				$scope.portalMessageUnreadReplies = breakdown.unreadReplies || 0
				$scope.portalMessageUnread = $scope.portalMessageUnreadMessages + $scope.portalMessageUnreadReplies
			} catch (e) { }
			safeApply($scope)

			await systemService.functionCall({
				type: 'markPortalMessageRead',
				params: Object.assign({}, p, { message_id: thread.message_id })
			})
		} catch (e) {
			// Non-fatal; leave optimistic state.
		}
	}

	$scope.markPortalItemRead = function (obj) {
		markPortalMessageRead(obj)
	}

	$scope.selectMessageThread = function (m) {
		if (!m) return
		$scope.messageCenter.selected = m
		$scope.messageCenter.replying = false
		$scope.messageCenter.replyError = null
		$scope.messageCenter.expandedBodies = {}
		$scope.messageCenter.threadHasScrollbar = false
		$scope.messageCenter.threadStickyReplyVisible = false
		destroyMessageCenterEditor()
		if (messageCenterIsNarrow()) $scope.messageCenter.view = 'thread'
		safeApply($scope)
		try {
			getUnreadThreadItems(m).forEach(function (item) {
				markPortalMessageRead(item)
			})
		} catch (e) { }
		scheduleMessageCenterThreadScrollToBottom()
	}

	$scope.startMessageReply = function () {
		if (!($scope.messageCenter && $scope.messageCenter.selected)) return
		$scope.messageCenter.replyError = null
		$scope.messageCenter.replying = true
		$scope.messageCenter.sendingReply = false
		safeApply($scope)
		let modal = getMessageCenterReplyModal()
		if (modal) modal.show()
		// Defer editor init until modal is visible
		$window.setTimeout(function () {
			initMessageCenterEditor()
		}, 350)
	}

	$scope.cancelMessageReply = function () {
		$scope.messageCenter.replying = false
		$scope.messageCenter.sendingReply = false
		$scope.messageCenter.replyError = null
		destroyMessageCenterEditor()
		let modal = getMessageCenterReplyModal()
		if (modal) modal.hide()
		safeApply($scope)
	}

	$scope.sendMessageReply = async function () {
		try {
			if (!($scope.messageCenter && $scope.messageCenter.selected)) return
			let thread = $scope.messageCenter.selected
			let threadId = thread && thread.message_id ? Number(thread.message_id) : null
			let p = getActiveParams()
			if (!p || !p.user_id || !p.user_token || !p.prop_id) {
				$scope.messageCenter.replyError = 'Missing authentication parameters.'
				safeApply($scope)
				return
			}

			let html = ''
			try {
				if ($window && $window.$ && $window.$.fn && typeof $window.$.fn.summernote === 'function') {
					html = String($window.$('#epMessageCenterReplyEditor').summernote('code') || '')
				}
			} catch (e) { }
			html = html.trim()
			if (!html || html === '<p><br></p>') {
				$scope.messageCenter.replyError = 'Please enter a reply.'
				safeApply($scope)
				return
			}

			$scope.messageCenter.sendingReply = true
			$scope.messageCenter.replyError = null
			safeApply($scope)

			// Use available name from props payload when possible.
			let senderName = ''
			try {
				senderName = ($scope.activeProp && $scope.activeProp.name) ? String($scope.activeProp.name) : ''
			} catch (e) { senderName = '' }

			let resp = await systemService.functionCall({
				type: 'savePortalMessageReply',
				params: Object.assign({}, p, {
					parent_message_id: thread.message_id,
					tax_year: thread.tax_year,
					message_text: html,
					sender_name: senderName
				})
			})

			let payload = resp && resp.data ? resp.data : null
			if (!payload || payload.success === false) {
				$scope.messageCenter.replyError = (payload && payload.error) ? String(payload.error) : 'Unable to send reply.'
				$scope.messageCenter.sendingReply = false
				safeApply($scope)
				return
			}

			$scope.messageCenter.replying = false
			$scope.messageCenter.sendingReply = false
			destroyMessageCenterEditor()
			let modal = getMessageCenterReplyModal()
			if (modal) modal.hide()
			safeApply($scope)
			notifyReviewToolPortalChanged('message-reply')

			// Reload threads to show the new reply.
			await $scope.loadPortalFiles()

			// Restore selection and scroll so the new reply is visible.
			try {
				if (threadId && Array.isArray($scope.portalMessages)) {
					let updated = $scope.portalMessages.find(m => m && Number(m.message_id) === threadId)
					if (updated) $scope.messageCenter.selected = updated
				}
			} catch (e) { }
			safeApply($scope)
			scheduleMessageCenterThreadScrollToBottom()
			try {
				if (threadId && Array.isArray($scope.portalMessages)) {
					let updated = $scope.portalMessages.find(m => m && Number(m.message_id) === threadId)
					if (updated) {
						$scope.messageCenter.selected = updated
						if (messageCenterIsNarrow()) $scope.messageCenter.view = 'thread'
					}
				}
			} catch (e) { }
			safeApply($scope)
		} catch (e) {
			$scope.messageCenter.replyError = 'Unable to send reply.'
			$scope.messageCenter.sendingReply = false
			safeApply($scope)
		}
	}

	function getPreviewModal() {
		try {
			let el = document.getElementById('epPreviewModal')
			if (!el) return null
			if (!_previewModal && $window.bootstrap && $window.bootstrap.Modal) {
				_previewModal = $window.bootstrap.Modal.getOrCreateInstance(el)
			}
			if (!_previewModalBound) {
				_previewModalBound = true
				el.addEventListener('hidden.bs.modal', function () {
					$scope.previewingFile = null
					$scope.previewTrustedUrl = null
					safeApply($scope)
				})
			}
			return _previewModal
		} catch (e) {
			return null
		}
	}

	function getRemoveModal() {
		try {
			let el = document.getElementById('epRemoveModal')
			if (!el) return null
			if (!_removeModal && $window.bootstrap && $window.bootstrap.Modal) {
				_removeModal = $window.bootstrap.Modal.getOrCreateInstance(el)
			}
			if (!_removeModalBound) {
				_removeModalBound = true
				el.addEventListener('hidden.bs.modal', function () {
					$scope.removeCandidate = null
					$scope.removeTrustedUrl = null
					$scope.removeMetaRows = []
					$scope.removeDeleting = false
					$scope.removeDeleteError = null
					safeApply($scope)
				})
			}
			return _removeModal
		} catch (e) {
			return null
		}
	}

	function getPendingRemoveModal() {
		try {
			let el = document.getElementById('epPendingRemoveModal')
			if (!el) return null
			if (!_pendingRemoveModal && $window.bootstrap && $window.bootstrap.Modal) {
				_pendingRemoveModal = $window.bootstrap.Modal.getOrCreateInstance(el)
			}
			if (!_pendingRemoveModalBound) {
				_pendingRemoveModalBound = true
				el.addEventListener('hidden.bs.modal', function () {
					$scope.pendingRemoveCandidate = null
					$scope.pendingRemoveTrustedUrl = null
					$scope.pendingRemoveMetaRows = []
					safeApply($scope)
				})
			}
			return _pendingRemoveModal
		} catch (e) {
			return null
		}
	}

	function isEditingActive() {
		return !!($scope.pendingFile && $scope.pendingFile._editing)
	}

	function getEditLockModal() {
		try {
			let el = document.getElementById('epEditLockModal')
			if (!el) return null
			if (!_editLockModal && $window.bootstrap && $window.bootstrap.Modal) {
				_editLockModal = $window.bootstrap.Modal.getOrCreateInstance(el)
			}
			if (!_editLockModalBound) {
				_editLockModalBound = true
				el.addEventListener('hidden.bs.modal', function () {
					$scope.editLockSaving = false
					$scope.editLockError = null
					$scope.editLockReason = null
					_editLockNextAction = null
					safeApply($scope)
				})
			}
			return _editLockModal
		} catch (e) {
			return null
		}
	}

	function showEditLock(reason, nextAction) {
		try {
			closeAllPopovers()
			$scope.editLockReason = reason || null
			$scope.editLockError = null
			$scope.editLockSaving = false
			_editLockNextAction = (typeof nextAction === 'function') ? nextAction : null
			safeApply($scope)
			let modal = getEditLockModal()
			if (modal) modal.show()
		} catch (e) { }
	}

	$scope.editLockCancel = function () {
		try {
			let modal = getEditLockModal()
			if (modal) modal.hide()
			try { $scope.discardPending() } catch (e) { }
			let next = _editLockNextAction
			// Run next action after the modal begins closing
			$window.setTimeout(function () {
				try { if (typeof next === 'function') next() } catch (e) { }
			}, 0)
		} catch (e) { }
	}

	async function trySavePendingForEditLock() {
		// savePending doesn't return a value; infer success by checking pendingFile cleared.
		if (!$scope.pendingFile) return true
		let beforeId = $scope.pendingFile && $scope.pendingFile.id
		await $scope.savePending()
		if (!$scope.pendingFile) return true
		// If it's still the same edit, treat as failure.
		let afterId = $scope.pendingFile && $scope.pendingFile.id
		return !(beforeId && afterId && beforeId === afterId)
	}

	$scope.editLockSave = async function () {
		if ($scope.editLockSaving) return
		$scope.editLockSaving = true
		$scope.editLockError = null
		safeApply($scope)
		try {
			let ok = await trySavePendingForEditLock()
			if (!ok) {
				$scope.editLockSaving = false
				$scope.editLockError = ($scope.pendingMessage && $scope.pendingMessage.text)
					? String($scope.pendingMessage.text)
					: 'Unable to save. Please complete required fields and try again.'
				safeApply($scope)
				return
			}
			$scope.editLockSaving = false
			safeApply($scope)
			let modal = getEditLockModal()
			if (modal) modal.hide()
			let next = _editLockNextAction
			$window.setTimeout(function () {
				try { if (typeof next === 'function') next() } catch (e) { }
			}, 0)
		} catch (e) {
			$scope.editLockSaving = false
			$scope.editLockError = 'Unable to save. Please try again.'
			safeApply($scope)
		}
	}

	function closeAllPopovers() {
		try {
			if (!window.bootstrap) return
			// aria-describedby is used for both tooltips and popovers.
			const triggers = document.querySelectorAll('[aria-describedby]')
			triggers.forEach(el => {
				// Popovers
				try {
					if (window.bootstrap.Popover) {
						const p = window.bootstrap.Popover.getInstance(el)
						if (p) {
							// Guard against Bootstrap internal state being missing
							if (p._activeTrigger == null) p._activeTrigger = {}
							// Avoid disposing during the click event (can null internal state and crash Bootstrap)
							if (typeof p.hide === 'function') p.hide()
						}
					}
				} catch (e) { }
				// Tooltips
				try {
					if (window.bootstrap.Tooltip) {
						const t = window.bootstrap.Tooltip.getInstance(el)
						if (t) {
							if (t._activeTrigger == null) t._activeTrigger = {}
							// Avoid disposing during the click event (can null internal state and crash Bootstrap)
							if (typeof t.hide === 'function') t.hide()
						}
					}
				} catch (e) { }
			})
			// Remove any lingering overlay elements from body as a fallback
			document.querySelectorAll('body > .popover, body > .tooltip').forEach(p => { try { p.remove() } catch (e) { } })
		} catch (e) { }
	}

	$scope.openPreview = function (file) {
		if (!file) return
		// Close any visible popovers so they don't show beneath the fullscreen preview
		closeAllPopovers()
		$scope.previewingFile = file
		if (file.previewKind === 'pdf' && file.previewUrl) {
			let pdfSrc = applyPdfPreviewViewerHints(file.previewUrl)
			$scope.previewTrustedUrl = $sce.trustAsResourceUrl(pdfSrc)
		} else {
			$scope.previewTrustedUrl = null
		}
		safeApply($scope)
		let modal = getPreviewModal()
		if (modal) modal.show()
		// Defensive: clear popovers shortly after opening in case of timing races
		setTimeout(closeAllPopovers, 60)
	}

	$scope.closePreview = function () {
		let modal = getPreviewModal()
		if (modal) {
			modal.hide()
			return
		}
		// Fallback if bootstrap modal instance isn't available
		$scope.previewingFile = null
		$scope.previewTrustedUrl = null
		safeApply($scope)
	}

	$scope.confirmRemove = async function () {
		if (!$scope.removeCandidate) return
		if ($scope.removeDeleting) return

		$scope.removeDeleting = true
		$scope.removeDeleteError = null
		safeApply($scope)

		let candidate = $scope.removeCandidate

		// If this is a server-backed file, delete from DB + GCS first.
		if (candidate && candidate.server_id) {
			try {
				let p = getActiveParams()
				let resp = await systemService.functionCall({
					type: 'removePortalFileAndInfo',
					params: p,
					portalFile: { server_id: candidate.server_id }
				})
				let payload = resp && resp.data ? resp.data : null
				if (!payload || payload.success === false) {
					$scope.removeDeleting = false
					$scope.removeDeleteError = (payload && payload.error) ? String(payload.error) : 'Unable to remove file.'
					safeApply($scope)
					return
				}
			} catch (e) {
				$scope.removeDeleting = false
				$scope.removeDeleteError = 'Unable to remove file.'
				safeApply($scope)
				return
			}
		}

		// Close the modal only after deletion completes successfully.
		let modal = getRemoveModal()
		if (modal) modal.hide()
		$scope.removeFile(candidate)
		// state clears on hidden.bs.modal, but also clear immediately for safety
		$scope.removeCandidate = null
		$scope.removeTrustedUrl = null
		$scope.removeMetaRows = []
		$scope.removeDeleting = false
		$scope.removeDeleteError = null
		notifyReviewToolPortalChanged('file-remove')
		safeApply($scope)
	}

	$scope.cancelRemove = function () {
		let modal = getRemoveModal()
		if (modal) modal.hide()
	}

	$scope.requestRemovePending = function () {
		if (!$scope.pendingFile) return
		$scope.pendingRemoveCandidate = $scope.pendingFile
		$scope.pendingRemoveMetaRows = buildMetaRows($scope.pendingFile)
		if ($scope.pendingFile.previewKind === 'pdf' && $scope.pendingFile.previewUrl) {
			$scope.pendingRemoveTrustedUrl = $sce.trustAsResourceUrl($scope.pendingFile.previewUrl)
		} else {
			$scope.pendingRemoveTrustedUrl = null
		}
		safeApply($scope)
		let modal = getPendingRemoveModal()
		if (modal) modal.show()
	}

	$scope.closePendingRemove = function () {
		let modal = getPendingRemoveModal()
		if (modal) modal.hide()
	}

	$scope.confirmRemovePending = function () {
		let modal = getPendingRemoveModal()
		if (modal) modal.hide()
		$scope.discardPending()
		safeApply($scope)
	}

	$scope.allowedFileTypes = (allowedFileTypesConfig && typeof allowedFileTypesConfig === 'object')
		? angular.copy(allowedFileTypesConfig)
		: {}

	$scope.allowedTypeKeys = Object.keys($scope.allowedFileTypes)
	let _dateAmountFieldIndex = null
	initController()

	function buildDateAmountFieldIndex() {
		let idx = {}
		try {
			if (!$scope.allowedFileTypes) return idx
			let typeKeys = Object.keys($scope.allowedFileTypes)
			for (let t = 0; t < typeKeys.length; t++) {
				let typeKey = typeKeys[t]
				let cfg = $scope.allowedFileTypes[typeKey]
				let fields = (cfg && Array.isArray(cfg.fields)) ? cfg.fields : []
				for (let i = 0; i < fields.length; i++) {
					let field = fields[i]
					if (!field || !field.key) continue
					if (field.type !== 'date' && field.type !== 'amount') continue
					if (!idx[field.key]) idx[field.key] = field
				}
			}
		} catch (e) {
			idx = {}
		}
		return idx
	}

	function computeDateAmountParts(file) {
		if (!file || !file.meta || typeof file.meta !== 'object') return []
		let meta = file.meta
		let parts = []

		function pushField(field, raw) {
			if (!field || !field.key) return
			let empty = raw === null || raw === undefined || (typeof raw === 'string' && raw.trim() === '')
			if (empty) return

			if (field.type === 'date') {
				let val = raw
				try {
					let d = (raw instanceof Date) ? raw : new Date(raw)
					if (d && !isNaN(d.getTime())) val = d
				} catch (e) {
					// keep raw
				}
				parts.push({ label: field.label || field.key, type: 'date', value: val })
				return
			}

			if (field.type === 'amount') {
				let valAmt = formatFieldValue(field, raw)
				parts.push({ label: field.label || field.key, type: 'amount', value: valAmt })
			}
		}

		// Preferred: schema order for this file's selectedType
		if (file.selectedType && $scope.allowedFileTypes && $scope.allowedFileTypes[file.selectedType]) {
			let cfg = $scope.allowedFileTypes[file.selectedType]
			let fields = (cfg && Array.isArray(cfg.fields)) ? cfg.fields : []
			for (let i = 0; i < fields.length; i++) {
				let field = fields[i]
				if (!field || !field.key) continue
				if (field.type !== 'date' && field.type !== 'amount') continue
				pushField(field, meta[field.key])
			}
			return parts
		}

		// Fallback: selectedType missing/unknown (older rows)
		if (!_dateAmountFieldIndex) _dateAmountFieldIndex = buildDateAmountFieldIndex()
		try {
			let keys = Object.keys(meta)
			for (let i = 0; i < keys.length; i++) {
				let k = keys[i]
				let field = _dateAmountFieldIndex[k]
				if (!field) continue
				pushField(field, meta[k])
			}
		} catch (e) {
			// ignore
		}

		return parts
	}

	function isPropertyAuthorized(prop) {
		try {
			if (!prop) return false
			return Number(prop.auth_ptio) === 1
		} catch (e) {
			return false
		}
	}
	$scope.isPropertyAuthorized = isPropertyAuthorized

	async function initController() {
		console.log('params :>> ', params);
		let resp = await systemService.functionCall({ type: 'getUserAndPropertyInfo', params: params })
		let payload = resp && resp.data ? resp.data : null
		console.log('getUserAndPropertyInfo :>> ', payload);
		$scope.evidenceYear = (payload && Number(payload.evidence_year) > 0) ? Number(payload.evidence_year) : null

		if (payload && payload.success && payload.data) {
			$scope.props = Array.isArray(payload.data) ? payload.data : [payload.data]
			let firstAuthorizedProp = ($scope.props || []).find(isPropertyAuthorized) || null
			let wantId = params && params.prop_id ? String(params.prop_id) : null
			let wantedProp = (wantId && $scope.props)
				? ($scope.props.find(p => p && (String(p.prop_id || '') === wantId)) || null)
				: null
			$scope.activeProp = (wantedProp && isPropertyAuthorized(wantedProp))
				? wantedProp
				: firstAuthorizedProp

			if (!$scope.activeProp) {
				$scope.uiMessage = {
					type: 'warn',
					text: 'No authorized properties are available for this user.'
				}
			}

			// If prop_id is missing from the URL, set activeProp to the first property (already done above).
		} else {
			$scope.props = null
			$scope.activeProp = null
			$scope.uiMessage = {
				type: 'warn',
				text: (payload && payload.error) ? String(payload.error) : 'Unable to load user and property information.'
			}
		}

		console.log('$scope.activeProp :>> ', $scope.activeProp);

		await $scope.loadPortalFiles()
		$scope.loadConditionNotes()
		maybeAutoOpenMessageCenterIfUnread()

		$scope.initializing = false
		safeApply($scope)
	}

	function isMessageCenterModalVisible() {
		try {
			let el = document.getElementById('epMessageCenterModal')
			return !!(el && el.classList && el.classList.contains('show'))
		} catch (e) {
			return false
		}
	}

	function maybeAutoOpenMessageCenterIfUnread() {
		try {
			let unread = Number($scope.portalMessageUnread || 0)
			if (!(unread > 0)) return
			// Avoid re-opening if the user already has it open.
			if (isMessageCenterModalVisible()) return
			$window.setTimeout(function () {
				try {
					if (isMessageCenterModalVisible()) return
					$scope.openMessageCenter()
				} catch (e) { }
			}, 0)
		} catch (e) { }
	}

	function serverRowToUiFile(row) {
		let extRaw = row && row.detected_ext ? String(row.detected_ext) : ''
		let ext = extRaw.replace('.', '').toUpperCase()
		let url = row && row.gcs_url ? String(row.gcs_url) : null
		let kind = 'file'
		let label = (ext || 'FILE')
		if (ext === 'PNG' || ext === 'JPG') kind = 'image'
		else if (ext === 'PDF') kind = 'pdf'
		else if (ext === 'HEIC') kind = 'heic'

		let meta = row ? row.meta_json : null
		if (typeof meta === 'string') {
			try { meta = JSON.parse(meta) } catch (e) { meta = {} }
		}
		if (!meta || typeof meta !== 'object') meta = {}

		let uiFile = {
			id: String(row.id || ''),
			server_id: row.id,
			name: row.original_name || '',
			size: row.size_bytes || 0,
			sizeLabel: formatBytes(row.size_bytes || 0),
			detectedExt: extRaw || (ext ? `.${ext}` : ''),
			previewKind: kind,
			previewUrl: url,
			previewLabel: label,
			selectedType: row.content_type_key || null,
			gcs_path: row.gcs_path || null,
			typeLabel: '',
			savedAt: row.created_at ? new Date(row.created_at) : null,
			gcs_url: url,
			meta: meta,
			dateAmountParts: []
		}
		setTypeLabel(uiFile)
		normalizeMetaForFile(uiFile)
		uiFile.dateAmountParts = computeDateAmountParts(uiFile)
		return uiFile
	}

	function normalizeMetaForFile(file) {
		try {
			if (!file || !file.selectedType) return
			let cfg = $scope.allowedFileTypes ? $scope.allowedFileTypes[file.selectedType] : null
			if (!cfg || !Array.isArray(cfg.fields)) return
			file.meta = file.meta && typeof file.meta === 'object' ? file.meta : {}

			for (let i = 0; i < cfg.fields.length; i++) {
				let field = cfg.fields[i]
				if (!field || !field.key) continue
				if (field.type !== 'date') continue
				let raw = file.meta[field.key]
				if (!raw) continue

				// Angular <input type="date"> requires Date objects, not ISO strings.
				if (raw instanceof Date) continue
				if (typeof raw === 'string') {
					let s = raw.trim()
					if (!s) {
						file.meta[field.key] = null
						continue
					}
					let d = null
					// If saved as YYYY-MM-DD, force local midnight.
					if (/^\d{4}-\d{2}-\d{2}$/.test(s)) d = new Date(s + 'T00:00:00')
					else d = new Date(s)
					file.meta[field.key] = (d && !isNaN(d.getTime())) ? d : null
				}
			}
		} catch (e) {
			// ignore
		}
	}

	$scope.loadPortalFiles = async function () {
		try {
			let p = getActiveParams()
			if (!p || !p.user_id || !p.user_token || !p.prop_id) {
				$scope.uploadedFiles = []
				$scope.portalMessages = []
				$scope.portalMessageUnread = 0
				$scope.portalMessageUnreadMessages = 0
				$scope.portalMessageUnreadReplies = 0
				return
			}
			let resp = await systemService.functionCall({ type: 'loadPortalFileAndInfo', params: p })
			let payload = resp && resp.data ? resp.data : null
			if (!payload || payload.success === false) {
				$scope.uploadedFiles = []
				$scope.portalMessages = []
				$scope.portalMessageUnread = 0
				$scope.portalMessageUnreadMessages = 0
				$scope.portalMessageUnreadReplies = 0
				$scope.uiMessage = {
					type: 'warn',
					text: (payload && payload.error) ? String(payload.error) : 'Unable to load uploaded files.'
				}
				safeApply($scope)
				return
			}
			let rows = Array.isArray(payload.data) ? payload.data : []
			let messages = Array.isArray(payload.messages) ? payload.messages : []
			$scope.uploadedFiles = rows.map(serverRowToUiFile)
			$scope.portalMessages = messages = Array.isArray(messages) ? messages : []
			let breakdown = computePortalMessageUnreadBreakdown($scope.portalMessages)
			$scope.portalMessageUnreadMessages = breakdown.unreadMessages || 0
			$scope.portalMessageUnreadReplies = breakdown.unreadReplies || 0
			$scope.portalMessageUnread = $scope.portalMessageUnreadMessages + $scope.portalMessageUnreadReplies
			console.log('$scope.portalMessageUnread :>> ', $scope.portalMessageUnread);
			console.log('$scope.portalMessages :>> ', JSON.stringify($scope.portalMessages, null, 2));
			maybeOpenPendingPortalEditFile()
			safeApply($scope)
		} catch (e) {
			$scope.uploadedFiles = []
			$scope.portalMessages = []
			$scope.portalMessageUnread = 0
			$scope.portalMessageUnreadMessages = 0
			$scope.portalMessageUnreadReplies = 0
			$scope.uiMessage = { type: 'warn', text: 'Unable to load uploaded files.' }
			safeApply($scope)
		}
	}

	async function doSelectProp(p) {
		if (!p) return
		if (!isPropertyAuthorized(p)) {
			$scope.uiMessage = {
				type: 'warn',
				text: 'WE ARE NOT AUTHORIZED ON THIS PROPERTY!'
			}
			safeApply($scope)
			return
		}
		if ($scope.pendingFile) {
			$scope.uiMessage = {
				type: 'warn',
				text: 'Finish the current file (Save or Remove) before switching properties.'
			}
			safeApply($scope)
			return
		}
		// Files in the upload list are saved to the property selected when they upload
		if ($scope.uploadQueue.length) {
			$scope.uiMessage = {
				type: 'warn',
				text: 'Upload or remove the files in the upload list before switching properties.'
			}
			safeApply($scope)
			return
		}
		// Condition Notes belong to the property they were written for
		if ($scope.conditionNotes.open || _conditionNotesTimer || _conditionNotesSavePromise) {
			let saved = await $scope.saveConditionNotes()
			if (saved === false && isConditionNotesDirty()) {
				$scope.uiMessage = {
					type: 'warn',
					text: 'Your condition notes could not be saved. Save them (or clear them) before switching properties.'
				}
				safeApply($scope)
				return
			}
		}
		$scope.activeProp = p
		await $scope.loadPortalFiles()
		$scope.loadConditionNotes()
		maybeAutoOpenMessageCenterIfUnread()
		safeApply($scope)

		// Mobile-only: close the property dropdown after selection.
		try {
			let isMobile = false
			if ($window && typeof $window.matchMedia === 'function') {
				isMobile = $window.matchMedia('(max-width: 900px)').matches
			}
			if (!isMobile) return
			if (!$window || !$window.bootstrap || !$window.bootstrap.Dropdown) return
			let toggleEl = document.querySelector('.ep-propdd .ep-propdd__toggle[data-bs-toggle="dropdown"]')
			if (!toggleEl) return
			$window.setTimeout(function () {
				try {
					let dd = $window.bootstrap.Dropdown.getOrCreateInstance(toggleEl)
					if (dd) dd.hide()
				} catch (e) { }
			}, 0)
		} catch (e) { }
	}

	$scope.selectProp = function (p) {
		if (!p) return
		if (isEditingActive()) {
			showEditLock('Switch properties', function () { doSelectProp(p) })
			return
		}
		doSelectProp(p)
	}

	$scope.browse = function () {
		let input = document.getElementById('epFileInput')
		if (input) input.click()
	}

	$scope.removeFile = function (file) {
		if (!file) return
		// Revoke preview URL for the removed file (if any)
		let existing = $scope.uploadedFiles.find(f => f.id === file.id)
		if (existing) cleanupPreview(existing)
		$scope.uploadedFiles = $scope.uploadedFiles.filter(f => f.id !== file.id)
	}

	// Uploaded files: a checkbox on each card (uploadedSelected, by id). With two or more ticked, a remove button deletes
	// them all after a confirmation that says how many photos and documents. Only files still shown count (selections
	// hidden by the type filter are dropped in rebuildGroupedUploadedFiles).
	$scope.uploadedSelected = {}
	$scope.removeSelected = { photos: [], documents: [], deleting: false, done: 0, total: 0, error: null }
	let _removeSelectedModal = null

	function getSelectedUploadedFiles() {
		return ($scope.visibleUploadedFiles || []).filter(function (f) { return f && $scope.uploadedSelected[f.id] })
	}

	$scope.getSelectedUploadedCount = function () {
		return getSelectedUploadedFiles().length
	}

	$scope.clearUploadedSelection = function () {
		$scope.uploadedSelected = {}
	}

	function pruneUploadedSelection() {
		let selected = $scope.uploadedSelected || {}
		let kept = {}
		;($scope.visibleUploadedFiles || []).forEach(function (f) {
			if (f && selected[f.id]) kept[f.id] = true
		})
		$scope.uploadedSelected = kept
	}

	// "3 photos and 2 documents" (photos as in the Condition Photos tab)
	$scope.getRemoveSelectedSummary = function () {
		let parts = []
		let p = $scope.removeSelected.photos.length
		let d = $scope.removeSelected.documents.length
		if (p) parts.push(`${p} photo${p === 1 ? '' : 's'}`)
		if (d) parts.push(`${d} document${d === 1 ? '' : 's'}`)
		return parts.join(' and ')
	}

	$scope.requestRemoveSelected = function () {
		let files = getSelectedUploadedFiles()
		if (files.length < 2) return
		$scope.removeSelected = {
			photos: files.filter(function (f) { return f.selectedType === 'PHOTO' }),
			documents: files.filter(function (f) { return f.selectedType !== 'PHOTO' }),
			deleting: false,
			done: 0,
			total: files.length,
			error: null
		}
		let modal = getRemoveSelectedModal()
		if (modal) modal.show()
	}

	$scope.closeRemoveSelected = function () {
		if ($scope.removeSelected.deleting) return
		let modal = getRemoveSelectedModal()
		if (modal) modal.hide()
	}

	// Deletes them one at a time (as the single remove does: DB row + stored file). Any that fail stay in the list,
	// still ticked, and the modal stays open saying which.
	$scope.confirmRemoveSelected = async function () {
		let state = $scope.removeSelected
		if (state.deleting) return
		let files = state.photos.concat(state.documents)
		if (!files.length) return
		state.deleting = true
		state.done = 0
		state.error = null
		safeApply($scope)

		let failed = []
		let removed = 0
		let p = getActiveParams()
		for (let i = 0; i < files.length; i++) {
			let file = files[i]
			let ok = true
			if (file.server_id) {
				try {
					let resp = await systemService.functionCall({
						type: 'removePortalFileAndInfo',
						params: p,
						portalFile: { server_id: file.server_id }
					})
					let payload = resp && resp.data ? resp.data : null
					ok = !!(payload && payload.success !== false)
				} catch (e) {
					ok = false
				}
			}
			if (ok) {
				$scope.removeFile(file)
				delete $scope.uploadedSelected[file.id]
				removed++
			} else {
				failed.push(file)
			}
			state.done = i + 1
			safeApply($scope)
		}

		state.deleting = false
		if (removed) notifyReviewToolPortalChanged('file-remove')
		if (failed.length) {
			state.photos = failed.filter(function (f) { return f.selectedType === 'PHOTO' })
			state.documents = failed.filter(function (f) { return f.selectedType !== 'PHOTO' })
			state.total = failed.length
			state.error = `${failed.length === 1 ? 'This file' : 'These ' + failed.length + ' files'} could not be removed: ${failed.map(function (f) { return f.name }).join(', ')}. Please try again.`
			safeApply($scope)
			return
		}
		safeApply($scope)
		let modal = getRemoveSelectedModal()
		if (modal) modal.hide()
	}

	function getRemoveSelectedModal() {
		try {
			let el = document.getElementById('epRemoveSelectedModal')
			if (!el || !$window.bootstrap || !$window.bootstrap.Modal) return null
			if (!_removeSelectedModal) _removeSelectedModal = $window.bootstrap.Modal.getOrCreateInstance(el, { backdrop: 'static' })
			return _removeSelectedModal
		} catch (e) {
			return null
		}
	}

	$scope.requestRemoveFile = function (file) {
		if (!file) return
		$scope.removeCandidate = file
		$scope.removeMetaRows = buildMetaRows(file)
		$scope.removeDeleting = false
		$scope.removeDeleteError = null
		if (file.previewKind === 'pdf' && file.previewUrl) {
			$scope.removeTrustedUrl = $sce.trustAsResourceUrl(file.previewUrl)
		} else {
			$scope.removeTrustedUrl = null
		}
		safeApply($scope)
		let modal = getRemoveModal()
		if (modal) modal.show()
	}

	function buildMetaRows(file) {
		if (!file) return []
		let rows = []
		rows.push({ label: 'File name', value: file.name || '' })
		rows.push({ label: 'File size', value: file.sizeLabel || '' })
		rows.push({ label: 'Detected extension', value: file.detectedExt || '' })
		if (file.addedAt) rows.push({ label: 'Added', value: file.addedAt })
		if (file.savedAt) rows.push({ label: 'Saved', value: file.savedAt })

		let cfg = file.selectedType ? $scope.allowedFileTypes[file.selectedType] : null
		rows.push({ label: 'Content type', value: cfg && cfg.label ? cfg.label : (file.selectedType || '') })

		let fields = $scope.getFieldsForFile ? $scope.getFieldsForFile(file) : []
		let meta = (file && file.meta) ? file.meta : {}
		for (let i = 0; i < fields.length; i++) {
			let field = fields[i]
			if (!field || !field.key) continue
			let raw = meta[field.key]
			let empty = raw === null || raw === undefined || (typeof raw === 'string' && raw.trim() === '')
			if (empty) continue
			rows.push({ label: field.label || field.key, value: formatFieldValue(field, raw) })
		}
		return rows
	}

	function formatFieldValue(field, raw) {
		if (!field) return raw
		if (field.type === 'checkbox') return raw ? 'Yes' : 'No'
		if (field.type === 'select' && Array.isArray(field.options)) {
			let opt = field.options.find(o => o && o.value === raw)
			return opt && opt.label ? opt.label : raw
		}
		if (field.type === 'amount') {
			// Keep user-entered formatting when present.
			if (typeof raw === 'number') return raw.toLocaleString(undefined, { style: 'currency', currency: 'USD' })
			return raw
		}
		return raw
	}

	$scope.getUploadedPopoverHtml = function (file) {
		if (!file) return ''
		let rows = buildMetaRows(file)
		let previewHtml = ''
		if (file.previewKind === 'image' && file.previewUrl) {
			previewHtml = `<img class="ep-popover__img" src="${escapeAttr(file.previewUrl)}" alt="" />`
		} else if (file.previewKind === 'pdf' && file.previewUrl) {
			// Small embedded preview for PDFs
			let pdfSrc = applyPdfPopoverViewerHints(file.previewUrl)
			previewHtml = `<iframe class="ep-popover__frame ep-popover__frame--pdf" src="${escapeAttr(pdfSrc)}" title="PDF preview" scrolling="no"></iframe>`
		} else {
			previewHtml = `<div class="ep-popover__badge">${escapeHtml(file.previewLabel || 'FILE')}</div>`
		}

		let metaHtml = rows.map(r => {
			let label = escapeHtml(r.label)
			let value = escapeHtml(formatPopoverValue(r.value))
			return `<div class="ep-popover__row"><div class="ep-popover__k">${label}</div><div class="ep-popover__v">${value}</div></div>`
		}).join('')

		return (
			`<div class="ep-popover__wrap">`
			+ `<div class="ep-popover__top">${previewHtml}</div>`
			+ `<div class="ep-popover__meta">${metaHtml}</div>`
			+ `<div class="ep-popover__hint">Click preview to open full screen</div>`
			+ `</div>`
		)
	}

	function applyPdfPopoverViewerHints(url) {
		// Many built-in PDF viewers (Chrome/Edge) respect these fragment params.
		// Goal: avoid horizontal scrolling in the embedded preview.
		try {
			let s = String(url || '')
			if (!s) return s

			let hashIndex = s.indexOf('#')
			if (hashIndex === -1) {
				return s + '#view=FitH&navpanes=0&toolbar=0'
			}

			let base = s.substring(0, hashIndex)
			let frag = s.substring(hashIndex + 1)
			if (!frag) return base + '#view=FitH&navpanes=0&toolbar=0'

			// If caller already set a view/zoom, respect it.
			if (/\bview=|\bzoom=/i.test(frag)) return s

			return base + '#' + frag + '&view=FitH&navpanes=0&toolbar=0'
		} catch (e) {
			return url
		}
	}

	function applyPdfPreviewViewerHints(url) {
		// Fullscreen preview: fit PDF page to device width.
		// (This affects the PDF viewer inside the iframe; CSS alone can't.)
		try {
			let s = String(url || '')
			if (!s) return s

			let hashIndex = s.indexOf('#')
			if (hashIndex === -1) {
				return s + '#zoom=page-width'
			}

			let base = s.substring(0, hashIndex)
			let frag = s.substring(hashIndex + 1)
			if (!frag) return base + '#zoom=page-width'

			// If caller already set a view/zoom, respect it.
			if (/\bview=|\bzoom=/i.test(frag)) return s

			return base + '#' + frag + '&zoom=page-width'
		} catch (e) {
			return url
		}
	}

	$scope.getFileNotes = function (file) {
		if (!file || !file.meta || typeof file.meta !== 'object') return ''
		let meta = file.meta

		// Prefer the notes key for the selected type (if defined).
		if (file.selectedType && $scope.allowedFileTypes && $scope.allowedFileTypes[file.selectedType]) {
			let cfg = $scope.allowedFileTypes[file.selectedType]
			let fields = Array.isArray(cfg.fields) ? cfg.fields : []
			let noteField = fields.find(f => f && f.key && f.type === 'textarea' && /notes/i.test(String(f.key)))
			if (noteField && noteField.key) {
				let val = meta[noteField.key]
				if (typeof val === 'string' && val.trim()) return val.trim()
			}
		}

		// Fallback: common notes keys across schemas.
		let commonKeys = ['photo_notes', 'estimate_notes', 'invoice_notes', 'ins_claim_notes', 'purchase_notes', 'appraisal_notes']
		for (let i = 0; i < commonKeys.length; i++) {
			let k = commonKeys[i]
			let v = meta[k]
			if (typeof v === 'string' && v.trim()) return v.trim()
		}

		// Last resort: any meta key containing "notes".
		try {
			let keys = Object.keys(meta)
			for (let i = 0; i < keys.length; i++) {
				let k = keys[i]
				if (!/notes/i.test(String(k))) continue
				let v = meta[k]
				if (typeof v === 'string' && v.trim()) return v.trim()
			}
		} catch (e) {
			// ignore
		}

		return ''
	}

	$scope.getFileDateAmountParts = function (file) {
		// Prefer the precomputed stable list (prevents $digest loops).
		if (file && Array.isArray(file.dateAmountParts)) return file.dateAmountParts
		return computeDateAmountParts(file)
	}

	$scope.getChipInfoPopoverHtml = function () {
		let keys = Array.isArray($scope.allowedTypeKeys) ? $scope.allowedTypeKeys : []
		if (!keys.length) return ''
		let rows = keys.map(k => {
			let cfg = $scope.allowedFileTypes ? $scope.allowedFileTypes[k] : null
			if (!cfg) return ''
			let name = escapeHtml(cfg.chipName || cfg.label || k)
			let desc = escapeHtml(cfg.chipTooltip || '')
			return (
				`<div class="ep-typespop__row">`
				+ `<div class="ep-typespop__name">${name}</div>`
				+ `<div class="ep-typespop__desc">${desc}</div>`
				+ `</div>`
			)
		}).filter(Boolean).join('')

		return (
			`<div class="ep-typespop__wrap">`
			+ `<div class="ep-typespop__title">File types to upload</div>`
			+ `<div class="ep-typespop__list">${rows}</div>`
			+ `</div>`
		)
	}

	function formatPopoverValue(val) {
		if (val === null || val === undefined) return ''
		// Date objects (or parseable strings) - display in local time
		if (val instanceof Date) return val.toLocaleString()
		if (typeof val === 'string') return val
		if (typeof val === 'number') return String(val)
		if (typeof val === 'boolean') return val ? 'Yes' : 'No'
		try {
			return String(val)
		} catch (e) {
			return ''
		}
	}

	function escapeHtml(str) {
		return String(str || '')
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;')
	}

	function escapeAttr(str) {
		// Conservative attribute escaping (also blocks quotes)
		return escapeHtml(str).replace(/`/g, '&#96;')
	}

	function startEditFile(file) {
		if (!file) return
		// Hide any active tooltip/popover first
		closeAllPopovers()
		if ($scope.pendingFile) {
			// For non-edit pending state, discard and proceed.
			try { $scope.discardPending() } catch (e) { }
			$scope.uiMessage = null
			$scope.pendingMessage = null
			safeApply($scope)
		}

		let idx = $scope.uploadedFiles.findIndex(f => f.id === file.id)
		if (idx < 0) return

		// Keep the item in the list; mark it as editing and load a copy into pending editor.
		let original = $scope.uploadedFiles[idx]
		$window.setTimeout(function () {
			try {
				closeAllPopovers()

				// Clear any stale editing markers and mark this row.
				try {
					$scope.uploadedFiles.forEach(function (f) {
						if (f) f._isEditing = false
					})
				} catch (e) { }
				try { original._isEditing = true } catch (e) { }

				$scope.pendingFile = angular.copy(original)
				$scope.pendingFile.meta = $scope.pendingFile.meta || {}
				$scope.pendingFile._editing = true
				$scope.pendingFile._editOriginalIndex = idx
				$scope.pendingFile._editTargetId = original.id
				$scope.pendingFile._editOriginalFile = angular.copy(original)
				normalizeMetaForFile($scope.pendingFile)
				$scope.pendingMessage = {
					type: 'ok',
					text: 'Editing existing file. Update fields and click Save.'
				}
				safeApply($scope)
			} catch (e) {
				try { console.error('editFile failed:', e) } catch (e2) { }
			}
		}, 0)
	}

	$scope.editFile = function (file) {
		if (!file) return
		// The upload list is hidden while the edit form is open; let it finish first
		if (uploadQueueRunning) return
		if (isEditingActive()) {
			showEditLock('Edit another file', function () { startEditFile(file) })
			return
		}
		startEditFile(file)
	}

	$scope.discardPending = function () {
		if ($scope.pendingFile && $scope.pendingFile._editing && $scope.pendingFile._editOriginalFile) {
			// Cleanup any local preview URLs (e.g., after selecting a replacement PDF)
			try { cleanupPreview($scope.pendingFile) } catch (e) { }
			// Editing existing uploaded file: keep row in the list, just clear highlight.
			try {
				let targetId = $scope.pendingFile._editTargetId
				let idx = $scope.uploadedFiles.findIndex(f => f && f.id === targetId)
				if (idx < 0 && typeof $scope.pendingFile._editOriginalIndex === 'number') idx = $scope.pendingFile._editOriginalIndex
				if (idx >= 0 && $scope.uploadedFiles[idx]) $scope.uploadedFiles[idx]._isEditing = false
			} catch (e) { }
		} else if ($scope.pendingFile) {
			// Discarding a new (non-edit) pending file: cleanup its preview URL.
			cleanupPreview($scope.pendingFile)
		}
		$scope.pendingFile = null
		$scope.pendingMessage = null
	}

	// Cancel edit (Bootstrap tooltip-safe): hide any visible tooltip/popover first,
	// then defer DOM removal to avoid Bootstrap internal state crashes.
	$scope.cancelEdit = function ($event) {
		try {
			if ($event && typeof $event.preventDefault === 'function') $event.preventDefault()
			if ($event && typeof $event.stopPropagation === 'function') $event.stopPropagation()
		} catch (e) { }
		try {
			// Ensure Bootstrap has a chance to hide active overlays before Angular removes elements.
			closeAllPopovers()
		} catch (e) { }
		try {
			if ($event && $event.currentTarget && typeof $event.currentTarget.blur === 'function') $event.currentTarget.blur()
		} catch (e) { }
		$window.setTimeout(function () {
			try { $scope.discardPending() } catch (e) { }
			try { safeApply($scope) } catch (e) { }
		}, 0)
	}

	$scope.browseReplacePdf = function () {
		try {
			if (!$scope.pendingFile || !$scope.pendingFile._editing) return
			// Only meaningful for PDFs
			let kind = String($scope.pendingFile.previewKind || '').toLowerCase()
			let ext = String($scope.pendingFile.detectedExt || '').toLowerCase()
			if (kind !== 'pdf' && ext !== '.pdf') return
			let input = document.getElementById('epReplacePdfInput')
			if (input && typeof input.click === 'function') input.click()
		} catch (e) { }
	}

	$scope.onReplacePdfFilesAdded = function (files) {
		try {
			if (!$scope.pendingFile || !$scope.pendingFile._editing) return
			if (!files || !files.length) return

			let file = files[0]
			if (!file) return

			let ext = getFileExt(file && file.name)
			ext = String(ext || '').toUpperCase()
			if (ext !== 'PDF') {
				$scope.pendingMessage = { type: 'warn', text: 'Please select a PDF file.' }
				safeApply($scope)
				return
			}

			// Replace the pending raw file and update preview
			// Note: we intentionally do NOT auto-save; user can still adjust metadata and click Save.
			try { cleanupPreview($scope.pendingFile) } catch (e) { }
			$scope.pendingFile.rawFile = file
			$scope.pendingFile.name = file.name
			$scope.pendingFile.size = file.size
			$scope.pendingFile.sizeLabel = formatBytes(file.size)
			$scope.pendingFile.detectedExt = '.PDF'
			$scope.pendingFile.previewKind = 'pdf'
			$scope.pendingFile.previewUrl = URL.createObjectURL(file)
			$scope.pendingFile.previewLabel = 'PDF'
			$scope.pendingMessage = { type: 'ok', text: 'New PDF selected. Click Save to upload and replace the existing PDF.' }
			safeApply($scope)
		} catch (e) {
			try { console.error('onReplacePdfFilesAdded failed:', e) } catch (e2) { }
			try {
				$scope.pendingMessage = { type: 'warn', text: 'Unable to select the new PDF. Please try again.' }
				safeApply($scope)
			} catch (e3) { }
		}
	}

	// ---- New uploads: choose what is being uploaded, then an upload list ------------------------------------------
	// Step 1 picks "photo" (any photo type; the file's extension decides PHOTO / PHOTOS_PDF / PHOTOS_DOCX) or one
	// document type. Step 2 adds files of that kind to $scope.uploadQueue, where each file gets its own questions,
	// then they upload one at a time with progress, cancel and retry. Saved files move to the Uploaded files list.
	const UPLOAD_MAX_BYTES = 25 * 1024 * 1024 // the server's limit (multer in server/config/routes.js)
	const UPLOAD_QUEUE_MAX = 100
	const PHOTO_IMAGE_EXTS = ['jpg', 'jpeg', 'png', 'heic']
	// Files whose photos can be taken out (PHOTOS_PDF / PHOTOS_DOCX)
	const PHOTO_SOURCE_EXTS = ['pdf', 'docx']
	const UPLOAD_MIME_BY_EXT = {
		jpg: 'image/jpeg',
		jpeg: 'image/jpeg',
		png: 'image/png',
		heic: 'image/heic',
		pdf: 'application/pdf',
		docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
		xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
	}

	$scope.uploadChoice = null
	$scope.uploadQueue = []
	$scope.uploadRejects = []
	$scope.uploadDoneMessage = null
	let uploadQueueRunning = false
	// PDF / Word files of photos whose photos were taken out into the list (so the same file isn't added twice)
	$scope.photoSources = []

	// Wizard: with two or more photos, or two or more documents, in the list, their questions are shown one file at a
	// time (wizardItems, in list order, swiped / stepped through with queueWizard.index); every other file stays in the
	// plain list. A document in the wizard also has its type confirmed (needsTypeConfirm).
	$scope.wizardItems = []
	$scope.queueOthers = []
	$scope.queueWizard = { index: 0 }
	let wizardFocusId = null // a newly added file to show once the list is rebuilt

	// Rebuilt when files are added / removed or a file's type changes (the AI found a photo is a document)
	$scope.$watch(function () {
		return $scope.uploadQueue.map(function (item) { return item ? item.id + ':' + item.selectedType : '' }).join('|')
	}, function () {
		let photos = $scope.uploadQueue.filter(function (item) { return item && item.selectedType === 'PHOTO' })
		let documents = $scope.uploadQueue.filter(function (item) { return item && isDocumentTypeKey(item.selectedType) })
		$scope.wizardItems = $scope.uploadQueue.filter(function (item) {
			return (photos.length > 1 && photos.indexOf(item) !== -1) || (documents.length > 1 && documents.indexOf(item) !== -1)
		})
		$scope.queueOthers = $scope.uploadQueue.filter(function (item) { return $scope.wizardItems.indexOf(item) === -1 })
		// (the type picker on a document's slide shows its current type)
		$scope.uploadQueue.forEach(function (item) { if (item) item.typePick = item.selectedType })
		// ("Fill in later"'s Undo goes once its photos have all left the list)
		if ($scope.photoFillLater && !$scope.photoFillLater.changes.some(function (c) { return isQueueItemStillListed(c.item) })) $scope.photoFillLater = null

		let index = $scope.queueWizard.index
		if (wizardFocusId) {
			let focus = $scope.wizardItems.findIndex(function (item) { return item.id === wizardFocusId })
			if (focus > -1) index = focus
			wizardFocusId = null
		}
		$scope.queueWizard.index = Math.max(0, Math.min(index, $scope.wizardItems.length - 1))

		// Forget a source once none of its photos are left in the list (it can then be added again)
		$scope.photoSources = $scope.photoSources.filter(function (source) {
			return $scope.uploadQueue.some(function (item) { return item && item.source === source })
		})
	})

	$scope.wizardGoTo = function (index) {
		if (typeof index !== 'number' || index < 0 || index >= $scope.wizardItems.length) return
		$scope.queueWizard.index = index
	}

	$scope.getWizardReadyCount = function () {
		return $scope.wizardItems.filter(function (item) { return $scope.getQueueItemState(item) === 'ready' }).length
	}

	// What the wizard holds: 'photo', 'document' or 'file' (both) - "Photo 2 of 5", "Remove all documents"
	$scope.getWizardNoun = function (plural) {
		let hasPhotos = $scope.wizardItems.some(function (item) { return isPhotoTypeKey(item.selectedType) })
		let hasDocuments = $scope.wizardItems.some(function (item) { return isDocumentTypeKey(item.selectedType) })
		let noun = (hasPhotos && hasDocuments) ? 'file' : (hasDocuments ? 'document' : 'photo')
		return plural ? noun + 's' : noun
	}

	function isDocumentTypeKey(typeKey) {
		let cfg = typeKey && $scope.allowedFileTypes ? $scope.allowedFileTypes[typeKey] : null
		return !!(cfg && cfg.kind === 'document')
	}

	$scope.isDocumentQueueItem = function (item) {
		return !!(item && isDocumentTypeKey(item.selectedType))
	}

	// A document in the wizard (two or more in the list) is uploaded only once its type is confirmed - the AI's pick
	// ("Confirm type") or one chosen in its type picker
	function needsTypeConfirm(item) {
		return !!(item && isDocumentTypeKey(item.selectedType) && !item.typeConfirmed && $scope.wizardItems.indexOf(item) !== -1)
	}
	$scope.needsTypeConfirm = needsTypeConfirm

	// The AI is still reading the file (its type and answers may change)
	$scope.isQueueItemReading = function (item) {
		return !!(item && item.aiFill && (item.aiFill.state === 'reading' || item.aiFill.state === 'checking'))
	}

	function getTypeKeysOfKind(kind) {
		return Object.keys($scope.allowedFileTypes || {}).filter(function (k) {
			return $scope.allowedFileTypes[k] && $scope.allowedFileTypes[k].kind === kind
		})
	}

	function isPhotoTypeKey(typeKey) {
		let cfg = typeKey && $scope.allowedFileTypes ? $scope.allowedFileTypes[typeKey] : null
		return !!(cfg && cfg.kind === 'photo')
	}

	// The content types a choice covers: every photo type for 'photo', otherwise the one document type
	function getTypeKeysForChoice(choice) {
		if (choice === 'photo') return getTypeKeysOfKind('photo')
		return (choice && $scope.allowedFileTypes && $scope.allowedFileTypes[choice]) ? [choice] : []
	}

	function getAllowedExtsForChoice(choice) {
		let exts = []
		getTypeKeysForChoice(choice).forEach(function (k) {
			let list = Array.isArray($scope.allowedFileTypes[k].allowedFileTypes) ? $scope.allowedFileTypes[k].allowedFileTypes : []
			list.forEach(function (e) {
				e = String(e || '').toLowerCase()
				if (e && exts.indexOf(e) === -1) exts.push(e)
			})
		})
		return exts
	}

	// Which content type a file of this extension saves as, for the choice (null when the choice doesn't take it)
	function getTypeKeyForChoiceAndExt(choice, ext) {
		let e = String(ext || '').toLowerCase()
		let keys = getTypeKeysForChoice(choice)
		for (let i = 0; i < keys.length; i++) {
			let list = $scope.allowedFileTypes[keys[i]].allowedFileTypes || []
			if (list.indexOf(e) !== -1) return keys[i]
		}
		return null
	}

	$scope.documentTypeKeys = getTypeKeysOfKind('document')

	$scope.getUploadChoiceLabel = function (choice) {
		if (choice === 'photo') return 'Condition Photos'
		let cfg = (choice && $scope.allowedFileTypes) ? $scope.allowedFileTypes[choice] : null
		return cfg ? String(cfg.pickerLabel || cfg.label || choice) : ''
	}

	$scope.getUploadChoiceHint = function (typeKey) {
		let cfg = (typeKey && $scope.allowedFileTypes) ? $scope.allowedFileTypes[typeKey] : null
		let hint = cfg && cfg.pickerHint ? String(cfg.pickerHint) : ''
		let year = $scope.evidenceYear || (new Date()).getFullYear()
		return hint.replace('{tax_year}', String(year))
	}

	$scope.getUploadChoiceExtsLabel = function (choice) {
		return getAllowedExtsForChoice(choice)
			.filter(function (e) { return e !== 'jpeg' })
			.map(function (e) { return e.toUpperCase() })
			.join(', ')
	}

	$scope.getUploadChoiceAccept = function (choice) {
		let parts = []
		getAllowedExtsForChoice(choice).forEach(function (e) {
			parts.push('.' + e)
			if (UPLOAD_MIME_BY_EXT[e] && parts.indexOf(UPLOAD_MIME_BY_EXT[e]) === -1) parts.push(UPLOAD_MIME_BY_EXT[e])
		})
		return parts.join(',')
	}

	$scope.chooseUpload = function (choice) {
		if (!getTypeKeysForChoice(choice).length) return
		$scope.uploadChoice = choice
		$scope.uploadRejects = []
		$scope.uploadDoneMessage = null
		$scope.uiMessage = null
	}

	// Files dropped on a card in "What are you uploading?": choose that card, then add them
	$scope.dropOnUploadChoice = function (choice, files) {
		if (!files || !files.length || uploadQueueRunning) return
		$scope.chooseUpload(choice)
		if ($scope.uploadChoice !== choice) return
		$scope.onUploadFilesAdded(files)
	}

	// Files already in the list keep the type they were added as
	$scope.changeUploadChoice = function () {
		if (uploadQueueRunning) return
		$scope.uploadChoice = null
		$scope.uploadRejects = []
	}

	$scope.dismissUploadRejects = function () {
		$scope.uploadRejects = []
	}

	// -- Condition Notes ----------------------------------------------------------------------------------------
	// The owner's own description of the property's condition (Upload evidence > Condition Notes), one per property
	// and evidence year (conditionNotesModel). Written in Summernote with basic formatting; saved a moment after they
	// stop typing, with Save notes / Back / switching properties saving right away. The server cleans the HTML.
	const CONDITION_NOTES_AUTOSAVE_MS = 1500
	$scope.conditionNotesMaxLength = 10000
	$scope.conditionNotes = {
		open: false,
		loading: false,
		saving: false,
		closing: false,
		error: null,
		html: '',
		savedHtml: '',
		updatedAt: null,
		propId: null
	}
	let _conditionNotesTimer = null
	let _conditionNotesSavePromise = null
	let _conditionNotesLoadToken = 0

	// Summernote's empty editor is "<p><br></p>"; anything without text counts as empty
	// (parsed, not rendered, so nothing in it runs; recent results are kept since the template asks often)
	let _conditionNotesTextCache = new Map()
	function conditionNotesText(html) {
		let src = String(html || '')
		if (_conditionNotesTextCache.has(src)) return _conditionNotesTextCache.get(src)
		let text = ''
		try {
			let doc = new DOMParser().parseFromString(src.replace(/<br\s*\/?>/gi, '\n').replace(/<\/(p|div|li|h3|h4|blockquote)>/gi, '\n'), 'text/html')
			text = String((doc.body && doc.body.textContent) || '').replace(/\u00a0/g, ' ').trim()
		} catch (e) {
			text = src.replace(/<[^>]*>/g, '').trim()
		}
		if (_conditionNotesTextCache.size > 8) _conditionNotesTextCache.clear()
		_conditionNotesTextCache.set(src, text)
		return text
	}

	function normalizeConditionNotesHtml(html) {
		return conditionNotesText(html) ? String(html || '').trim() : ''
	}

	function isConditionNotesDirty() {
		let n = $scope.conditionNotes
		return normalizeConditionNotesHtml(n.html) !== normalizeConditionNotesHtml(n.savedHtml)
	}

	function getConditionNotesEditor() {
		if (!$window || !$window.$ || !$window.$.fn || typeof $window.$.fn.summernote !== 'function') return null
		let el = $window.$('#epConditionNotesEditor')
		return (el && el.length) ? el : null
	}

	function destroyConditionNotesEditor() {
		try {
			let el = getConditionNotesEditor()
			if (el && el.data('summernote')) el.summernote('destroy')
		} catch (e) { }
	}

	function initConditionNotesEditor() {
		$window.setTimeout(function () {
			let el = getConditionNotesEditor()
			if (!el) {
				if (!$scope.conditionNotes.open) return
				$scope.conditionNotes.error = 'The editor could not be loaded. Please reload the page.'
				safeApply($scope)
				return
			}
			try {
				destroyConditionNotesEditor()
				el.summernote({
					height: $scope.isMobile ? 220 : 300,
					dialogsInBody: true,
					disableDragAndDrop: true,
					placeholder: 'Describe the condition of the property…',
					toolbar: [
						['style', ['bold', 'italic', 'underline']],
						['para', ['ul', 'ol']],
						['misc', ['undo', 'redo']]
					],
					callbacks: {
						onChange: function (contents) {
							$scope.conditionNotes.html = String(contents || '')
							$scope.conditionNotes.error = null
							scheduleConditionNotesAutosave()
							safeApply($scope)
						},
						// No pictures in the notes (photos are uploaded as Condition Photos)
						onImageUpload: function () { }
					}
				})
				el.summernote('code', $scope.conditionNotes.html || '')
				$scope.conditionNotes.html = String(el.summernote('code') || '')
				$scope.conditionNotes.savedHtml = $scope.conditionNotes.html
			} catch (e) {
				$scope.conditionNotes.error = 'The editor could not be loaded. Please reload the page.'
				safeApply($scope)
			}
		}, 0)
	}

	function scheduleConditionNotesAutosave() {
		if (_conditionNotesTimer) $window.clearTimeout(_conditionNotesTimer)
		_conditionNotesTimer = $window.setTimeout(function () {
			_conditionNotesTimer = null
			$scope.saveConditionNotes()
		}, CONDITION_NOTES_AUTOSAVE_MS)
	}

	$scope.loadConditionNotes = async function () {
		let token = ++_conditionNotesLoadToken
		let n = $scope.conditionNotes
		let p = getActiveParams()
		n.html = ''
		n.savedHtml = ''
		n.updatedAt = null
		n.error = null
		n.propId = p && p.prop_id ? p.prop_id : null
		if (!p || !p.user_id || !p.user_token || !p.prop_id) return
		n.loading = true
		try {
			let resp = await systemService.functionCall({ type: 'loadConditionNotes', params: { user_id: p.user_id, user_token: p.user_token, prop_id: p.prop_id } })
			if (token !== _conditionNotesLoadToken) return
			let payload = resp && resp.data ? resp.data : null
			if (!payload || payload.success === false) {
				n.error = (payload && payload.error) ? String(payload.error) : 'Your condition notes could not be loaded.'
			} else {
				n.html = n.savedHtml = String((payload.data && payload.data.notes_html) || '')
				n.updatedAt = (payload.data && payload.data.notes_updated_at) || null
			}
		} catch (e) {
			if (token !== _conditionNotesLoadToken) return
			n.error = 'Your condition notes could not be loaded.'
		}
		n.loading = false
		if (n.open) {
			let el = getConditionNotesEditor()
			if (el && el.data('summernote')) {
				el.summernote('code', n.html || '')
				n.html = n.savedHtml = String(el.summernote('code') || '')
			}
		}
		safeApply($scope)
	}

	// Resolves once the notes on screen are saved (or there was nothing to save); false if the save failed
	$scope.saveConditionNotes = function () {
		let n = $scope.conditionNotes
		if (_conditionNotesTimer) {
			$window.clearTimeout(_conditionNotesTimer)
			_conditionNotesTimer = null
		}
		if (_conditionNotesSavePromise) {
			// Save again after the one in flight, in case they kept typing
			return _conditionNotesSavePromise.then(function () { return isConditionNotesDirty() ? $scope.saveConditionNotes() : true })
		}
		if (!isConditionNotesDirty() || n.loading) return Promise.resolve(true)
		if (conditionNotesText(n.html).length > $scope.conditionNotesMaxLength) {
			n.error = 'Your notes are longer than ' + $scope.conditionNotesMaxLength.toLocaleString('en-US') + ' characters. Please shorten them so they can be saved.'
			safeApply($scope)
			return Promise.resolve(false)
		}
		let p = getActiveParams()
		if (!p || !p.user_id || !p.user_token || String(p.prop_id) !== String(n.propId)) return Promise.resolve(false)
		let html = normalizeConditionNotesHtml(n.html)
		n.saving = true
		n.error = null
		safeApply($scope)
		_conditionNotesSavePromise = systemService.functionCall({
			type: 'saveConditionNotes',
			params: { user_id: p.user_id, user_token: p.user_token, prop_id: n.propId, notes_html: html }
		}).then(function (resp) {
			let payload = resp && resp.data ? resp.data : null
			if (!payload || payload.success === false) {
				n.error = (payload && payload.error) ? String(payload.error) : 'Your condition notes could not be saved. Please try again.'
				return false
			}
			n.savedHtml = html
			n.updatedAt = (payload.data && payload.data.notes_updated_at) || new Date().toISOString()
			notifyReviewToolPortalChanged('condition-notes')
			return true
		}, function () {
			n.error = 'Your condition notes could not be saved. Please check your connection and try again.'
			return false
		}).then(function (ok) {
			_conditionNotesSavePromise = null
			n.saving = false
			safeApply($scope)
			return ok
		})
		return _conditionNotesSavePromise
	}

	$scope.openConditionNotes = function () {
		let n = $scope.conditionNotes
		n.open = true
		$scope.uiMessage = null
		$scope.uploadDoneMessage = null
		initConditionNotesEditor()
	}

	// Back to the picker once the notes are saved; if the save fails they stay open with the error
	$scope.closeConditionNotes = async function () {
		let n = $scope.conditionNotes
		if (n.closing) return
		n.closing = true
		let ok = await $scope.saveConditionNotes()
		n.closing = false
		if (ok === false && isConditionNotesDirty()) {
			safeApply($scope)
			return
		}
		destroyConditionNotesEditor()
		n.open = false
		n.error = null
		n.pendingImport = null
		n.importNote = null
		safeApply($scope)
	}

	// A .txt or Word (.docx) file dropped on Condition Notes (or picked with "Import a file"): its text goes in the
	// editor. With notes already written they choose to replace them or add the text at the bottom (pendingImport).
	const CONDITION_NOTES_IMPORT_MAX_BYTES = 5 * 1024 * 1024
	$scope.dropOnConditionNotes = function (files) {
		importConditionNotesFile(files)
	}

	$scope.browseConditionNotesFile = function () {
		let input = document.getElementById('epConditionNotesFileInput')
		if (input) input.click()
	}

	$scope.onConditionNotesFilePicked = function (files) {
		importConditionNotesFile(files)
	}

	function textToNotesHtml(text) {
		let escape = function (s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;') }
		let lines = String(text || '').replace(/\r\n?/g, '\n').split('\n').map(function (l) { return l.replace(/\t/g, '    ').replace(/\s+$/, '') })
		let html = lines.filter(function (l) { return l.trim() !== '' }).map(function (l) { return '<p>' + escape(l) + '</p>' }).join('')
		return html
	}

	function readFileAsText(file) {
		return new Promise(function (resolve, reject) {
			let reader = new FileReader()
			reader.onload = function () { resolve(String(reader.result || '')) }
			reader.onerror = function () { reject(reader.error) }
			reader.readAsText(file)
		})
	}

	// The editor once it's open and the saved notes are in it
	async function waitForConditionNotesEditor() {
		for (let i = 0; i < 100; i++) {
			let el = getConditionNotesEditor()
			if (el && el.data('summernote') && !$scope.conditionNotes.loading) return el
			await new Promise(function (r) { $window.setTimeout(r, 50) })
		}
		return null
	}

	async function importConditionNotesFile(files) {
		let n = $scope.conditionNotes
		if (!files || !files.length) return
		if (!n.open) $scope.openConditionNotes()
		n.pendingImport = null
		n.importNote = null
		let file = files[0]
		let name = file.name || 'the file'
		let ext = String(getFileExt(name) || '').toLowerCase()
		if (files.length > 1) n.importNote = 'Condition Notes takes one file at a time, so only ' + name + ' was used.'
		if (ext !== 'txt' && ext !== 'docx') {
			n.error = name + ' can\'t be used here. Drop a .txt or Word (.docx) file.'
			safeApply($scope)
			return
		}
		if (file.size > CONDITION_NOTES_IMPORT_MAX_BYTES) {
			n.error = name + ' is too large (5 MB at most).'
			safeApply($scope)
			return
		}
		n.importing = true
		n.error = null
		safeApply($scope)
		let text = ''
		try {
			if (ext === 'txt') {
				text = await readFileAsText(file)
			} else {
				let p = getActiveParams()
				let resp = await systemService.functionCall({
					type: 'extractConditionNotesFileText',
					params: { user_id: p.user_id, user_token: p.user_token, prop_id: p.prop_id },
					file: file
				})
				let payload = resp && resp.data ? resp.data : null
				if (!payload || payload.success === false) throw new Error((payload && payload.error) || 'The text in this Word file could not be read.')
				text = String((payload.data && payload.data.text) || '')
			}
		} catch (e) {
			n.importing = false
			n.error = (e && e.message) ? String(e.message) : 'The file could not be read.'
			safeApply($scope)
			return
		}
		let html = textToNotesHtml(text)
		n.importing = false
		if (!html) {
			n.error = 'There is no text in ' + name + '.'
			safeApply($scope)
			return
		}
		let el = await waitForConditionNotesEditor()
		if (!el) {
			n.error = 'The editor could not be loaded. Please reload the page.'
			safeApply($scope)
			return
		}
		if (conditionNotesText(n.html)) {
			n.pendingImport = { name: name, html: html }
			safeApply($scope)
			return
		}
		applyConditionNotesImport(html, false)
	}

	function applyConditionNotesImport(html, append) {
		let n = $scope.conditionNotes
		let el = getConditionNotesEditor()
		if (!el || !el.data('summernote')) return
		let current = normalizeConditionNotesHtml(String(el.summernote('code') || ''))
		el.summernote('code', append && current ? current + html : html)
		n.html = String(el.summernote('code') || '')
		n.pendingImport = null
		n.error = null
		$scope.saveConditionNotes()
		safeApply($scope)
	}

	// The choice when notes are already written: 'replace' / 'append' / anything else to keep them as they are
	$scope.resolveConditionNotesImport = function (choice) {
		let pending = $scope.conditionNotes.pendingImport
		if (!pending) return
		if (choice === 'replace' || choice === 'append') applyConditionNotesImport(pending.html, choice === 'append')
		else $scope.conditionNotes.pendingImport = null
	}

	$scope.canSaveConditionNotes = function () {
		let n = $scope.conditionNotes
		return !n.loading && !n.saving && isConditionNotesDirty()
	}

	$scope.getConditionNotesLength = function () {
		return conditionNotesText($scope.conditionNotes.html).length
	}

	// loading / saving / unsaved / saved / empty / error
	$scope.getConditionNotesState = function () {
		let n = $scope.conditionNotes
		if (n.loading) return 'loading'
		if (n.saving) return 'saving'
		if (n.error && isConditionNotesDirty()) return 'error'
		if (isConditionNotesDirty()) return 'unsaved'
		if (normalizeConditionNotesHtml(n.savedHtml)) return 'saved'
		return 'empty'
	}

	function formatConditionNotesTime(value) {
		let d = value ? new Date(value) : null
		if (!d || isNaN(d.getTime())) return ''
		let sameDay = d.toDateString() === new Date().toDateString()
		return sameDay
			? 'today at ' + d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
			: d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
	}

	$scope.getConditionNotesStatusText = function () {
		let state = $scope.getConditionNotesState()
		if (state === 'loading') return 'Loading your notes…'
		if (state === 'saving') return 'Saving…'
		if (state === 'error') return 'Not saved'
		if (state === 'unsaved') return 'Unsaved changes'
		if (state === 'saved') {
			let when = formatConditionNotesTime($scope.conditionNotes.updatedAt)
			return when ? 'Saved ' + when : 'Saved'
		}
		return 'Nothing written yet'
	}

	// The line under "Condition Notes" in the picker
	$scope.getConditionNotesCardStatus = function () {
		let n = $scope.conditionNotes
		if (n.loading) return 'Loading…'
		if (normalizeConditionNotesHtml(n.savedHtml)) {
			let when = formatConditionNotesTime(n.updatedAt)
			return when ? 'Last saved ' + when : 'Saved'
		}
		return 'Not started'
	}

	$scope.$on('$destroy', function () {
		if (_conditionNotesTimer) $window.clearTimeout(_conditionNotesTimer)
		destroyConditionNotesEditor()
	})

	$scope.isUploadQueueBusy = function () {
		return uploadQueueRunning
	}

	$scope.isQueueItemEditable = function (item) {
		return !!(item && (item.status === 'draft' || item.status === 'failed'))
	}

	function isQueueItemComplete(item) {
		return getMissingRequiredFields(item).length === 0 && !needsTypeConfirm(item)
	}

	function isQueueItemReady(item) {
		return $scope.isQueueItemEditable(item) && isQueueItemComplete(item)
	}

	$scope.getReadyQueueCount = function () {
		return $scope.uploadQueue.filter(isQueueItemReady).length
	}

	$scope.getIncompleteQueueCount = function () {
		return $scope.uploadQueue.filter(function (item) {
			return $scope.isQueueItemEditable(item) && !isQueueItemComplete(item)
		}).length
	}

	$scope.getQueueItemState = function (item) {
		if (!item) return ''
		if (item.status === 'draft') return isQueueItemComplete(item) ? 'ready' : 'needs'
		if (item.status === 'failed') return item.cancelled ? 'cancelled' : 'failed'
		return item.status
	}

	$scope.getQueueItemStatusLabel = function (item) {
		switch ($scope.getQueueItemState(item)) {
			case 'preparing': return item.preparingText || 'Preparing…'
			case 'needs': return (item.aiFill && item.aiFill.state === 'reading') ? 'Reading the document…' : getMissingAnswersText(item)
			case 'ready': return 'Ready to upload'
			case 'uploading': return `Uploading ${item.progress || 0}%`
			case 'processing': return 'Saving…'
			case 'cancelled': return 'Upload cancelled'
			case 'failed': return 'Upload failed'
			default: return ''
		}
	}

	// "Location needs to be answered" / "Location and Issue existed on Jan 1 need to be answered" (a field's
	// shortLabel when it has one)
	function getMissingAnswersText(item) {
		let names = getMissingRequiredFieldDefs(item).map(function (field) { return field.shortLabel || field.label })
		if (needsTypeConfirm(item)) names.unshift('Document type')
		if (names.length === 1 && needsTypeConfirm(item)) return 'Confirm the document type'
		if (!names.length) return 'Needs answers'
		let list = names.length === 1
			? names[0]
			: names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1]
		return `${list} need${names.length === 1 ? 's' : ''} to be answered`
	}

	function getConvertNote(choice, typeKey, ext) {
		if (isPhotoTypeKey(typeKey)) {
			if (typeKey === 'PHOTOS_PDF' || typeKey === 'PHOTOS_DOCX') {
				return 'Tip: photos uploaded one at a time can each be given a location and notes.'
			}
			return ''
		}
		if (PHOTO_IMAGE_EXTS.indexOf(ext) !== -1) return 'This picture will be saved as a PDF.'
		if (ext === 'docx') return 'This Word file will be saved as a PDF.'
		if (ext === 'xlsx') return 'This Excel file will be saved as a PDF.'
		return ''
	}

	// Photos: up to UPLOAD_PHOTOS_PER_ADD at a time; a document type: up to UPLOAD_DOCUMENTS_PER_ADD (two or more go
	// in the wizard, where the AI's pick of each one's type is confirmed)
	const UPLOAD_PHOTOS_PER_ADD = 25
	const UPLOAD_DOCUMENTS_PER_ADD = 10
	$scope.getUploadMaxPerAdd = function (choice) {
		return choice === 'photo' ? UPLOAD_PHOTOS_PER_ADD : UPLOAD_DOCUMENTS_PER_ADD
	}

	$scope.onUploadFilesAdded = function (files) {
		let choice = $scope.uploadChoice
		if (!files || !files.length || !choice) return
		$scope.uploadDoneMessage = null

		let rejects = []
		let choiceLabel = $scope.getUploadChoiceLabel(choice)
		let allowedLabel = $scope.getUploadChoiceExtsLabel(choice)

		let maxPerAdd = $scope.getUploadMaxPerAdd(choice)
		if (files.length > maxPerAdd) {
			let skipped = files.length - maxPerAdd
			rejects.push(`Up to ${maxPerAdd} ${choice === 'photo' ? 'photos' : 'documents'} can be added at a time, so the last ${skipped} ${skipped === 1 ? 'was' : 'were'} not added. Add ${skipped === 1 ? 'it' : 'them'} next.`)
			files = Array.prototype.slice.call(files, 0, maxPerAdd)
		}

		for (let i = 0; i < files.length; i++) {
			let file = files[i]
			if (!file) continue
			let name = file.name || '(unnamed file)'
			let ext = String(getFileExt(name) || '').toLowerCase()
			let typeKey = getTypeKeyForChoiceAndExt(choice, ext)
			// Several documents dropped together are each read by the AI for their type, so one the chosen type can't
			// take (an Excel file dropped on Insurance Claim) starts as a document type that can
			if (!typeKey && files.length > 1 && isDocumentTypeKey(choice)) {
				typeKey = $scope.documentTypeKeys.find(function (k) { return getTypeKeyForChoiceAndExt(k, ext) }) || null
			}

			if (!typeKey) {
				rejects.push(`${name}: ${ext ? 'a .' + ext.toUpperCase() + ' file' : 'this file'} can't be uploaded as ${choiceLabel}. Allowed: ${allowedLabel}.`)
				continue
			}
			if (!file.size) {
				rejects.push(`${name} is empty.`)
				continue
			}
			// Photos are made smaller before upload (checked again after), everything else is sent as it is
			let shrinksBeforeUpload = isPhotoTypeKey(typeKey) && PHOTO_IMAGE_EXTS.indexOf(ext) !== -1
			if (!shrinksBeforeUpload && file.size > UPLOAD_MAX_BYTES) {
				rejects.push(`${name} is ${formatBytes(file.size)}, over the 25 MB limit.`)
				continue
			}
			let duplicate = $scope.uploadQueue.some(function (q) {
				return q && q.originalName === name && q.originalSize === file.size
			}) || $scope.photoSources.some(function (s) {
				return s.name === name && s.file && s.file.size === file.size
			})
			if (duplicate) {
				rejects.push(`${name} is already in the upload list.`)
				continue
			}
			if ($scope.uploadQueue.length >= UPLOAD_QUEUE_MAX) {
				rejects.push(`${name}: the upload list holds ${UPLOAD_QUEUE_MAX} files. Upload these first, then add more.`)
				continue
			}

			let item = {
				id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
				rawFile: file,
				originalName: name,
				originalSize: file.size,
				name: name,
				size: file.size,
				sizeLabel: formatBytes(file.size),
				detectedExt: `.${ext.toUpperCase()}`,
				previewKind: 'file',
				previewUrl: null,
				previewLabel: ext.toUpperCase(),
				selectedType: typeKey,
				typeLabel: '',
				meta: {},
				status: 'preparing',
				progress: 0,
				error: null,
				cancelled: false,
				convertNote: getConvertNote(choice, typeKey, ext),
				// The file as picked (a photo's upload copy is made small; the AI reads this one)
				originalFile: file,
				originalExt: ext
			}
			setTypeLabel(item)
			if (!wizardFocusId && (typeKey === 'PHOTO' || isDocumentTypeKey(typeKey))) wizardFocusId = item.id
			$scope.uploadQueue.push(item)
			prepareQueueItem(item, ext)
		}

		$scope.uploadRejects = rejects
		safeApply($scope)
	}

	function isQueueItemStillListed(item) {
		return $scope.uploadQueue.indexOf(item) !== -1
	}

	// Builds the preview, and for photos makes the upright JPG that is uploaded (same processing as before)
	async function prepareQueueItem(item, ext) {
		let EXT = ext.toUpperCase()
		if (item.selectedType === 'PHOTOS_PDF' || item.selectedType === 'PHOTOS_DOCX') return findPhotosInQueueItem(item, ext)
		try {
			if (isPhotoTypeKey(item.selectedType) && PHOTO_IMAGE_EXTS.indexOf(ext) !== -1) {
				let res = await normalizeImageUploadToJpeg(item.rawFile, EXT)
				if (!isQueueItemStillListed(item)) return
				if (res && res.file) {
					if (res.file.size > UPLOAD_MAX_BYTES) {
						item.error = `This photo is ${formatBytes(res.file.size)}, over the 25 MB limit.`
					}
					item.rawFile = res.file
					item.name = res.file.name
					item.size = res.file.size
					item.sizeLabel = formatBytes(res.file.size)
					item.detectedExt = '.JPG'
					item.previewKind = 'image'
					item.previewUrl = URL.createObjectURL(res.file)
					item.previewLabel = null
				}
			} else if (ext === 'heic') {
				// A HEIC document is uploaded as it is (the server makes the PDF); convert a copy just for the preview
				let res = await normalizeImageUploadToJpeg(item.rawFile, EXT)
				if (!isQueueItemStillListed(item)) return
				if (res && res.file) {
					item.previewKind = 'image'
					item.previewUrl = URL.createObjectURL(res.file)
					item.previewLabel = null
				}
			} else {
				let preview = makePreview(item.rawFile, EXT)
				item.previewKind = preview.kind
				item.previewUrl = preview.url
				item.previewLabel = preview.label
			}
		} catch (e) {
			try { console.error('Upload list: unable to prepare', item.name, e) } catch (e2) { }
			if (!isQueueItemStillListed(item)) return
			item.previewKind = 'file'
			item.previewUrl = null
			item.previewLabel = EXT
			if (isPhotoTypeKey(item.selectedType)) {
				item.error = 'This photo could not be shown here. You can still try to upload it.'
			}
		}
		if (!isQueueItemStillListed(item)) {
			cleanupPreview(item)
			return
		}
		item.status = 'draft'
		safeApply($scope)
		analyzeQueueItem(item)
	}

	// The AI reads a new file in the upload list (prefillPortalDocument): it says whether the file really is the type
	// the homeowner picked - a photo of an estimate added as Photos is an estimate - and answers that type's questions.
	// A different type is applied with a message and "Change back" (applyDetectedType / revertQueueItemType). Only
	// questions still empty are filled - nothing typed meanwhile is replaced - and each filled one is marked for them to
	// check. Every photo taken out of a PDF / Word file is checked too, a few at a time (runAiCheck).
	// item.aiFill: { state: 'reading' (documents) | 'checking' (photos) | 'filled' | 'none' | 'checked' | 'error',
	// values: { key: value } }; item.typeChange: { fromType, toType, reason, snapshot, reverted } (neither is uploaded)
	function analyzeQueueItem(item) {
		if (!item || item.aiTypeChecked) return
		let ext = item.originalExt || String(getFileExt(item.originalName) || '').toLowerCase()
		if (item.selectedType === 'PHOTO' && PHOTO_IMAGE_EXTS.indexOf(ext) === -1) return
		item.aiTypeChecked = true
		runAiCheck(function () {
			// (removed or uploading while it waited)
			if (!isQueueItemStillListed(item) || !$scope.isQueueItemEditable(item)) return
			return prefillQueueItemFromDocument(item, { detect: true })
		})
	}

	// At most AI_CHECK_CONCURRENCY files are read at once (a PDF of 24 photos adds 24 at the same moment)
	const AI_CHECK_CONCURRENCY = 3
	let aiChecksRunning = 0
	let aiChecksWaiting = []
	function runAiCheck(job) {
		aiChecksWaiting.push(job)
		pumpAiChecks()
	}
	function pumpAiChecks() {
		while (aiChecksRunning < AI_CHECK_CONCURRENCY && aiChecksWaiting.length) {
			let job = aiChecksWaiting.shift()
			aiChecksRunning++
			Promise.resolve().then(job).catch(function () { }).then(function () {
				aiChecksRunning--
				pumpAiChecks()
			})
		}
	}

	async function prefillQueueItemFromDocument(item, options) {
		let detect = !!(options && options.detect)
		let isPhoto = isPhotoTypeKey(item.selectedType)
		let askedType = item.selectedType
		item.aiFill = { state: isPhoto ? 'checking' : 'reading', values: {} }
		safeApply($scope)
		// A photo is read from the file they picked (the upload copy is made small); a document is sent as it is
		let file = item.rawFile
		let ext = String(item.detectedExt || '').replace('.', '')
		if (isPhoto && item.originalFile && item.originalFile.size <= UPLOAD_MAX_BYTES) {
			file = item.originalFile
			ext = item.originalExt || ext
		}
		let payload = null
		try {
			let resp = await systemService.functionCall({
				type: 'prefillPortalDocument',
				params: getActiveParams(),
				file: file,
				portalFile: { name: item.name, detectedExt: '.' + String(ext).toUpperCase(), selectedType: askedType, detect: detect }
			})
			payload = resp && resp.data ? resp.data : null
		} catch (e) {
			payload = null
		}
		if (!isQueueItemStillListed(item)) return
		let data = (payload && payload.success && payload.data) ? payload.data : null
		let values = (data && data.values) ? data.values : null
		// Uploading already, or the type changed meanwhile: leave it as it is
		if (!values || !$scope.isQueueItemEditable(item) || item.selectedType !== askedType) {
			item.aiFill.state = values ? (isPhoto ? 'checked' : 'none') : 'error'
			safeApply($scope)
			return
		}
		let detected = data.detected_type ? String(data.detected_type) : null
		// Why the AI thinks it's the type it picked (shown where a document's type is confirmed)
		if (detect) item.aiTypeReason = data.detected_reason ? String(data.detected_reason) : null
		// A PDF / Word file added as a document that is really photos of the property: offer to take the photos out
		// (takePhotosOutOfQueueItem) rather than change it, since that replaces the file with its photos
		if (detected === 'PHOTO' && !isPhoto && PHOTO_SOURCE_EXTS.indexOf(ext) !== -1) {
			item.photoSuggestion = { reason: item.aiTypeReason }
			item.aiFill.state = 'photos'
			safeApply($scope)
			return
		}
		if (detected && detected !== askedType && $scope.allowedFileTypes[detected]) {
			let applied = await applyDetectedType(item, detected, values, data.detected_reason)
			if (applied) return
		}
		let filled = fillEmptyFieldsFromValues(item, values)
		item.aiFill.values = filled
		item.aiFill.state = Object.keys(filled).length ? 'filled' : (isPhotoTypeKey(item.selectedType) ? 'checked' : 'none')
		safeApply($scope)
	}

	// Fills the item's empty questions from the AI's answers; returns what was filled
	function fillEmptyFieldsFromValues(item, values) {
		let cfg = $scope.allowedFileTypes[item.selectedType]
		let fields = (cfg && Array.isArray(cfg.fields)) ? cfg.fields : []
		let filled = {}
		// Selects first, so an "(other)" box shows before it's filled
		fields.slice().sort(function (a, b) { return (a.type === 'select' ? 0 : 1) - (b.type === 'select' ? 0 : 1) }).forEach(function (field) {
			if (!field || !values || !Object.prototype.hasOwnProperty.call(values, field.key)) return
			if (!isBlankMetaValue(item.meta[field.key])) return
			if (!shouldShowField(item, field)) return
			let value = toPrefillMetaValue(field, values[field.key])
			if (value === null) return
			item.meta[field.key] = value
			filled[field.key] = value
		})
		return filled
	}

	// "Condition Photos", "Estimate of Repair Costs" ... as in the upload picker
	$scope.getTypeDisplayName = function (typeKey) {
		if (isPhotoTypeKey(typeKey)) return 'Condition Photos'
		let cfg = $scope.allowedFileTypes[typeKey]
		return cfg ? String(cfg.pickerLabel || cfg.label || typeKey) : String(typeKey || '')
	}

	// Answers that mean the same thing in two types: the same question, or the type's notes / its only date / its only
	// amount (an estimate's amount becomes the invoice's amount, a photo's notes the document's notes)
	function carryOverAnswers(fromType, meta, toType) {
		let fromCfg = $scope.allowedFileTypes[fromType]
		let toCfg = $scope.allowedFileTypes[toType]
		let fromFields = (fromCfg && Array.isArray(fromCfg.fields)) ? fromCfg.fields : []
		let toFields = (toCfg && Array.isArray(toCfg.fields)) ? toCfg.fields : []
		function role(field, fields) {
			if (/_notes$/.test(field.key)) return 'notes'
			if ((field.type === 'date' || field.type === 'amount') && fields.filter(function (f) { return f.type === field.type }).length === 1) return field.type
			return null
		}
		let result = {}
		toFields.forEach(function (to) {
			let same = fromFields.find(function (f) { return f.key === to.key })
			let r = role(to, toFields)
			let from = same || (r ? fromFields.find(function (f) { return role(f, fromFields) === r }) : null)
			if (from && meta && !isBlankMetaValue(meta[from.key])) result[to.key] = meta[from.key]
		})
		return result
	}

	const TYPE_CHANGE_FILE_KEYS = ['rawFile', 'name', 'size', 'sizeLabel', 'detectedExt', 'error']

	// The AI found the file is another type: switch to it (a photo becoming a document uploads the file they picked, not
	// the small photo copy, and the server saves it as a PDF), carry over answers that apply, fill in the new questions,
	// and keep what it was so "Change back" can restore it. False when the switch can't be made.
	async function applyDetectedType(item, toType, values, reason) {
		let fromType = item.selectedType
		let snapshot = { selectedType: fromType, meta: angular.copy(item.meta), convertNote: item.convertNote, file: {} }
		TYPE_CHANGE_FILE_KEYS.forEach(function (k) { snapshot.file[k] = item[k] })
		if (!(await switchQueueItemType(item, toType))) return false
		let filled = fillEmptyFieldsFromValues(item, values)
		item.aiFill = { state: Object.keys(filled).length ? 'filled' : (isPhotoTypeKey(toType) ? 'checked' : 'none'), values: filled }
		item.typeChange = { fromType: fromType, toType: toType, reason: reason || '', snapshot: snapshot, reverted: false }
		safeApply($scope)
		return true
	}

	// Changes a file's type: its upload file (a photo becoming a document uploads the file they picked, not the small
	// photo copy; a picture becoming a photo gets its small upright copy), the answers that carry over, its label and
	// its conversion note. False when the file can't be that type.
	async function switchQueueItemType(item, toType) {
		let fromType = item.selectedType
		let ext = item.originalExt || String(item.detectedExt || '').replace('.', '').toLowerCase()
		let toCfg = $scope.allowedFileTypes[toType]
		let toIsPhoto = isPhotoTypeKey(toType)
		let fromIsPhoto = isPhotoTypeKey(fromType)
		if (!toIsPhoto && toCfg && Array.isArray(toCfg.allowedFileTypes) && toCfg.allowedFileTypes.indexOf(ext) === -1) return false
		if (fromIsPhoto && !toIsPhoto && fromType === 'PHOTO') {
			if (item.originalFile && item.originalFile.size <= UPLOAD_MAX_BYTES) {
				item.rawFile = item.originalFile
				item.name = item.originalName
				item.size = item.originalFile.size
				item.sizeLabel = formatBytes(item.size)
				item.detectedExt = '.' + ext.toUpperCase()
			}
			item.error = null
		} else if (!fromIsPhoto && toIsPhoto) {
			if (PHOTO_IMAGE_EXTS.indexOf(ext) === -1) return false
			try {
				let res = await normalizeImageUploadToJpeg(item.originalFile || item.rawFile, ext.toUpperCase())
				if (!res || !res.file) return false
				if (!isQueueItemStillListed(item) || !$scope.isQueueItemEditable(item) || item.selectedType !== fromType) return false
				item.rawFile = res.file
				item.name = res.file.name
				item.size = res.file.size
				item.sizeLabel = formatBytes(res.file.size)
				item.detectedExt = '.JPG'
			} catch (e) {
				return false
			}
		}
		item.meta = carryOverAnswers(fromType, item.meta, toType)
		item.selectedType = toType
		setTypeLabel(item)
		item.convertNote = getConvertNote(null, toType, ext)
		return true
	}

	function getQueueItemExt(item) {
		return item ? (item.originalExt || String(item.detectedExt || '').replace('.', '').toLowerCase()) : ''
	}

	// The types a document's type picker offers: every document type that takes its kind of file, and Condition Photos
	// for a picture, or for a PDF / Word file (its photos are then taken out)
	$scope.getQueueItemTypeOptions = function (item) {
		let ext = getQueueItemExt(item)
		let keys = ($scope.documentTypeKeys || []).filter(function (k) {
			let list = $scope.allowedFileTypes[k] && $scope.allowedFileTypes[k].allowedFileTypes
			return Array.isArray(list) && list.indexOf(ext) !== -1
		})
		if (PHOTO_IMAGE_EXTS.indexOf(ext) !== -1 || PHOTO_SOURCE_EXTS.indexOf(ext) !== -1) keys.push('PHOTO')
		return keys
	}

	$scope.getQueueItemTypeOptionLabel = function (item, typeKey) {
		if (typeKey === 'PHOTO' && PHOTO_SOURCE_EXTS.indexOf(getQueueItemExt(item)) !== -1) return 'Condition Photos (take the photos out)'
		return $scope.getTypeDisplayName(typeKey)
	}

	// What happens to the file when it's uploaded: saved as it is, or converted to a PDF by the server
	$scope.getQueueItemConversion = function (item) {
		let ext = getQueueItemExt(item)
		if (ext === 'pdf') return { converts: false, text: 'PDF - no conversion needed.' }
		if (PHOTO_IMAGE_EXTS.indexOf(ext) !== -1) return { converts: true, text: 'Picture - converted to a PDF when it is uploaded.' }
		if (ext === 'docx') return { converts: true, text: 'Word file - converted to a PDF when it is uploaded.' }
		if (ext === 'xlsx') return { converts: true, text: 'Excel file - converted to a PDF when it is uploaded.' }
		return { converts: false, text: '' }
	}

	// "Confirm type": the document's type (the AI's pick) is confirmed
	$scope.confirmQueueItemType = function (item) {
		if (!item || !$scope.isQueueItemEditable(item) || !isDocumentTypeKey(item.selectedType)) return
		if (item.photoSuggestion) $scope.keepQueueItemAsDocument(item)
		item.typeConfirmed = true
	}

	// A type chosen in the document's type picker (item.typePick): switch to it, which also confirms it, and have the
	// AI fill in the new type's questions from the file. Condition Photos for a PDF / Word file takes its photos out.
	$scope.changeQueueItemType = async function (item) {
		if (!item) return
		let toType = item.typePick
		if (!toType || toType === item.selectedType || !$scope.isQueueItemEditable(item) || !$scope.allowedFileTypes[toType]) {
			item.typePick = item.selectedType
			return
		}
		if (toType === 'PHOTO' && PHOTO_SOURCE_EXTS.indexOf(getQueueItemExt(item)) !== -1) {
			$scope.takePhotosOutOfQueueItem(item)
			return
		}
		let ok = await switchQueueItemType(item, toType)
		if (!ok) {
			item.typePick = item.selectedType
			safeApply($scope)
			return
		}
		item.typeChange = null
		item.photoSuggestion = null
		item.aiTypeReason = null
		item.typeConfirmed = true
		item.aiFill = null
		if (isDocumentTypeKey(toType)) prefillQueueItemFromDocument(item, { detect: false })
		safeApply($scope)
	}

	// The AI found a PDF / Word file is photos of the property (or they chose Condition Photos for it): take its photos
	// out, as when it's added as Photos (findPhotosInQueueItem). With none found it stays one file, uploaded as photos.
	$scope.takePhotosOutOfQueueItem = function (item) {
		if (!item || !$scope.isQueueItemEditable(item)) return
		let ext = getQueueItemExt(item)
		let toType = ext === 'pdf' ? 'PHOTOS_PDF' : (ext === 'docx' ? 'PHOTOS_DOCX' : null)
		if (!toType || !$scope.allowedFileTypes[toType]) return
		cleanupPreview(item)
		item.selectedType = toType
		setTypeLabel(item)
		item.meta = {}
		item.aiFill = null
		item.typeChange = null
		item.photoSuggestion = null
		item.aiTypeReason = null
		item.convertNote = null
		item.error = null
		item.status = 'preparing'
		wizardFocusId = null
		findPhotosInQueueItem(item, ext)
	}

	// "Keep as one document": the AI's photos suggestion is set aside, and it reads the file for the chosen type's answers
	$scope.keepQueueItemAsDocument = function (item) {
		if (!item || !item.photoSuggestion) return
		item.photoSuggestion = null
		if ($scope.isQueueItemEditable(item) && isDocumentTypeKey(item.selectedType)) prefillQueueItemFromDocument(item, { detect: false })
	}

	// The PDF shown on a document's wizard slide (made once per preview)
	$scope.getQueueItemPdfSrc = function (item) {
		if (!item || !item.previewUrl) return null
		if (item.pdfSrcFor !== item.previewUrl) {
			item.pdfSrc = $sce.trustAsResourceUrl(applyPdfPreviewViewerHints(item.previewUrl))
			item.pdfSrcFor = item.previewUrl
		}
		return item.pdfSrc
	}

	$scope.getQueueItemFileIcon = function (item) {
		let ext = getQueueItemExt(item)
		if (ext === 'docx') return 'fa-file-word'
		if (ext === 'xlsx') return 'fa-file-excel'
		if (ext === 'pdf') return 'fa-file-pdf'
		return 'fa-file'
	}

	// "Change back to …": the type they picked, with its file and answers, updated with answers given since that apply;
	// a document type then gets its own questions filled in from the file
	$scope.revertQueueItemType = function (item) {
		let tc = item && item.typeChange
		if (!tc || tc.reverted || !$scope.isQueueItemEditable(item)) return
		let currentType = item.selectedType
		let carried = carryOverAnswers(currentType, item.meta, tc.fromType)
		TYPE_CHANGE_FILE_KEYS.forEach(function (k) { item[k] = tc.snapshot.file[k] })
		item.selectedType = tc.fromType
		setTypeLabel(item)
		item.convertNote = tc.snapshot.convertNote
		let meta = angular.copy(tc.snapshot.meta) || {}
		// (what they answered since is the newer answer)
		Object.keys(carried).forEach(function (k) { meta[k] = carried[k] })
		item.meta = meta
		item.aiFill = null
		tc.reverted = true
		if (!isPhotoTypeKey(item.selectedType)) prefillQueueItemFromDocument(item, { detect: false })
		safeApply($scope)
	}

	function isBlankMetaValue(value) {
		return value === null || value === undefined || (typeof value === 'string' && value.trim() === '')
	}

	// The server's answer in the form the field's input uses (a date input wants a local-midnight Date)
	function toPrefillMetaValue(field, raw) {
		if (raw === null || raw === undefined || raw === '') return null
		if (field.type === 'date') {
			let m = String(raw).match(/^(\d{4})-(\d{2})-(\d{2})$/)
			return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null
		}
		if (field.type === 'amount') {
			let n = Number(raw)
			return Number.isFinite(n) ? n : null
		}
		return String(raw)
	}

	// The answer is still the one read from the document (marked "From your document" until they change it)
	$scope.isAiFilledField = function (item, field) {
		if (!item || !item.aiFill || !field || !item.aiFill.values || !Object.prototype.hasOwnProperty.call(item.aiFill.values, field.key)) return false
		let filled = item.aiFill.values[field.key]
		let current = item.meta ? item.meta[field.key] : null
		if (filled instanceof Date) return current instanceof Date && current.getTime() === filled.getTime()
		return String(current) === String(filled)
	}

	$scope.getAiFilledCount = function (item) {
		if (!item || !item.aiFill || !item.aiFill.values) return 0
		return $scope.getFieldsForFile(item).filter(function (field) { return $scope.isAiFilledField(item, field) }).length
	}

	function base64ToBlob(base64, type) {
		let bin = atob(base64)
		let bytes = new Uint8Array(bin.length)
		for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i)
		return new Blob([bytes], { type: type })
	}

	// A PDF / Word file added as Photos: the server finds the photos in it (collages are split into their photos).
	// They replace the file in the list - one PHOTO each, with any caption text as a suggested note - so each gets
	// its own location and notes (in the wizard when there are two or more). The original file is stored when the
	// first of them uploads, and each photo records it in meta_json.source_file. With no photos found the file
	// stays, and uploads as one file the way it always has.
	async function findPhotosInQueueItem(item, ext) {
		item.preparingText = 'Finding photos…'
		safeApply($scope)
		let photos = []
		let problem = null
		try {
			let resp = await systemService.functionCall({
				type: 'extractPortalPhotos',
				params: getActiveParams(),
				file: item.rawFile,
				portalFile: { name: item.name, detectedExt: item.detectedExt }
			})
			let payload = resp && resp.data ? resp.data : null
			if (payload && payload.success !== false && payload.data) {
				photos = Array.isArray(payload.data.photos) ? payload.data.photos : []
			} else {
				problem = (payload && payload.error) ? String(payload.error) : 'The photos in this file could not be read.'
			}
		} catch (e) {
			problem = 'The photos in this file could not be read.'
		}
		if (!isQueueItemStillListed(item)) return
		item.preparingText = null

		if (!photos.length) {
			let preview = makePreview(item.rawFile, ext.toUpperCase())
			item.previewKind = preview.kind
			item.previewUrl = preview.url
			item.previewLabel = preview.label
			item.convertNote = problem
				? `${problem} It will be uploaded as one file.`
				: 'No separate photos were found in this file, so it will be uploaded as one file.'
			item.status = 'draft'
			safeApply($scope)
			analyzeQueueItem(item)
			return
		}

		let room = UPLOAD_QUEUE_MAX - ($scope.uploadQueue.length - 1)
		let used = photos.slice(0, Math.max(0, room))
		let baseName = replaceFilenameExt(item.name, '')
		let source = {
			id: 'src-' + item.id,
			name: item.name,
			file: item.rawFile,
			ext: ext,
			count: photos.length,
			stored: null,
			storing: null
		}
		if (used.length < photos.length) {
			$scope.uploadRejects = $scope.uploadRejects.concat([
				`${item.name}: only the first ${used.length} of its ${photos.length} photos were added (the upload list holds ${UPLOAD_QUEUE_MAX} files).`
			])
		}
		let newItems = used.map(function (p, i) {
			let fileName = `${baseName} - photo ${i + 1}.jpg`
			let file = new File([base64ToBlob(p.data, 'image/jpeg')], fileName, { type: 'image/jpeg', lastModified: Date.now() })
			let photo = {
				id: `${Date.now()}-${i}-${Math.random().toString(16).slice(2)}`,
				rawFile: file,
				originalName: fileName,
				originalSize: file.size,
				name: fileName,
				size: file.size,
				sizeLabel: formatBytes(file.size),
				detectedExt: '.JPG',
				previewKind: 'file',
				previewUrl: null,
				previewLabel: 'JPG',
				selectedType: 'PHOTO',
				typeLabel: '',
				meta: p.note ? { photo_notes: String(p.note) } : {},
				status: 'preparing',
				progress: 0,
				error: null,
				cancelled: false,
				convertNote: null,
				source: source,
				sourceNumber: i + 1,
				// The photo as found in the file (its upload copy is made small; the AI reads this one)
				originalFile: file,
				originalExt: 'jpg'
			}
			setTypeLabel(photo)
			return photo
		})

		let at = $scope.uploadQueue.indexOf(item)
		$scope.uploadQueue = $scope.uploadQueue.slice(0, at).concat(newItems, $scope.uploadQueue.slice(at + 1))
		$scope.photoSources.push(source)
		wizardFocusId = newItems[0].id
		safeApply($scope)
		newItems.forEach(function (photo) { prepareQueueItem(photo, 'jpg') })
	}

	// Stores the original PDF / Word file once, the first time one of its photos uploads
	function ensurePhotoSourceStored(source) {
		if (source.stored) return Promise.resolve(source.stored)
		if (!source.storing) {
			source.storing = systemService.functionCall({
				type: 'savePortalSourceFile',
				params: getActiveParams(),
				file: source.file,
				portalFile: { name: source.name, detectedExt: '.' + source.ext.toUpperCase() }
			}).then(function (resp) {
				let payload = resp && resp.data ? resp.data : null
				if (!payload || payload.success === false || !payload.data) {
					throw new Error((payload && payload.error) ? String(payload.error) : 'The original file could not be saved.')
				}
				source.stored = payload.data
				return source.stored
			}).finally(function () {
				source.storing = null
			})
		}
		return source.storing
	}

	$scope.removeQueueItem = function (item) {
		if (!item || item.status === 'uploading' || item.status === 'processing') return
		cleanupPreview(item)
		$scope.uploadQueue = $scope.uploadQueue.filter(function (q) { return q !== item })
	}

	// Wizard: remove every file in it (not ones uploading / saving). When any of them has an answer, confirm first
	// with a table of those files and their answers: a column per question when they're all one type (photos: Location,
	// Issue existed on Jan 1, Notes), otherwise their type and their answers.
	function getRemovableWizardItems() {
		return $scope.wizardItems.filter(function (item) {
			return item && ($scope.isQueueItemEditable(item) || item.status === 'preparing')
		})
	}

	function isAnswerGiven(field, raw) {
		if (field.type === 'checkbox') return raw === true
		if (raw === null || raw === undefined) return false
		if (typeof raw === 'string') return raw.trim() !== ''
		return true
	}

	function formatAnswer(field, raw) {
		if (field.type === 'date' && raw instanceof Date) return isNaN(raw.getTime()) ? '' : raw.toLocaleDateString()
		return String(formatFieldValue(field, raw))
	}

	// One column per question of the type; a conditional question (showWhen, e.g. "Photo location (other)") is shown
	// with the question it depends on
	function getAnswerColumns(typeKey) {
		let cfg = $scope.allowedFileTypes ? $scope.allowedFileTypes[typeKey] : null
		let fields = cfg && Array.isArray(cfg.fields) ? cfg.fields : []
		return fields.filter(function (field) { return field && field.key && !field.showWhen }).map(function (field) {
			return {
				key: field.key,
				label: field.shortLabel || field.label,
				field: field,
				extras: fields.filter(function (f) { return f && f.showWhen && f.showWhen.key === field.key })
			}
		})
	}

	function getAnswerCells(item, columns) {
		let meta = (item && item.meta) || {}
		let answered = false
		let cells = columns.map(function (col) {
			let raw = meta[col.key]
			if (!isAnswerGiven(col.field, raw)) return ''
			answered = true
			let value = formatAnswer(col.field, raw)
			col.extras.forEach(function (extra) {
				if (!shouldShowField(item, extra) || !isAnswerGiven(extra, meta[extra.key])) return
				value += ' – ' + formatAnswer(extra, meta[extra.key])
			})
			return value
		})
		return answered ? cells : null
	}

	$scope.canRemoveAllWizard = function () {
		return $scope.wizardItems.length > 1 && getRemovableWizardItems().length > 0
	}

	// Always confirms, with a recap of every file being removed: its thumbnail, name and any answers given
	$scope.requestRemoveAllWizard = function () {
		let items = getRemovableWizardItems()
		if (!items.length) return
		let types = items.map(function (item) { return item.selectedType }).filter(function (t, i, all) { return all.indexOf(t) === i })
		let oneType = types.length === 1
		let columns = oneType ? getAnswerColumns(types[0]) : [{ key: 'type', label: 'Type' }, { key: 'answers', label: 'Answers' }]
		let answeredCount = 0
		let rows = items.map(function (item) {
			let cells
			let answers
			if (oneType) {
				answers = getAnswerCells(item, columns)
				cells = answers || columns.map(function () { return '' })
			} else {
				let typeColumns = getAnswerColumns(item.selectedType)
				answers = getAnswerCells(item, typeColumns)
				cells = [
					$scope.getTypeDisplayName(item.selectedType),
					answers ? typeColumns.map(function (col, i) { return answers[i] ? col.label + ': ' + answers[i] : null }).filter(Boolean).join('\n') : ''
				]
			}
			if (answers) answeredCount++
			return { item: item, number: $scope.wizardItems.indexOf(item) + 1, cells: cells, answered: !!answers }
		})
		$scope.removeAllWizard = {
			columns: columns,
			rows: rows,
			items: items,
			count: items.length,
			answeredCount: answeredCount,
			noun: $scope.getWizardNoun(true)
		}
		let modal = getRemoveAllWizardModal()
		if (modal) modal.show()
	}

	$scope.closeRemoveAllWizard = function () {
		let modal = getRemoveAllWizardModal()
		if (modal) modal.hide()
	}

	// Removes the files in the recap (any that started uploading meanwhile are left alone)
	$scope.confirmRemoveAllWizard = function () {
		$scope.closeRemoveAllWizard()
		let items = ($scope.removeAllWizard.items || []).filter(function (item) {
			return isQueueItemStillListed(item) && ($scope.isQueueItemEditable(item) || item.status === 'preparing')
		})
		removeQueueItems(items)
	}

	function removeQueueItems(items) {
		items.forEach(function (item) { cleanupPreview(item) })
		$scope.uploadQueue = $scope.uploadQueue.filter(function (q) { return items.indexOf(q) === -1 })
		$scope.queueWizard.index = 0
	}

	function getRemoveAllWizardModal() {
		try {
			let el = document.getElementById('epRemoveAllWizardModal')
			if (!el || !$window.bootstrap || !$window.bootstrap.Modal) return null
			if (!_removeAllWizardModal) _removeAllWizardModal = $window.bootstrap.Modal.getOrCreateInstance(el)
			return _removeAllWizardModal
		} catch (e) {
			return null
		}
	}

	// -- Photos in the upload list (two or more): "Edit in table mode" and "Fill in later" ----------------------------

	function getQueuePhotoItems() {
		return $scope.uploadQueue.filter(function (item) { return item && item.selectedType === 'PHOTO' })
	}
	$scope.getQueuePhotoItems = getQueuePhotoItems

	$scope.getQueuePhotoReadyCount = function () {
		return getQueuePhotoItems().filter(function (item) { return $scope.getQueueItemState(item) === 'ready' }).length
	}

	// The photo questions, for the table's columns
	function getPhotoField(key) {
		let cfg = $scope.allowedFileTypes ? $scope.allowedFileTypes.PHOTO : null
		return (cfg && Array.isArray(cfg.fields)) ? (cfg.fields.find(function (f) { return f && f.key === key }) || null) : null
	}
	$scope.photoTableFields = {
		location: getPhotoField('photo_location'),
		locationOther: getPhotoField('photo_location_other'),
		jan1: getPhotoField('issue_existed_jan1'),
		notes: getPhotoField('photo_notes')
	}

	$scope.isFieldShown = function (item, field) {
		return !!field && shouldShowField(item, field)
	}

	// Edit in table mode: every photo in the upload list as a row (location, Jan 1, notes, ready, remove), moved around
	// with the keyboard like a spreadsheet (epGridNav). The answers are the photos' own, so the wizard shows them too.
	let _photoTableModal = null
	$scope.openPhotoTable = function () {
		if (getQueuePhotoItems().length < 2) return
		let modal = getPhotoTableModal()
		if (modal) modal.show()
	}

	$scope.closePhotoTable = function () {
		let modal = getPhotoTableModal()
		if (modal) modal.hide()
	}

	$scope.uploadFromPhotoTable = function () {
		$scope.closePhotoTable()
		$scope.uploadAllReady()
	}

	function getPhotoTableModal() {
		try {
			let el = document.getElementById('epPhotoTableModal')
			if (!el || !$window.bootstrap || !$window.bootstrap.Modal) return null
			if (!_photoTableModal) _photoTableModal = $window.bootstrap.Modal.getOrCreateInstance(el)
			return _photoTableModal
		} catch (e) {
			return null
		}
	}

	// Fill in later: each photo still missing its location gets "Fill in Later", and each with "This issue existed on
	// January 1st" unticked gets it ticked, so they can be uploaded now. Answers already given are kept. Undo puts back
	// what each photo had (photoFillLater.changes).
	$scope.photoFillLater = null

	function getPhotoFillLaterChanges() {
		return getQueuePhotoItems().filter(function (item) {
			if (!$scope.isQueueItemEditable(item)) return false
			let meta = item.meta || {}
			return isBlankMetaValue(meta.photo_location) || meta.issue_existed_jan1 !== true
		})
	}

	$scope.canFillPhotosLater = function () {
		return getPhotoFillLaterChanges().length > 0
	}

	$scope.fillPhotosLater = function () {
		let items = getPhotoFillLaterChanges()
		if (!items.length) return
		let changes = items.map(function (item) {
			item.meta = item.meta || {}
			let before = { photo_location: item.meta.photo_location, issue_existed_jan1: item.meta.issue_existed_jan1 }
			if (isBlankMetaValue(item.meta.photo_location)) item.meta.photo_location = 'fill_in_later'
			item.meta.issue_existed_jan1 = true
			return { item: item, before: before }
		})
		$scope.photoFillLater = {
			count: changes.length,
			locations: changes.filter(function (c) { return isBlankMetaValue(c.before.photo_location) }).length,
			changes: changes
		}
	}

	// Puts back an answer only where it's still the one filled in (one changed since is kept)
	$scope.undoFillPhotosLater = function () {
		let state = $scope.photoFillLater
		if (!state) return
		state.changes.forEach(function (c) {
			let item = c.item
			if (!isQueueItemStillListed(item) || !$scope.isQueueItemEditable(item)) return
			if (item.meta.photo_location === 'fill_in_later' && isBlankMetaValue(c.before.photo_location)) item.meta.photo_location = c.before.photo_location
			if (item.meta.issue_existed_jan1 === true && c.before.issue_existed_jan1 !== true) item.meta.issue_existed_jan1 = c.before.issue_existed_jan1
		})
		$scope.photoFillLater = null
	}

	$scope.dismissFillPhotosLater = function () {
		$scope.photoFillLater = null
	}

	$scope.cancelQueueItem = function (item) {
		if (!item || item.status !== 'uploading' || !item._upload) return
		item._upload.cancel()
	}

	$scope.retryQueueItem = function (item) {
		if (!item || uploadQueueRunning) return
		runUploadQueue([item])
	}

	$scope.uploadAllReady = function () {
		if (uploadQueueRunning) return
		runUploadQueue($scope.uploadQueue.filter(isQueueItemReady))
	}

	async function runUploadQueue(items) {
		if (uploadQueueRunning || !items || !items.length) return
		uploadQueueRunning = true
		$scope.uploadDoneMessage = null
		$scope.uploadRejects = []
		safeApply($scope)

		let uploaded = 0
		let failed = 0
		try {
			for (let i = 0; i < items.length; i++) {
				let item = items[i]
				// Skip files removed, or changed so they still need answers, while earlier files uploaded
				if (!isQueueItemStillListed(item)) continue
				if (!isQueueItemReady(item)) {
					if ($scope.isQueueItemEditable(item)) item.error = 'Answer the questions for this file, then click Upload.'
					continue
				}
				let ok = await uploadQueueItem(item)
				if (ok) uploaded++
				else if (!item.cancelled) failed++
			}
		} finally {
			uploadQueueRunning = false
		}

		if (uploaded) {
			let msg = `${uploaded} file${uploaded === 1 ? '' : 's'} uploaded.`
			if (failed) msg += ` ${failed} could not be uploaded; see the message on ${failed === 1 ? 'that file' : 'each file'}.`
			$scope.uploadDoneMessage = msg
			notifyReviewToolPortalChanged('file-create')
		}
		safeApply($scope)
	}

	// Uploads one file; resolves true when saved. The file can be cancelled while its bytes are being sent. Once
	// they have all arrived the server is saving it, so Cancel goes away rather than leave the outcome unknown.
	async function uploadQueueItem(item) {
		// Show the photo being uploaded in the wizard
		let wizardIndex = $scope.wizardItems.indexOf(item)
		if (wizardIndex > -1) $scope.queueWizard.index = wizardIndex
		item.status = 'uploading'
		item.progress = 0
		item.error = null
		item.cancelled = false
		safeApply($scope)

		let meta = angular.copy(item.meta || {})
		// A photo taken from a PDF / Word file links to the stored original
		if (item.source) {
			try {
				let stored = await ensurePhotoSourceStored(item.source)
				meta.source_file = {
					name: item.source.name,
					kind: item.source.ext,
					gcs_path: stored.gcs_path,
					gcs_url: stored.gcs_url,
					photo_number: item.sourceNumber,
					photo_count: item.source.count
				}
			} catch (e) {
				item.status = 'failed'
				item.progress = 0
				item.error = `${(e && e.message) ? e.message : 'The original file could not be saved.'} Please try again.`
				safeApply($scope)
				return false
			}
		}

		let req = {
			type: 'savePortalFileAndInfo',
			params: getActiveParams(),
			file: item.rawFile,
			portalFile: {
				client_id: item.id,
				server_id: null,
				name: item.name,
				size: item.size,
				detectedExt: item.detectedExt,
				selectedType: item.selectedType,
				meta: meta
			}
		}

		let resp = null
		try {
			item._upload = systemService.uploadWithProgress(req, function (loaded, total) {
				if (item.status !== 'uploading') return
				item.progress = total ? Math.min(100, Math.round((loaded / total) * 100)) : 0
				if (total && loaded >= total) item.status = 'processing'
				safeApply($scope)
			})
			resp = await item._upload.promise
		} catch (e) {
			resp = { httpError: e }
		}
		item._upload = null

		if (resp && resp.cancelled) {
			item.status = 'failed'
			item.cancelled = true
			item.progress = 0
			safeApply($scope)
			return false
		}

		let payload = resp && resp.data ? resp.data : null
		if (!payload || payload.success === false) {
			item.status = 'failed'
			item.progress = 0
			if (payload && payload.error) {
				item.error = String(payload.error)
			} else if (resp && resp.httpError && resp.httpError.status === 413) {
				item.error = 'This file is larger than the 25 MB limit.'
			} else if (resp && resp.httpError && resp.httpError.status > 0) {
				item.error = `The upload failed (error ${resp.httpError.status}). Please try again.`
			} else {
				item.error = 'The upload failed. Check your internet connection and try again.'
			}
			safeApply($scope)
			return false
		}

		// (the source holds the original file; it isn't part of the saved row)
		let source = item.source
		item.source = null
		let saved = angular.copy(item)
		item.source = source
		;['rawFile', '_upload', 'status', 'progress', 'error', 'cancelled', 'convertNote', 'originalName', 'originalSize', 'source', 'sourceNumber', 'preparingText', 'aiFill', 'typeChange', 'aiTypeChecked', 'originalFile', 'originalExt'].forEach(function (k) {
			delete saved[k]
		})
		saved.meta = meta
		let serverData = payload.data || null
		if (serverData && serverData.id) saved.server_id = serverData.id
		// The server may have converted it (a picture or Word file saved as a PDF)
		if (serverData && serverData.original_name) saved.name = String(serverData.original_name)
		if (serverData && Number(serverData.size_bytes) > 0) {
			saved.size = Number(serverData.size_bytes)
			saved.sizeLabel = formatBytes(saved.size)
		}
		let usesServerUrl = applyServerUrlToFile(saved, serverData)
		if (usesServerUrl) cleanupPreview(item)
		saved.savedAt = new Date()
		saved._isEditing = false
		setTypeLabel(saved)
		try {
			saved.dateAmountParts = computeDateAmountParts(saved)
		} catch (e) {
			saved.dateAmountParts = []
		}
		markUploadedFileJustAdded(saved)
		$scope.uploadedFiles.unshift(saved)
		$scope.uploadQueue = $scope.uploadQueue.filter(function (q) { return q !== item })
		safeApply($scope)
		return true
	}

	// Points the file's preview at its stored copy (no refresh needed). Returns true when it did.
	function applyServerUrlToFile(file, serverData) {
		if (!file || !serverData || !serverData.gcs_url) return false
		let url = String(serverData.gcs_url)
		let u = url.toLowerCase()
		file.gcs_url = url
		if (serverData.gcs_path) file.gcs_path = serverData.gcs_path
		if (u.endsWith('.pdf')) {
			file.previewKind = 'pdf'
			file.previewUrl = url
			file.previewLabel = 'PDF'
			file.detectedExt = '.PDF'
			return true
		}
		if (u.endsWith('.jpg') || u.endsWith('.jpeg') || u.endsWith('.png')) {
			file.previewKind = 'image'
			file.previewUrl = url
			file.previewLabel = null
			return true
		}
		return false
	}

	$scope.savePending = async function () {
		if (!$scope.pendingFile) return
		if ($scope.pendingFile._saving) return
		$scope.pendingFile._saving = true
		safeApply($scope)

		// Backup: ensure HEIC/PNG are converted to an upright JPG before upload.
		try {
			if ($scope.pendingFile && $scope.pendingFile.rawFile) {
				let ext = String($scope.pendingFile.detectedExt || '').replace('.', '').toUpperCase()
				if (ext === 'HEIC' || ext === 'PNG') {
					$scope.pendingMessage = { type: 'ok', text: 'Processing image…' }
					safeApply($scope)
					let res = await normalizeImageUploadToJpeg($scope.pendingFile.rawFile, ext)
					if (res && res.file) {
						cleanupPreview($scope.pendingFile)
						$scope.pendingFile.rawFile = res.file
						$scope.pendingFile.name = res.file.name
						$scope.pendingFile.size = res.file.size
						$scope.pendingFile.sizeLabel = formatBytes(res.file.size)
						$scope.pendingFile.detectedExt = '.JPG'
						$scope.pendingFile.previewKind = 'image'
						$scope.pendingFile.previewUrl = URL.createObjectURL(res.file)
						$scope.pendingFile.previewLabel = null
						safeApply($scope)
					}
				}
			}
		} catch (e) {
			try { console.error('Image conversion failed:', e) } catch (e2) { }
			let msg = ''
			try {
				if (typeof e === 'string') msg = e
				else if (e && typeof e.message === 'string' && e.message) msg = e.message
				else if (e && typeof e.type === 'string' && e.type) msg = e.type
				else if (e && typeof e.toString === 'function') msg = String(e.toString())
			} catch (e3) { }
			msg = String(msg || '').trim()
			$scope.pendingMessage = {
				type: 'warn',
				text: msg ? `Unable to convert image to JPG. ${msg}` : 'Unable to convert image to JPG. Please try again.'
			}
			if ($scope.pendingFile) $scope.pendingFile._saving = false
			safeApply($scope)
			return
		}

		if (!$scope.pendingFile.selectedType || !$scope.allowedFileTypes[$scope.pendingFile.selectedType]) {
			$scope.pendingMessage = {
				type: 'warn',
				text: 'Please select a file content type.'
			}
			if ($scope.pendingFile) $scope.pendingFile._saving = false
			safeApply($scope)
			return
		}
		let missing = getMissingRequiredFields($scope.pendingFile)
		if (missing.length) {
			$scope.pendingMessage = {
				type: 'warn',
				text: `Please complete required fields: ${missing.join(', ')}`
			}
			if ($scope.pendingFile) $scope.pendingFile._saving = false
			safeApply($scope)
			return
		}

		console.log('SAVE pendingFile payload:', {
			id: $scope.pendingFile.id,
			name: $scope.pendingFile.name,
			detectedExt: $scope.pendingFile.detectedExt,
			selectedType: $scope.pendingFile.selectedType,
			meta: angular.copy($scope.pendingFile.meta || {})
		})

		let req = {
			type: 'savePortalFileAndInfo',
			params: getActiveParams(),
			file: $scope.pendingFile.rawFile || null,
			portalFile: {
				client_id: $scope.pendingFile.id,
				server_id: $scope.pendingFile.server_id || null,
				name: $scope.pendingFile.name,
				size: $scope.pendingFile.size,
				detectedExt: $scope.pendingFile.detectedExt,
				selectedType: $scope.pendingFile.selectedType,
				meta: angular.copy($scope.pendingFile.meta || {})
			}
		}

		let info = await systemService.functionCall(req)
		if (!info || !info.data || info.data.success === false) {
			$scope.pendingMessage = {
				type: 'warn',
				text: (info && info.data && info.data.error)
					? String(info.data.error)
					: 'Save failed. Please try again.'
			}
			if ($scope.pendingFile) $scope.pendingFile._saving = false
			safeApply($scope)
			return
		}

		// Persist server identifiers/URLs (if returned) onto the saved object.
		let serverData = (info && info.data && info.data.data) ? info.data.data : null
		if (serverData && serverData.id) {
			$scope.pendingFile.server_id = serverData.id
		}
		// Use the server URL for thumbnails immediately (no refresh needed)
		applyServerUrlToFile($scope.pendingFile, serverData)

		let saved = angular.copy($scope.pendingFile)
		let wasEditing = !!saved._editing
		let editIdx = saved._editOriginalIndex
		let editTargetId = saved._editTargetId
		delete saved._saving
		delete saved._processingPreview
		delete saved._editing
		delete saved._editOriginalIndex
		delete saved._editTargetId
		delete saved._editOriginalFile
		delete saved.rawFile
		saved.savedAt = new Date()
		saved._isEditing = false
		setTypeLabel(saved)
		try {
			saved.dateAmountParts = computeDateAmountParts(saved)
		} catch (e) {
			saved.dateAmountParts = []
		}
		if (wasEditing) {
			clearUploadedFileJustAdded(saved)
			// Update the existing list row in-place (keep it visible, remove highlight).
			let idx = -1
			try {
				idx = $scope.uploadedFiles.findIndex(f => f && f.id === editTargetId)
			} catch (e) { idx = -1 }
			if (idx < 0 && typeof editIdx === 'number') idx = editIdx
			if (idx >= 0 && $scope.uploadedFiles[idx]) {
				$scope.uploadedFiles[idx] = saved
			} else {
				$scope.uploadedFiles.unshift(saved)
			}
		} else {
			markUploadedFileJustAdded(saved)
			$scope.uploadedFiles.unshift(saved)
		}
		notifyReviewToolPortalChanged(wasEditing ? 'file-update' : 'file-create')
		try { if ($scope.pendingFile) $scope.pendingFile._saving = false } catch (e) { }
		$scope.pendingFile = null
		$scope.pendingMessage = {
			type: 'ok',
			text: 'Saved.'
		}
		// Keep the success message visible in the upload area only briefly if desired.
		// For now, it will show until next action.
		safeApply($scope)
	}

	$scope.canSavePending = function (file) {
		if (!file) return false
		if (file._saving) return false
		if (!file.selectedType || !$scope.allowedFileTypes[file.selectedType]) return false
		return getMissingRequiredFields(file).length === 0
	}

	$scope.onFileTypeChanged = function (file) {
		if (!file) return
		file.meta = file.meta || {}
		setTypeLabel(file)
		if (file === $scope.pendingFile && file.selectedType === 'PHOTO' && !file.meta.photo_location) {
			focusPendingPhotoLocationField()
		}
	}

	function getFileExtForContentTypeMatching(file) {
		try {
			if (!file) return ''
			let raw = ''
			if (file.detectedExt) raw = String(file.detectedExt)
			else if (file.name) {
				let e = getFileExt(String(file.name))
				raw = e ? `.${e}` : ''
			}
			raw = String(raw || '').trim()
			if (!raw) return ''
			return raw.replace('.', '').toLowerCase()
		} catch (e) {
			return ''
		}
	}

	// A saved photo can't become a document here: documents are stored as PDFs, and the server only converts a picture
	// when it is uploaded. (The server refuses the change too.)
	function isSavedPhotoToDocumentChange(file, typeKey) {
		let original = file && file._editing ? file._editOriginalFile : null
		if (!original || !isPhotoTypeKey(original.selectedType) || isPhotoTypeKey(typeKey)) return false
		return PHOTO_IMAGE_EXTS.indexOf(getFileExtForContentTypeMatching(file)) !== -1
	}

	$scope.isContentTypeDisabledForFile = function (file, typeKey) {
		try {
			if (!file || !typeKey || !$scope.allowedFileTypes) return false
			let cfg = $scope.allowedFileTypes[typeKey]
			if (!cfg || !Array.isArray(cfg.allowedFileTypes) || cfg.allowedFileTypes.length === 0) return false
			let ext = getFileExtForContentTypeMatching(file)
			if (!ext) return false
			if (isSavedPhotoToDocumentChange(file, typeKey)) return true
			return cfg.allowedFileTypes.indexOf(ext) === -1
		} catch (e) {
			return false
		}
	}

	$scope.getContentTypeDisabledReason = function (file, typeKey) {
		if (isSavedPhotoToDocumentChange(file, typeKey)) return '(To use this photo as a document, remove it and upload it again as a document)'
		return `(Allowed File Type(s): ${$scope.getAllowedExtLabelForType(typeKey)})`
	}

	$scope.getAllowedExtLabelForType = function (typeKey) {
		try {
			if (!typeKey || !$scope.allowedFileTypes) return ''
			let cfg = $scope.allowedFileTypes[typeKey]
			if (!cfg || !Array.isArray(cfg.allowedFileTypes)) return ''
			return cfg.allowedFileTypes
				.map(function (x) { return String(x || '').trim().toLowerCase() })
				.filter(Boolean)
				.join(', ')
		} catch (e) {
			return ''
		}
	}

	$scope.onPickFileContentType = function (file, typeKey, $event) {
		try {
			if ($event) {
				// Prevent selecting disabled options.
				if ($scope.isContentTypeDisabledForFile(file, typeKey)) {
					$event.preventDefault()
					$event.stopPropagation()
					return
				}
			}
			if (!file) return
			file.selectedType = typeKey
			$scope.onFileTypeChanged(file)
		} catch (e) {
			// ignore
		}
	}

	$scope.isFileTypeMissing = function (file) {
		return !!(file && !file.selectedType)
	}

	$scope.isFieldMissing = function (file, field) {
		if (!file || !field) return false
		if (field.required === false) return false

		let val = (file.meta || {})[field.key]

		if (field.type === 'checkbox') {
			let mode = field.requiredMode || 'checked'
			if (mode === 'answered') return (typeof val !== 'boolean')
			return (val !== true)
		}

		// For other field types, treat empty string/null/undefined as missing.
		if (val === null || val === undefined) return true
		if (typeof val === 'string') return val.trim() === ''
		return false
	}

	$scope.getFieldsForFile = function (file) {
		if (!file || !file.selectedType) return []
		let cfg = $scope.allowedFileTypes[file.selectedType]
		if (!cfg || !cfg.fields) return []
		// Normalize conditional fields in-place to keep stable identities.
		for (let i = 0; i < cfg.fields.length; i++) {
			let f = cfg.fields[i]
			if (f && f.showWhen && f.type === 'text') {
				f.maxLength = 40
			}
		}
		return cfg.fields.filter(field => shouldShowField(file, field))
	}

	function shouldShowField(file, field) {
		if (!field || !field.showWhen) return true
		let meta = (file && file.meta) ? file.meta : {}
		let rule = field.showWhen
		let actual = meta[rule.key]
		if (rule.equals !== undefined) return actual === rule.equals
		if (Array.isArray(rule.in)) return rule.in.indexOf(actual) !== -1
		return true
	}

	// The required fields (shown for this file) still unanswered; isFieldMissing has the rules (required unless
	// required: false; checkboxes by requiredMode)
	function getMissingRequiredFieldDefs(file) {
		return $scope.getFieldsForFile(file).filter(function (field) { return $scope.isFieldMissing(file, field) })
	}

	function getMissingRequiredFields(file) {
		return getMissingRequiredFieldDefs(file).map(function (field) { return field.label })
	}

	function getFileExt(filename) {
		if (!filename || typeof filename !== 'string') return null
		let parts = filename.split('.')
		if (parts.length < 2) return null
		let ext = parts[parts.length - 1].toUpperCase()
		return ext
	}

	function focusPendingPhotoLocationField() {
		try {
			$window.setTimeout(function () {
				try {
					let el = document.getElementById('epPendingPhotoLocationSelect')
					if (!el) return
					if (typeof el.focus === 'function') el.focus()
					if (typeof el.showPicker === 'function') {
						el.showPicker()
						return
					}
					if (typeof el.click === 'function') el.click()
				} catch (e) { }
			}, 0)
		} catch (e) { }
	}

	function makePreview(file, ext) {
		let safeExt = (ext || '').toUpperCase()
		// Only generate object URLs for formats we can reliably render as an <img> without processing.
		if (safeExt === 'PNG' || safeExt === 'JPG' || safeExt === 'JPEG') {
			try {
				return { kind: 'image', url: URL.createObjectURL(file), label: null }
			} catch (e) {
				return { kind: 'file', url: null, label: safeExt || 'FILE' }
			}
		}
		if (safeExt === 'PDF') {
			try {
				return { kind: 'pdf', url: URL.createObjectURL(file), label: 'PDF' }
			} catch (e) {
				return { kind: 'pdf', url: null, label: 'PDF' }
			}
		}
		// HEIC needs conversion before it can be previewed.
		if (safeExt === 'HEIC') return { kind: 'file', url: null, label: 'HEIC' }
		return { kind: 'file', url: null, label: safeExt || 'FILE' }
	}

	function replaceExtWithJpg(filename) {
		if (!filename || typeof filename !== 'string') return 'upload.jpg'
		let base = filename
		let idx = filename.lastIndexOf('.')
		if (idx > 0) base = filename.slice(0, idx)
		return `${base}.jpg`
	}

	async function blobToOrientedCanvas(blob) {
		// Try createImageBitmap with EXIF orientation support (Chrome/Edge).
		if (window.createImageBitmap) {
			try {
				let bmp = await createImageBitmap(blob, { imageOrientation: 'from-image' })
				let canvas = document.createElement('canvas')
				canvas.width = bmp.width
				canvas.height = bmp.height
				let ctx = canvas.getContext('2d')
				ctx.fillStyle = '#ffffff'
				ctx.fillRect(0, 0, canvas.width, canvas.height)
				ctx.drawImage(bmp, 0, 0)
				try { bmp.close && bmp.close() } catch (e) { }
				return canvas
			} catch (e) {
				// Fall through to <img> loader below
			}
		}

		// Fallback: decode via <img>. Many browsers display with correct orientation;
		// this path may be less reliable for EXIF-rotated JPEGs on older engines.
		let url = URL.createObjectURL(blob)
		try {
			let img = await new Promise((resolve, reject) => {
				let i = new Image()
				i.onload = () => resolve(i)
				i.onerror = reject
				i.src = url
			})
			let canvas = document.createElement('canvas')
			canvas.width = img.naturalWidth || img.width
			canvas.height = img.naturalHeight || img.height
			let ctx = canvas.getContext('2d')
			ctx.fillStyle = '#ffffff'
			ctx.fillRect(0, 0, canvas.width, canvas.height)
			ctx.drawImage(img, 0, 0)
			return canvas
		} finally {
			try { URL.revokeObjectURL(url) } catch (e) { }
		}
	}

	async function canvasToJpegBlob(canvas, quality) {
		let q = (typeof quality === 'number') ? quality : 0.9
		if (canvas && typeof canvas.toBlob === 'function') {
			return await new Promise((resolve) => {
				canvas.toBlob(function (b) { resolve(b) }, 'image/jpeg', q)
			})
		}
		// Fallback for older engines
		let dataUrl = canvas.toDataURL('image/jpeg', q)
		let res = await fetch(dataUrl)
		return await res.blob()
	}

	function coerceToJpegBlob(maybe, fallbackType) {
		if (!maybe) return null
		// Blob/File
		if (maybe instanceof Blob) {
			let t = maybe.type || ''
			if (t && t.toLowerCase() === 'image/jpeg') return maybe
			return new Blob([maybe], { type: 'image/jpeg' })
		}
		// ArrayBuffer
		if (maybe instanceof ArrayBuffer) {
			return new Blob([maybe], { type: fallbackType || 'image/jpeg' })
		}
		// Typed arrays
		if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView && ArrayBuffer.isView(maybe)) {
			return new Blob([maybe.buffer], { type: fallbackType || 'image/jpeg' })
		}
		return null
	}

	async function ensureHeic2anyLoaded() {
		if (window.heic2any) return true
		// Try to load from node_modules (server exposes node_modules as static)
		return await new Promise((resolve) => {
			try {
				let existing = document.querySelector('script[data-heic2any="1"]')
				if (existing) {
					existing.addEventListener('load', function () { resolve(!!window.heic2any) })
					existing.addEventListener('error', function () { resolve(false) })
					return
				}
				let s = document.createElement('script')
				s.src = '/heic2any/dist/heic2any.min.js'
				s.async = true
				s.setAttribute('data-heic2any', '1')
				s.onload = function () { resolve(!!window.heic2any) }
				s.onerror = function () { resolve(false) }
				document.head.appendChild(s)
			} catch (e) {
				resolve(false)
			}
		})
	}

	async function normalizeImageUploadToJpeg(file, ext) {
		let safeExt = String(ext || '').toUpperCase()
		let inputBlob = file

		if (safeExt === 'HEIC') {
			// Some uploads are mislabeled by extension (ex: .heic filename but blob is image/png).
			// If the browser already knows the MIME type and it's readable, skip heic2any.
			let t = ''
			try { t = (file && file.type) ? String(file.type).toLowerCase() : '' } catch (e) { t = '' }
			let alreadyReadable = (t === 'image/png' || t === 'image/jpeg' || t === 'image/jpg' || t === 'image/webp')
			let looksHeic = (t === 'image/heic' || t === 'image/heif' || t === 'image/heic-sequence' || t === 'image/heif-sequence' || !t)

			if (!alreadyReadable && looksHeic) {
				let ok = await ensureHeic2anyLoaded()
				if (!ok || !window.heic2any) throw new Error('Missing heic2any library')
				try {
					let out = await window.heic2any({
						blob: file,
						toType: 'image/jpeg',
						quality: 0.9
					})
					// heic2any may return a Blob or an array of Blobs
					if (Array.isArray(out)) out = out[0]
					let coerced = coerceToJpegBlob(out, 'image/jpeg')
					if (!coerced) throw new Error('HEIC conversion returned an unsupported format')
					inputBlob = coerced
				} catch (err) {
					// heic2any throws ERR_USER when the blob is already readable
					let msg = ''
					try { msg = (err && err.message) ? String(err.message) : '' } catch (e) { msg = '' }
					msg = msg.toLowerCase()
					if (msg.includes('already browser readable') || msg.includes('err_user')) {
						inputBlob = file
					} else {
						throw err
					}
				}
			} else {
				// Extension says HEIC but browser says it's already readable.
				inputBlob = file
			}
		}

		// For PNG/JPG/JPEG/HEIC-derived-JPG: draw to canvas (respecting orientation),
		// optionally resize, then export as JPEG.
		let canvas = await blobToOrientedCanvas(inputBlob)
		canvas = resizeCanvasToWidth(canvas, UPLOAD_IMAGE_TARGET_WIDTH_PX, UPLOAD_IMAGE_RESIZE_UPSCALE)
		let jpegBlob = await canvasToJpegBlob(canvas, 0.9)
		if (!jpegBlob) throw new Error('Unable to create JPEG')

		let newName = replaceExtWithJpg(file && file.name ? file.name : 'upload')
		let newFile = new File([jpegBlob], newName, { type: 'image/jpeg', lastModified: Date.now() })
		return { file: newFile }
	}

	function cleanupPreview(file) {
		if (!file) return
		if (file.previewUrl && typeof file.previewUrl === 'string') {
			try {
				URL.revokeObjectURL(file.previewUrl)
			} catch (e) {
				// ignore
			}
		}
		file.previewUrl = null
	}

	function formatBytes(bytes) {
		if (!bytes && bytes !== 0) return ''
		const units = ['B', 'KB', 'MB', 'GB']
		let idx = 0
		let val = bytes
		while (val >= 1024 && idx < units.length - 1) {
			val /= 1024
			idx++
		}
		return `${val.toFixed(idx === 0 ? 0 : 1)} ${units[idx]}`
	}

	$scope.previewReport = function () {
		if ($scope.previewingReport) return
		let p = getActiveParams()
		if (!p || !p.user_id || !p.prop_id) return

		$scope.previewingReport = true
		safeApply($scope)

		let origin = ($window.location && $window.location.origin)
			? $window.location.origin
			: `${$window.location.protocol}//${$window.location.host}`

		let propId = encodeURIComponent(String(p.prop_id))
		let userId = encodeURIComponent(String(p.user_id))
		let token = p.user_token ? encodeURIComponent(String(p.user_token)) : ''
		let taxYear = p.tax_year != null && String(p.tax_year).trim() ? encodeURIComponent(String(p.tax_year).trim()) : ''

		let url = token
			? `${origin}/report/${propId}/${userId}/${token}/preview`
			: `${origin}/report/${propId}/${userId}/preview`
		let queryParts = ['source=client_portal']
		if (taxYear) queryParts.push(`tax_year=${taxYear}`)
		if (queryParts.length) url += `?${queryParts.join('&')}`

		$window.open(url, '_blank')

		$window.setTimeout(function () {
			$scope.previewingReport = false
			safeApply($scope)
		}, 2000)
	}

	$scope.createPdf = async function () {
		if ($scope.creatingPdf) return
		let p = getActiveParams()
		if (!p || !p.user_id || !p.prop_id || !p.user_token) {
			$window.alert('Unable to create PDF: missing user/session info.')
			return
		}

		try {
			$scope.creatingPdf = true
			safeApply($scope)

			let resp = await $http.post('/report/createPdf', {
				user_id: p.user_id,
				user_token: p.user_token,
				prop_id: p.prop_id,
				tax_year: p.tax_year
			})

			let data = resp && resp.data ? resp.data : null
			if (!data || data.success === false) {
				let msg = (data && data.error) ? data.error : 'Unable to create PDF.'
				throw new Error(msg)
			}

			let out = data.data || {}
			let url = out.signedUrl || out.url
			if (url) {
				$window.open(url, '_blank')
			} else {
				$window.alert('PDF created and uploaded, but no URL was returned.')
			}
		} catch (e) {
			console.log('createPdf error:', e)
			$window.alert((e && e.message) ? e.message : 'Unable to create PDF.')
		} finally {
			$scope.creatingPdf = false
			safeApply($scope)
		}
	}

	function doRouteTo(route) {
		let p = getActiveParams()
		let path = `/${p.user_id}/${p.user_token}/${p.prop_id}`
		switch (route) {
			case 'dashboard':
				path = `https://dashboard.propertytax.io/${p.user_id}/${p.user_token}/${p.prop_id}`
				$window.location = path
				return		// Bypass the $location.path() below
				break
		}
		$location.path(path)
	}

	$scope.routeTo = function (route) {
		if (route === 'dashboard' && isEditingActive()) {
			showEditLock('Go to Dashboard', function () { showPortalExitSummary('dashboard') })
			return
		}
		if (route === 'dashboard') {
			showPortalExitSummary('dashboard')
			return
		}
		doRouteTo(route)
	}

	$scope.$on('$destroy', function () {
		try {
			if (reviewPortalBroadcast && typeof reviewPortalBroadcast.close === 'function') reviewPortalBroadcast.close()
		} catch (e) { }
		try {
			if (_portalExitTabCloseTimer) $window.clearTimeout(_portalExitTabCloseTimer)
		} catch (e) { }
		_portalExitTabCloseTimer = null
		try {
			if (_portalExitBeforeUnloadHandler) $window.removeEventListener('beforeunload', _portalExitBeforeUnloadHandler)
		} catch (e) { }
		_portalExitBeforeUnloadHandler = null
		reviewPortalBroadcast = null
	})

})